<template>
  <div class="coordinate-display-card">
    <b-row>
      <!-- <b-col
        md="6"
        sm="12"
      >
        <b-table
          :items="filteredCoordinates"
          :fields="coordinateFields"
          small
          striped
          responsive
          class="mb-0"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(latitude)="data">
            <code>{{ data.item.latitude }}</code>
          </template>
          <template #cell(longitude)="data">
            <code>{{ data.item.longitude }}</code>
          </template>
          
          <template #cell(utm_east)="data">
            <code>{{ data.item.utm_east != null ? Number(data.item.utm_east).toFixed(3) : '-' }}</code>
          </template>
          <template #cell(utm_north)="data">
            <code>{{ data.item.utm_north != null ? Number(data.item.utm_north).toFixed(3) : '-' }}</code>
          </template>
          <template #cell(coordinate_system)="data">
            <b-badge
              variant="outline-info"
              class="small"
            >
              {{ data.item.coordinate_system }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="viewCoordinateOnMap(data.item)"
            >
              View Map
            </b-button>
          </template>
        </b-table>
        <div>
        </div>
          
          
          <b-collapse
            id="sketch-collapse"
            v-model="showSketch"
          >
          <div class="sketch-container">

            <b-row>
              <b-col md="4">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  :disabled="!surveySiteCoordinateSketch"
                  @click="downloadSketchPng"
                >
                  تنزيل الرسم
                </b-button>
              </b-col>
              <b-col md="8">
                <div
              v-if="surveySiteCoordinateSketch"
              class="text-primary small font-weight-bold mb-1 site-sketch-from-coords"
            >
            
              <div
                ref="siteSketchWrap"
                class="coordinate-sketch-wrap"
              >
                <div class="compass-rose compass-top-left">
                  
                  <img src="../../public/CompassRose.png" alt="Compass Rose" class="compass-rose-image">
                </div>
                <svg
                  ref="siteSketchSvg"
                  class="site-polygon-sketch-svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <defs>
                    <pattern
                      :id="surveySketchPatternIds.grid"
                      width="0"
                      height="0"
                      patternUnits="userSpaceOnUse"
                    >
                      <path
                        d="M 5 0 L 0 0 0 5"
                        fill="none"
                        stroke="#0a3345"
                        stroke-width="0.08"
                        opacity="0.22"
                      />
                    </pattern>
                    <pattern
                      :id="surveySketchPatternIds.hatch"
                      width="2.2"
                      height="2.2"
                      patternUnits="userSpaceOnUse"
                      patternTransform="rotate(45)"
                    >
                      <path
                        d="M 0 0 L 0 2.2"
                        stroke="#0a3345"
                        stroke-width="0.35"
                        opacity="0.18"
                      />
                    </pattern>
                  </defs>
                  <rect
                    class="sketch-paper-bg"
                    x="0"
                    y="0"
                    width="100"
                    height="100"
                    fill="#faf8f4"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="100"
                    height="100"
                    :fill="'url(#' + surveySketchPatternIds.grid + ')'"
                  />
                  <polygon
                    :points="surveySiteCoordinateSketch.pointsStr"
                    :fill="'url(#' + surveySketchPatternIds.hatch + ')'"
                    stroke="#0a3345"
                    stroke-width="0.5"
                    stroke-linejoin="miter"
                    class="sketch-lot-fill"
                  />
                  <g class="sketch-dimensions">
                    <g
                      v-for="(seg, idx) in surveySiteCoordinateSketch.segments"
                      :key="'sk-len-' + idx"
                      :transform="'rotate(' + seg.angleDeg + ' ' + seg.lx + ' ' + seg.ly + ')'"
                    >
                      <line
                        :x1="seg.mx"
                        :y1="seg.my"
                        :x2="seg.lx"
                        :y2="seg.ly"
                        class="sketch-length-guide"
                      />
                      <text
                        :x="seg.lx"
                        :y="seg.ly"
                        class="sketch-edge-length"
                        text-anchor="middle"
                        dominant-baseline="middle"
                      >
                        {{ formatSketchEdgeLengthM(seg.lengthM) }}
                      </text>
                    </g>
                  </g>
                  <g class="sketch-vertices">
                    <g
                      v-for="v in surveySiteCoordinateSketch.vertices"
                      :key="'vtx-' + v.index"
                    >
                      <circle
                        :cx="v.cx"
                        :cy="v.cy"
                        :r="v.r"
                        class="sketch-vertex-dot"
                      />
                      <circle
                        :cx="v.cx"
                        :cy="v.cy"
                        :r="v.r + 0.55"
                        fill="none"
                        stroke="#0a3345"
                        stroke-width="0.35"
                      />
                      <text
                        :x="v.tx"
                        :y="v.ty"
                        class="sketch-vertex-index"
                        text-anchor="middle"
                        dominant-baseline="middle"
                      >
                        {{ toArabicIndicDigits(v.index) }}
                      </text>
                    </g>
                  </g>
                  <g
                    v-if="surveySiteCoordinateSketch.scaleBar"
                    class="sketch-scale-bar"
                  >
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x1"
                      :y1="surveySiteCoordinateSketch.scaleBar.y"
                      :x2="surveySiteCoordinateSketch.scaleBar.x2"
                      :y2="surveySiteCoordinateSketch.scaleBar.y"
                      stroke="#0a3345"
                      stroke-width="0.9"
                    />
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x1"
                      :y1="surveySiteCoordinateSketch.scaleBar.y - 1.2"
                      :x2="surveySiteCoordinateSketch.scaleBar.x1"
                      :y2="surveySiteCoordinateSketch.scaleBar.y + 1.2"
                      stroke="#0a3345"
                      stroke-width="0.55"
                    />
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x2"
                      :y1="surveySiteCoordinateSketch.scaleBar.y - 1.2"
                      :x2="surveySiteCoordinateSketch.scaleBar.x2"
                      :y2="surveySiteCoordinateSketch.scaleBar.y + 1.2"
                      stroke="#0a3345"
                      stroke-width="0.55"
                    />
                    <text
                      :x="(surveySiteCoordinateSketch.scaleBar.x1 + surveySiteCoordinateSketch.scaleBar.x2) / 2"
                      :y="surveySiteCoordinateSketch.scaleBar.y - 2.4"
                      class="sketch-scale-caption"
                      text-anchor="middle"
                      dominant-baseline="middle"
                    >
                      مقياس الرسم
                    </text>
                    <text
                      :x="(surveySiteCoordinateSketch.scaleBar.x1 + surveySiteCoordinateSketch.scaleBar.x2) / 2"
                      :y="surveySiteCoordinateSketch.scaleBar.y + 4.2"
                      class="sketch-scale-value"
                      text-anchor="middle"
                      dominant-baseline="middle"
                    >
                      {{ surveySiteCoordinateSketch.scaleBar.label }}
                    </text>
                  </g>
                </svg>
              </div>
              
            </div>
              </b-col>
            </b-row>
            </div>
          </b-collapse>
        
      </b-col> -->
      <b-col
        md="12"
        sm="12"
      >
        <p
          v-if="showNoCoordinatesHint"
          class="text-muted small mb-1"
        >
          {{ noCoordinatesMessage }}
        </p>
        <div
          v-if="showInlineMap && resolvedProjectId"
          class="geodesia-survey-import-panel w-100 mb-1"
        >
          <div v-if="hasPermission('Access GIS')" class="d-flex flex-wrap align-items-start geodesia-survey-import-actions">
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/TrimbleIcon.jpeg')"
                  alt="AutoCAD"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleGeodesiaSheetImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSheet"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSheet || previewingGeodesiaSheet || importingGeodesiaSurveyFile || !!previewingProjectSurveyFileType"
                  :title="geodesiaSheetPreviewActiveForSheet ? 'إخفاء نقاط geodesia sheet من الخريطة' : 'عرض نقاط geodesia sheet على الخريطة'"
                  @click="handleGeodesiaSheetPreviewToggle"
                >
                  <b-spinner
                    v-if="previewingGeodesiaSheet"
                    small
                  />
                  <feather-icon
                    v-else
                    :icon="geodesiaSheetPreviewActiveForSheet ? 'EyeOffIcon' : 'EyeIcon'"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/autoCadIcon.jpeg')"
                  alt="AutoCAD"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleDxfImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'dxf'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط DXF على الخريطة"
                  @click="handleDxfSurveyPreview"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'dxf'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/HTMLIcon.jpeg')"
                  alt="AutoCAD"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleHtmlImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'html'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط HTML على الخريطة"
                  @click="handleHtmlSurveyPreview"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'html'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/KMLIcon.jpeg')"
                  alt="AutoCAD"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleKmlImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kml'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط KML على الخريطة"
                  @click="handleKmlSurveyPreview"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'kml'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/kmz.png')"
                  alt="kmz"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleKmzImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kmz'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط KMZ على الخريطة"
                  @click="handleKmzSurveyPreview"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'kmz'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/SHPIcon.jpeg')"
                  alt="AutoCAD"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleShpImportClick"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'shp'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط SHP على الخريطة"
                  @click="handleShpSurveyPreview"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'shp'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/RawData.png')"
                  alt="raw data"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleGeodesiaImportClick('raw')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'raw'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط RAW على الخريطة"
                  @click="handleProjectSurveyFilePreview('raw')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'raw'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
            <div class="import-buttons-container">
              <div class="icon-container">
                <img
                  class="img"
                  :src="require('@/assets/images/icons/rw5.webp')"
                  alt="rw5"
                />
              </div>
              <div class="buttons-container">
                <b-button
                  variant="success"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                  @click="handleGeodesiaImportClick('rw5')"
                >
                  <b-spinner
                    v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'rw5'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="info"
                  size="sm"
                  class="btnSM"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط RW5 على الخريطة"
                  @click="handleProjectSurveyFilePreview('rw5')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'rw5'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="12"
                  />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  class="btnSM"
                >
                  <feather-icon
                      variant="warning"
                      icon="AlertCircleIcon"
                      size="12"
                    />
                </b-button>
              </div>
            </div>
          </div>
          <!-- <div style="display:none;" class=" d-flex flex-wrap align-items-start geodesia-survey-import-actions">
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSheet"
                @click="showGeodesiaSheetImportModal = true"
              >
                <feather-icon
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد Excel (Trimble)
              </b-button>
              <small
                v-if="hasGeodesiaSheet"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSheet || previewingGeodesiaSheet"
                  :title="geodesiaSheetPreviewActiveForSheet ? 'إخفاء نقاط geodesia sheet من الخريطة' : 'عرض نقاط geodesia sheet على الخريطة'"
                  @click="handleGeodesiaSheetPreviewToggle"
                >
                  <b-spinner
                    v-if="previewingGeodesiaSheet"
                    small
                  />
                  <feather-icon
                    v-else
                    :icon="geodesiaSheetPreviewActiveForSheet ? 'EyeOffIcon' : 'EyeIcon'"
                    size="18"
                  />
                </b-button>
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-kml-export-button p-0 ml-50"
                  :disabled="!canExportGeodesiaSheetKml || downloadingGeodesiaSheetKml || loadingGeodesiaSheetFileMeta || importingGeodesiaSheet || previewingGeodesiaSheet"
                  title="تصدير Geodesia Sheet كملف KML"
                  @click="downloadGeodesiaSheetKml"
                >
                  <b-spinner
                    v-if="downloadingGeodesiaSheetKml"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="DownloadIcon"
                    size="18"
                  />
                </b-button>
              </small>
              <b-button
                v-if="geodesiaSheetPreviewActiveForSheet && geodesiaSheetPoints.length >= 3"
                variant="outline-primary"
                size="sm"
                class="geodesia-survey-import-button mt-50"
                :title="'اختر نقاط Geodesia Sheet لإنشاء المضلع'"
                @click="openGeodesiaPolygonModal"
              >
                <feather-icon
                  icon="HexagonIcon"
                  size="14"
                  class="mr-1"
                />
                إنشاء مضلع...
              </b-button>
            </div>
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('jxl')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'jxl'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد JXL
              </b-button>
              <small
                v-if="hasJxl"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || previewingJxlSurvey"
                  :title="jxlPreviewActive ? 'إخفاء نقاط JXL من الخريطة' : 'عرض نقاط JXL على الخريطة'"
                  @click="handleJxlPreviewToggle"
                >
                  <b-spinner
                    v-if="previewingJxlSurvey"
                    small
                  />
                  <feather-icon
                    v-else
                    :icon="jxlPreviewActive ? 'EyeOffIcon' : 'EyeIcon'"
                    size="18"
                  />
                </b-button>
              </small>
              <b-button
                v-if="jxlPreviewActive && geodesiaSheetPoints.length >= 3"
                variant="outline-primary"
                size="sm"
                class="geodesia-survey-import-button mt-50"
                title="اختر نقاط JXL لإنشاء المضلع"
                @click="openGeodesiaPolygonModal"
              >
                <feather-icon
                  icon="HexagonIcon"
                  size="14"
                  class="mr-1"
                />
                إنشاء مضلع...
              </b-button>
            </div>

            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('rw5')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'rw5'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد RW5
              </b-button>
              <small
                v-if="project && project.has_rw5"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط RW5 على الخريطة"
                  @click="handleProjectSurveyFilePreview('rw5')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'rw5'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="18"
                  />
                </b-button>
              </small>
            </div>
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('raw')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'raw'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد RAW
              </b-button>
              <small
                v-if="project && project.has_raw"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط RAW على الخريطة"
                  @click="handleProjectSurveyFilePreview('raw')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'raw'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="18"
                  />
                </b-button>
              </small>
            </div>
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('kmz')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kmz'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد KMZ
              </b-button>
              <small
                v-if="project && project.has_jxl"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط KMZ على الخريطة"
                  @click="handleProjectSurveyFilePreview('kmz')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'kmz'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="18"
                  />
                </b-button>
              </small>
            </div>
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('kml')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'kml'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد KML
              </b-button>
              <small
                v-if="project && project.has_jxl"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط KML على الخريطة"
                  @click="handleProjectSurveyFilePreview('kml')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'kml'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="18"
                  />
                </b-button>
              </small>
            </div>
            <div class="geodesia-survey-import-item">
              <b-button
                variant="success"
                size="sm"
                class="geodesia-survey-import-button"
                :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet"
                @click="handleGeodesiaImportClick('dxf')"
              >
                <b-spinner
                  v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'dxf'"
                  small
                  class="mr-1"
                />
                <feather-icon
                  v-else
                  icon="DownloadIcon"
                  size="14"
                  class="mr-1"
                />
                استيراد DXF
              </b-button>
              <small
                v-if="project && project.has_jxl"
                class="text-warning d-flex align-items-center mt-1 geodesia-survey-existing-file"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="16"
                  class="mr-1"
                />
                <b-button
                  variant="link"
                  size="sm"
                  class="geodesia-survey-preview-button p-0 ml-50"
                  :disabled="importingGeodesiaSurveyFile || importingGeodesiaSheet || !!previewingProjectSurveyFileType"
                  title="عرض نقاط DXF على الخريطة"
                  @click="handleProjectSurveyFilePreview('dxf')"
                >
                  <b-spinner
                    v-if="previewingProjectSurveyFileType === 'dxf'"
                    small
                  />
                  <feather-icon
                    v-else
                    icon="EyeIcon"
                    size="18"
                  />
                </b-button>
              </small>
            </div>

          </div> -->
        </div>
        <div
          v-if="showInlineMap"
          ref="inlineMapFullscreenRoot"
          class="inline-map-wrapper map-fullscreen-root"
          :class="{ 'map-fullscreen-root--arcgis': !useGoogleMap }"
        >
          <coordinates-map-google
            v-if="googleMapEngineMounted"
            ref="inlineGoogleMap"
            class="map-engine"
            :class="mapEngineClass(true)"
            :aria-hidden="useGoogleMap ? 'false' : 'true'"
            :coordinates="mapDisplayCoordinates"
            :location-id="projectLocationId"
            :other-project-locations="otherLocationsForMap"
            :enable-save-as-new-location="enableSaveAsNewLocation"
            @coordinates-changed="onMapCoordinatesChanged"
            @coordinates-saved="onMapCoordinatesSaved"
            @save-as-new-location="onMapSaveAsNewLocation"
            @draw-history-sync="onMapDrawHistorySync($event, true)"
          />
          <coordinates-map
            v-if="arcgisMapEngineMounted"
            ref="inlineArcgisMap"
            class="map-engine"
            :class="mapEngineClass(false)"
            :aria-hidden="useGoogleMap ? 'true' : 'false'"
            :coordinates="mapDisplayCoordinates"
            :location-id="projectLocationId"
            :other-project-locations="otherLocationsForMap"
            :enable-save-as-new-location="enableSaveAsNewLocation"
            @coordinates-changed="onMapCoordinatesChanged"
            @coordinates-saved="onMapCoordinatesSaved"
            @save-as-new-location="onMapSaveAsNewLocation"
            @draw-history-sync="onMapDrawHistorySync($event, false)"
          />
          <div
            v-if="switchingMapEngine"
            class="map-engine-switch-loader"
          >
            <b-spinner variant="light" />
            <span>{{ mapEngineSwitchLoaderText }}</span>
          </div>
          <div
            ref="inlineSurveyDockHost"
            class="map-survey-dock-host"
          >
            <map-float-panel
              v-if="hasPermission('Access GIS')"
              ref="inlineSurveyDock"
              panel-id="gis-survey-dock-inline"
              :panel-class="surveyDockPanelClass"
              :layout-key="surveyDockLayoutKey"
              center-horizontally
            >
              <template #title>
                ملفات الرفع
              </template>
              <map-fullscreen-survey-dock
                id-prefix="inline-survey"
                embedded
                :items="fullscreenSurveyPreviewItems"
                :file-flags="fullscreenSurveyFileFlags"
                :active-keys="fullscreenSurveyActiveKeys"
                :loading-key="fullscreenSurveyLoadingKey"
                :busy="fullscreenSurveyBusy"
                :replace-message="fullscreenSurveyReplaceMessage"
                :replace-confirm-label="fullscreenSurveyConfirmLabel"
                @preview="onFullscreenSurveyPreviewClick"
                @upload="onFullscreenSurveyUploadClick"
                @confirm-replace="resolveFullscreenSurveyReplace(true)"
                @cancel-replace="resolveFullscreenSurveyReplace(false)"
              />
            </map-float-panel>
          </div>
          <div
            v-if="mapFullscreenNotice"
            class="map-fullscreen-notice"
            :class="`map-fullscreen-notice--${mapFullscreenNotice.type}`"
            role="alert"
          >
            {{ mapFullscreenNotice.message }}
          </div> 
          <map-project-locations-panel
            :locations="projectLocations"
            :active-location-id="projectLocationId"
            :can-create="canCreateMapLocation"
            show-draw-actions
            :draw-history="mapDrawHistory"
            :draw-history-index="mapDrawHistoryIndex"
            :move-active="mapDrawMoveActive"
            @create="onMapLocationCreate"
            @edit-data="onMapLocationEditData"
            @edit-polygon="onMapLocationEditPolygon"
            @draw-move="onMapDrawMove"
            @draw-undo="onMapDrawUndo"
            @draw-redo="onMapDrawRedo"
            @draw-jump="onMapDrawJump"
          />
          <button
            v-show="fullscreenToolbarTarget === 'inline' && mapFullscreenToolbarHidden"
            ref="inlineToolbarShowFab"
            type="button"
            class="map-toolbar-show-fab"
            title="إظهار شريط الأدوات"
            aria-label="إظهار شريط الأدوات"
            @click.stop="toggleFullscreenMapToolbar"
          >
            <feather-icon
              icon="ChevronUpIcon"
              size="16"
            />
            <span>إظهار الأدوات</span>
          </button>
        </div>
        <div
          v-if="showInlineMap"
          ref="inlineMapToolbarHost"
          class="map-toolbar-host"
        >
        <div
          ref="inlineMapToolbar"
          class="map-toolbar-actions d-flex flex-nowrap align-items-center gap-2 mt-1"
          :class="{
            'map-toolbar-actions--fullscreen': fullscreenToolbarTarget === 'inline',
            'is-collapsed': fullscreenToolbarTarget === 'inline' && mapFullscreenToolbarHidden,
          }"
        >
          <button
            type="button"
            class="map-toolbar-fullscreen-toggle"
            title="إخفاء شريط الأدوات"
            aria-label="إخفاء شريط الأدوات"
            aria-expanded="true"
            @click.stop="toggleFullscreenMapToolbar"
          >
            <feather-icon
              icon="ChevronDownIcon"
              size="16"
            />
          </button>
          <b-form-checkbox
            :checked="esriMapSwitchChecked"
            switch
            class="mb-0 ml-2"
            :disabled="switchingMapEngine"
            @change="onEsriMapSwitchChange"
          >
            خريطة Esri
            <b-spinner
              v-if="switchingMapEngine"
              small
              class="map-engine-switch-inline-spinner"
            />
          </b-form-checkbox>
          <b-button
            size="sm"
            variant="outline-primary"
            class="map-toolbar-btn map-toolbar-btn--icon"
            v-b-tooltip="mapToolbarTooltip('تحديث الخريطة')"
            @click="refreshMap"
          >
            <feather-icon icon="RefreshCwIcon" size="16" />
          </b-button>
          <b-button
            size="sm"
            variant="outline-info"
            class="map-toolbar-btn map-toolbar-btn--icon"
            v-b-tooltip="mapToolbarTooltip('فتح الخريطة')"
            @click="openMapPopup"
          >
            <feather-icon icon="Maximize2Icon" size="16" />
          </b-button>

          
          <b-button
            v-if="hasPermission('edit projects')"
            size="sm"
            variant="outline-dark"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="exportingDxf"
            v-b-tooltip="mapToolbarTooltip('تصدير ملف أوتوكاد (DXF)')"
            @click="openDxfExportModal"
          >
            <b-spinner
              v-if="exportingDxf"
              small
            />
            <feather-icon
              v-else
              icon="DownloadIcon"
              size="16"
            />
          </b-button>
          <b-button
            v-if="hasPermission('edit projects')"
            size="sm"
            variant="outline-dark"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="exportingJxlHtml"
            v-b-tooltip="mapToolbarTooltip('تصدير HTML من JXL')"
            @click="exportProjectJxlHtml"
          >
            <b-spinner
              v-if="exportingJxlHtml"
              small
            />
            <feather-icon
              v-else
              icon="FileTextIcon"
              size="16"
            />
          </b-button>
          <b-button
            v-if="hasPermission('edit projects')"
            size="sm"
            variant="outline-success"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="takingScreenshot"
            v-b-tooltip="mapToolbarTooltip('لقطة شاشة')"
            @click="takeMapScreenshot"
          >
            <b-spinner
              v-if="takingScreenshot"
              small
            />
            <feather-icon
              v-else
              icon="CameraIcon"
              size="16"
            />
          </b-button>
          <b-button
            size="sm"
            variant="outline-primary"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="kmlActionLoading"
            v-b-tooltip="mapToolbarTooltip('Export KML')"
            @click="openKmlDownloadModal"
          >
            <b-spinner
              v-if="kmlActionLoading"
              small
            />
            <feather-icon
              v-else
              icon="MapIcon"
              size="16"
            />
          </b-button>
          <b-button
            v-if="showJxlDownload"
            size="sm"
            variant="outline-success"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="loadExportExcel"
            v-b-tooltip="mapToolbarTooltip('Export Excel')"
            @click="exportExcel(projectLocationId)"
          >
            <b-spinner
              v-if="loadExportExcel"
              small
            />
            <feather-icon
              v-else
              icon="FileTextIcon"
              size="16"
            />
          </b-button>
          <b-button
            v-if="showJxlDownload && hasPermission('edit projects')"
            size="sm"
            variant="outline-secondary"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="downloadingJxl"
            v-b-tooltip="mapToolbarTooltip('تنزيل JXL (Trimble / JobXML) لهذه القطعة')"
            @click="downloadCoordinatesJxl"
          >
            <b-spinner
              v-if="downloadingJxl"
              small
            />
            <feather-icon
              v-else
              icon="DownloadIcon"
              size="16"
            />
          </b-button>
          <b-button
            v-if="hasPermission('generate shapefile')"
            size="sm"
            variant="outline-warning"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="downloadingShapeZip"
            v-b-tooltip="mapToolbarTooltip('Download Shape ZIP for this project')"
            @click="openShapeSchemaModal"
          >
            <b-spinner
              v-if="downloadingShapeZip"
              small
            />
            <feather-icon
              v-else
              icon="PackageIcon"
              size="16"
            />
          </b-button>
          <b-button
            size="sm"
            variant="outline-info"
            class="map-toolbar-btn map-toolbar-btn--icon"
            :disabled="!filteredCoordinates.length"
            v-b-tooltip="mapToolbarTooltip('جدول الإحداثيات')"
            @click="showCoordinatesTablePreview = true"
          >
            <feather-icon icon="EyeIcon" size="16" />
          </b-button>
          <b-button
            v-if="isProjectDetailsRoute && hasPermission('edit projects')"
            size="sm"
            variant="outline-primary"
            class="map-toolbar-btn map-toolbar-btn--icon"
            v-b-tooltip="mapToolbarTooltip(showSketch ? 'إخفاء الرسم التخطيطي' : 'عرض الرسم التخطيطي')"
            @click="showSketch = !showSketch"
          >
            <feather-icon
              :icon="showSketch ? 'EyeOffIcon' : 'PenToolIcon'"
              size="16"
            />
          </b-button>
          <div
            v-if="canViewAdministrativeBoundaries"
            class="admin-boundary-badge"
            :class="{ 'admin-boundary-badge--loading': loadingAdministrativeBoundary }"
          >
            <b-spinner
              v-if="loadingAdministrativeBoundary"
              small
              class="admin-boundary-badge__loader"
            />
            <span class="admin-boundary-badge__title">الحدود الإدارية للمشروع</span>
            <span
              v-for="row in administrativeBoundaryRows"
              :key="`project-${row.type}`"
              class="admin-boundary-badge__item"
              :class="{ 'is-empty': !row.found }"
            >
              {{ row.label }}: <strong>{{ row.name }}</strong>
            </span>
            <small
              v-if="administrativeBoundaryError"
              class="text-danger"
            >
              {{ administrativeBoundaryError }}
            </small>
          </div>
          <!--
          <div
            v-if="canViewAdministrativeBoundaries && (clickedMapPoint || loadingSelectedAdministrativeBoundary || selectedAdministrativeBoundaryResult || selectedAdministrativeBoundaryError)"
            class="admin-boundary-badge admin-boundary-badge--selected"
            :class="{ 'admin-boundary-badge--loading': loadingSelectedAdministrativeBoundary }"
          >
            <b-spinner
              v-if="loadingSelectedAdministrativeBoundary"
              small
              class="admin-boundary-badge__loader"
            />
            <span class="admin-boundary-badge__title">الحدود الإدارية المختارة</span>
            <span
              v-for="row in selectedAdministrativeBoundaryRows"
              :key="`selected-${row.type}`"
              class="admin-boundary-badge__item"
              :class="{ 'is-empty': !row.found }"
            >
              {{ row.label }}: <strong>{{ row.name }}</strong>
            </span>
            <small
              v-if="selectedAdministrativeBoundaryError"
              class="text-danger"
            >
              {{ selectedAdministrativeBoundaryError }}
            </small>
          </div>
          -->
        </div>
        </div>
        <div>
          <b-collapse
            id="sketch-collapse"
            v-model="showSketch"
          >
          <div class="sketch-container">

            <b-row>
              <b-col md="4">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  :disabled="!surveySiteCoordinateSketch"
                  @click="downloadSketchPng"
                >
                  تنزيل الرسم
                </b-button>
              </b-col>
              <b-col md="8">
                <div
              v-if="surveySiteCoordinateSketch"
              class="text-primary small font-weight-bold mb-1 site-sketch-from-coords"
            >
            
              <div
                ref="siteSketchWrap"
                class="coordinate-sketch-wrap"
              >
                <div class="compass-rose compass-top-left">
                  
                  <img src="../../public/CompassRose.png" alt="Compass Rose" class="compass-rose-image">
                </div>
                <svg
                  ref="siteSketchSvg"
                  class="site-polygon-sketch-svg"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <defs>
                    <pattern
                      :id="surveySketchPatternIds.grid"
                      width="0"
                      height="0"
                      patternUnits="userSpaceOnUse"
                    >
                      <path
                        d="M 5 0 L 0 0 0 5"
                        fill="none"
                        stroke="#0a3345"
                        stroke-width="0.08"
                        opacity="0.22"
                      />
                    </pattern>
                    <pattern
                      :id="surveySketchPatternIds.hatch"
                      width="2.2"
                      height="2.2"
                      patternUnits="userSpaceOnUse"
                      patternTransform="rotate(45)"
                    >
                      <path
                        d="M 0 0 L 0 2.2"
                        stroke="#0a3345"
                        stroke-width="0.35"
                        opacity="0.18"
                      />
                    </pattern>
                  </defs>
                  <rect
                    class="sketch-paper-bg"
                    x="0"
                    y="0"
                    width="100"
                    height="100"
                    fill="#faf8f4"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="100"
                    height="100"
                    :fill="'url(#' + surveySketchPatternIds.grid + ')'"
                  />
                  <polygon
                    :points="surveySiteCoordinateSketch.pointsStr"
                    :fill="'url(#' + surveySketchPatternIds.hatch + ')'"
                    stroke="#0a3345"
                    stroke-width="0.5"
                    stroke-linejoin="miter"
                    class="sketch-lot-fill"
                  />
                  <g class="sketch-dimensions">
                    <g
                      v-for="(seg, idx) in surveySiteCoordinateSketch.segments"
                      :key="'sk-len-' + idx"
                      :transform="'rotate(' + seg.angleDeg + ' ' + seg.lx + ' ' + seg.ly + ')'"
                    >
                      <line
                        :x1="seg.mx"
                        :y1="seg.my"
                        :x2="seg.lx"
                        :y2="seg.ly"
                        class="sketch-length-guide"
                      />
                      <text
                        :x="seg.lx"
                        :y="seg.ly"
                        class="sketch-edge-length"
                        text-anchor="middle"
                        dominant-baseline="middle"
                      >
                        {{ formatSketchEdgeLengthM(seg.lengthM) }}
                      </text>
                    </g>
                  </g>
                  <g class="sketch-vertices">
                    <g
                      v-for="v in surveySiteCoordinateSketch.vertices"
                      :key="'vtx-' + v.index"
                    >
                      <circle
                        :cx="v.cx"
                        :cy="v.cy"
                        :r="v.r"
                        class="sketch-vertex-dot"
                      />
                      <circle
                        :cx="v.cx"
                        :cy="v.cy"
                        :r="v.r + 0.55"
                        fill="none"
                        stroke="#0a3345"
                        stroke-width="0.35"
                      />
                      <text
                        :x="v.tx"
                        :y="v.ty"
                        class="sketch-vertex-index"
                        text-anchor="middle"
                        dominant-baseline="middle"
                      >
                        {{ toArabicIndicDigits(v.index) }}
                      </text>
                    </g>
                  </g>
                  <g
                    v-if="surveySiteCoordinateSketch.scaleBar"
                    class="sketch-scale-bar"
                  >
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x1"
                      :y1="surveySiteCoordinateSketch.scaleBar.y"
                      :x2="surveySiteCoordinateSketch.scaleBar.x2"
                      :y2="surveySiteCoordinateSketch.scaleBar.y"
                      stroke="#0a3345"
                      stroke-width="0.9"
                    />
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x1"
                      :y1="surveySiteCoordinateSketch.scaleBar.y - 1.2"
                      :x2="surveySiteCoordinateSketch.scaleBar.x1"
                      :y2="surveySiteCoordinateSketch.scaleBar.y + 1.2"
                      stroke="#0a3345"
                      stroke-width="0.55"
                    />
                    <line
                      :x1="surveySiteCoordinateSketch.scaleBar.x2"
                      :y1="surveySiteCoordinateSketch.scaleBar.y - 1.2"
                      :x2="surveySiteCoordinateSketch.scaleBar.x2"
                      :y2="surveySiteCoordinateSketch.scaleBar.y + 1.2"
                      stroke="#0a3345"
                      stroke-width="0.55"
                    />
                    <text
                      :x="(surveySiteCoordinateSketch.scaleBar.x1 + surveySiteCoordinateSketch.scaleBar.x2) / 2"
                      :y="surveySiteCoordinateSketch.scaleBar.y - 2.4"
                      class="sketch-scale-caption"
                      text-anchor="middle"
                      dominant-baseline="middle"
                    >
                      مقياس الرسم
                    </text>
                    <text
                      :x="(surveySiteCoordinateSketch.scaleBar.x1 + surveySiteCoordinateSketch.scaleBar.x2) / 2"
                      :y="surveySiteCoordinateSketch.scaleBar.y + 4.2"
                      class="sketch-scale-value"
                      text-anchor="middle"
                      dominant-baseline="middle"
                    >
                      {{ surveySiteCoordinateSketch.scaleBar.label }}
                    </text>
                  </g>
                </svg>
              </div>
              
            </div>
              </b-col>
            </b-row>
            </div>
          </b-collapse>
        
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showMapPopup"
      title="عرض الخريطة"
      size="xl"
      hide-footer
      lazy
      modal-class="coordinates-map-popup-modal"
      @shown="onMapPopupShown"
    >
      <div class="map-popup-shell">
        <div
          ref="popupMapFullscreenRoot"
          class="map-popup-shell__map map-fullscreen-root"
          :class="{ 'map-fullscreen-root--arcgis': !useGoogleMap }"
        >
          <coordinates-map-google
            v-if="googleMapEngineMounted"
            ref="popupGoogleMap"
            class="map-engine"
            :class="mapEngineClass(true)"
            :aria-hidden="useGoogleMap ? 'false' : 'true'"
            layout="popup"
            :coordinates="mapDisplayCoordinates"
            :location-id="projectLocationId"
            :other-project-locations="otherLocationsForMap"
            :enable-save-as-new-location="enableSaveAsNewLocation"
            @coordinates-changed="onMapCoordinatesChanged"
            @coordinates-saved="onMapCoordinatesSaved"
            @save-as-new-location="onMapSaveAsNewLocation"
            @draw-history-sync="onMapDrawHistorySync($event, true)"
          />
          <coordinates-map
            v-if="arcgisMapEngineMounted"
            ref="popupArcgisMap"
            class="map-engine"
            :class="mapEngineClass(false)"
            :aria-hidden="useGoogleMap ? 'true' : 'false'"
            layout="popup"
            :coordinates="mapDisplayCoordinates"
            :location-id="projectLocationId"
            :other-project-locations="otherLocationsForMap"
            :enable-save-as-new-location="enableSaveAsNewLocation"
            @coordinates-changed="onMapCoordinatesChanged"
            @coordinates-saved="onMapCoordinatesSaved"
            @save-as-new-location="onMapSaveAsNewLocation"
            @draw-history-sync="onMapDrawHistorySync($event, false)"
          />
          <div
            v-if="switchingMapEngine"
            class="map-engine-switch-loader"
          >
            <b-spinner variant="light" />
            <span>{{ mapEngineSwitchLoaderText }}</span>
          </div>
          <div
            ref="popupSurveyDockHost"
            class="map-survey-dock-host"
          >
            <map-float-panel
              v-if="hasPermission('Access GIS')"
              ref="popupSurveyDock"
              panel-id="gis-survey-dock-popup"
              :panel-class="surveyDockPanelClass"
              :layout-key="surveyDockLayoutKey"
              center-horizontally
            >
              <template #title>
                ملفات الرفع
              </template>
              <map-fullscreen-survey-dock
                id-prefix="popup-survey"
                embedded
                :items="fullscreenSurveyPreviewItems"
                :file-flags="fullscreenSurveyFileFlags"
                :active-keys="fullscreenSurveyActiveKeys"
                :loading-key="fullscreenSurveyLoadingKey"
                :busy="fullscreenSurveyBusy"
                :replace-message="fullscreenSurveyReplaceMessage"
                :replace-confirm-label="fullscreenSurveyConfirmLabel"
                @preview="onFullscreenSurveyPreviewClick"
                @upload="onFullscreenSurveyUploadClick"
                @confirm-replace="resolveFullscreenSurveyReplace(true)"
                @cancel-replace="resolveFullscreenSurveyReplace(false)"
              />
            </map-float-panel>
          </div>
          <div
            v-if="mapFullscreenNotice"
            class="map-fullscreen-notice"
            :class="`map-fullscreen-notice--${mapFullscreenNotice.type}`"
            role="alert"
          >
            {{ mapFullscreenNotice.message }}
          </div>
          <map-project-locations-panel
            :locations="projectLocations"
            :active-location-id="projectLocationId"
            :can-create="canCreateMapLocation"
            show-draw-actions
            :draw-history="mapDrawHistory"
            :draw-history-index="mapDrawHistoryIndex"
            :move-active="mapDrawMoveActive"
            @create="onMapLocationCreate"
            @edit-data="onMapLocationEditData"
            @edit-polygon="onMapLocationEditPolygon"
            @draw-move="onMapDrawMove"
            @draw-undo="onMapDrawUndo"
            @draw-redo="onMapDrawRedo"
            @draw-jump="onMapDrawJump"
          />
          <button
            v-show="fullscreenToolbarTarget === 'popup' && mapFullscreenToolbarHidden"
            ref="popupToolbarShowFab"
            type="button"
            class="map-toolbar-show-fab"
            title="إظهار شريط الأدوات"
            aria-label="إظهار شريط الأدوات"
            @click.stop="toggleFullscreenMapToolbar"
          >
            <feather-icon
              icon="ChevronUpIcon"
              size="16"
            />
            <span>إظهار الأدوات</span>
          </button>
        </div>
        <div
          ref="popupMapToolbarHost"
          class="map-toolbar-host"
        >
      <div
        ref="popupMapToolbar"
        class="map-toolbar-actions map-toolbar-actions--popup d-flex flex-wrap align-items-center gap-2 mt-1"
        :class="{
          'map-toolbar-actions--fullscreen': fullscreenToolbarTarget === 'popup',
          'is-collapsed': fullscreenToolbarTarget === 'popup' && mapFullscreenToolbarHidden,
        }"
      >
        <button
          type="button"
          class="map-toolbar-fullscreen-toggle"
          title="إخفاء شريط الأدوات"
          aria-label="إخفاء شريط الأدوات"
          aria-expanded="true"
          @click.stop="toggleFullscreenMapToolbar"
        >
          <feather-icon
            icon="ChevronDownIcon"
            size="16"
          />
        </button>
        <b-form-checkbox
          :checked="esriMapSwitchChecked"
          switch
          class="mb-0 ml-2"
          :disabled="switchingMapEngine"
          @change="onEsriMapSwitchChange"
        >
          خريطة Esri
          <b-spinner
            v-if="switchingMapEngine"
            small
            class="map-engine-switch-inline-spinner"
          />
        </b-form-checkbox>
        <b-button
          size="sm"
          variant="outline-primary"
          class="map-toolbar-btn map-toolbar-btn--icon"
          v-b-tooltip="mapPopupToolbarTooltip('تحديث الخريطة')"
          @click="refreshMap"
        >
          <feather-icon icon="RefreshCwIcon" size="16" />
        </b-button>
        <b-button
          v-if="hasPermission('edit projects')"
          size="sm"
          variant="outline-dark"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="exportingDxf"
          v-b-tooltip="mapPopupToolbarTooltip('تصدير ملف أوتوكاد (DXF)')"
          @click="openDxfExportModal"
        >
          <b-spinner
            v-if="exportingDxf"
            small
          />
          <feather-icon
            v-else
            icon="DownloadIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="hasPermission('edit projects')"
          size="sm"
          variant="outline-dark"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="exportingJxlHtml"
          v-b-tooltip="mapPopupToolbarTooltip('تصدير HTML من JXL')"
          @click="exportProjectJxlHtml"
        >
          <b-spinner
            v-if="exportingJxlHtml"
            small
          />
          <feather-icon
            v-else
            icon="FileTextIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="hasPermission('edit projects')"
          size="sm"
          variant="outline-success"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="takingScreenshot"
          v-b-tooltip="mapPopupToolbarTooltip('لقطة شاشة')"
          @click="takeMapScreenshot"
        >
          <b-spinner
            v-if="takingScreenshot"
            small
          />
          <feather-icon
            v-else
            icon="CameraIcon"
            size="16"
          />
        </b-button>
        <b-button
          size="sm"
          variant="outline-primary"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="kmlActionLoading"
          v-b-tooltip="mapPopupToolbarTooltip('Export KML')"
          @click="openKmlDownloadModal"
        >
          <b-spinner
            v-if="kmlActionLoading"
            small
          />
          <feather-icon
            v-else
            icon="MapIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="showJxlDownload"
          size="sm"
          variant="outline-success"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="loadExportExcel"
          v-b-tooltip="mapPopupToolbarTooltip('Export Excel')"
          @click="exportExcel(projectLocationId)"
        >
          <b-spinner
            v-if="loadExportExcel"
            small
          />
          <feather-icon
            v-else
            icon="FileTextIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="showJxlDownload && hasPermission('edit projects')"
          size="sm"
          variant="outline-secondary"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="downloadingJxl"
          v-b-tooltip="mapPopupToolbarTooltip('تنزيل JXL (Trimble / JobXML) لهذه القطعة')"
          @click="downloadCoordinatesJxl"
        >
          <b-spinner
            v-if="downloadingJxl"
            small
          />
          <feather-icon
            v-else
            icon="DownloadIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="hasPermission('generate shapefile')"
          size="sm"
          variant="outline-warning"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="downloadingShapeZip"
          v-b-tooltip="mapPopupToolbarTooltip('Download Shape ZIP for this project')"
          @click="openShapeSchemaModal"
        >
          <b-spinner
            v-if="downloadingShapeZip"
            small
          />
          <feather-icon
            v-else
            icon="PackageIcon"
            size="16"
          />
        </b-button>
        <b-button
          size="sm"
          variant="outline-info"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="!filteredCoordinates.length"
          v-b-tooltip="mapPopupToolbarTooltip('جدول الإحداثيات')"
          @click="showCoordinatesTablePreview = true"
        >
          <feather-icon icon="EyeIcon" size="16" />
        </b-button>
        <b-button
          v-if="isProjectDetailsRoute && hasPermission('edit projects')"
          size="sm"
          variant="outline-primary"
          class="map-toolbar-btn map-toolbar-btn--icon"
          v-b-tooltip="mapPopupToolbarTooltip(showSketch ? 'إخفاء الرسم التخطيطي' : 'عرض الرسم التخطيطي')"
          @click="showSketch = !showSketch"
        >
          <feather-icon
            :icon="showSketch ? 'EyeOffIcon' : 'PenToolIcon'"
            size="16"
          />
        </b-button>
        <b-button
          v-if="resolvedProjectId"
          size="sm"
          variant="success"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="importingGeodesiaSurveyFile"
          v-b-tooltip="mapPopupToolbarTooltip('استيراد JXL')"
          @click="handleGeodesiaImportClick('jxl')"
        >
          <b-spinner
            v-if="importingGeodesiaSurveyFile && geodesiaImportingType === 'jxl'"
            small
          />
          <feather-icon
            v-else
            icon="DownloadIcon"
            size="16"
          />
        </b-button>
        <b-button
          v-if="hasJxl"
          size="sm"
          variant="outline-success"
          class="map-toolbar-btn map-toolbar-btn--icon"
          :disabled="importingGeodesiaSurveyFile || previewingJxlSurvey"
          v-b-tooltip="mapPopupToolbarTooltip(jxlPreviewActive ? 'إخفاء نقاط JXL من الخريطة' : 'عرض نقاط JXL على الخريطة')"
          @click="handleJxlPreviewToggle"
        >
          <b-spinner
            v-if="previewingJxlSurvey"
            small
          />
          <feather-icon
            v-else
            :icon="jxlPreviewActive ? 'EyeOffIcon' : 'EyeIcon'"
            size="16"
          />
        </b-button>
        <b-button
          v-if="jxlPreviewActive && geodesiaSheetPoints.length >= 3"
          size="sm"
          variant="outline-primary"
          class="map-toolbar-btn map-toolbar-btn--icon"
          v-b-tooltip="mapPopupToolbarTooltip('إنشاء مضلع من نقاط JXL')"
          @click="openGeodesiaPolygonModal"
        >
          <feather-icon icon="HexagonIcon" size="16" />
        </b-button>
        <div
          v-if="canViewAdministrativeBoundaries"
          class="admin-boundary-badge"
          :class="{ 'admin-boundary-badge--loading': loadingAdministrativeBoundary }"
        >
          <b-spinner
            v-if="loadingAdministrativeBoundary"
            small
            class="admin-boundary-badge__loader"
          />
          <span class="admin-boundary-badge__title">الحدود الإدارية للمشروع</span>
          <span
            v-for="row in administrativeBoundaryRows"
            :key="`popup-${row.type}`"
            class="admin-boundary-badge__item"
            :class="{ 'is-empty': !row.found }"
          >
            {{ row.label }}: <strong>{{ row.name }}</strong>
          </span>
          <small
            v-if="administrativeBoundaryError"
            class="text-danger"
          >
            {{ administrativeBoundaryError }}
          </small>
        </div>
        </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="showCoordinatesTablePreview"
      title="معاينة جدول الإحداثيات"
      size="lg"
      scrollable
      ok-only
      ok-title="إغلاق"
    >
      <b-table
        :items="filteredCoordinates"
        :fields="coordinateFields"
        small
        striped
        responsive
        class="mb-0"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(latitude)="data">
          <code>{{ data.item.latitude }}</code>
        </template>
        <template #cell(longitude)="data">
          <code>{{ data.item.longitude }}</code>
        </template>
        <template #cell(utm_east)="data">
          <code>{{ data.item.utm_east != null ? Number(data.item.utm_east).toFixed(3) : '-' }}</code>
        </template>
        <template #cell(utm_north)="data">
          <code>{{ data.item.utm_north != null ? Number(data.item.utm_north).toFixed(3) : '-' }}</code>
        </template>
      </b-table>
    </b-modal>
    <b-modal
      v-model="showKmlDownloadModal"
      title="تنزيل KML / Download KML"
      ok-title="تنزيل / Download"
      cancel-title="إلغاء / Cancel"
      :ok-disabled="!canConfirmKmlDownload || kmlActionLoading"
      :cancel-disabled="kmlActionLoading"
      @ok="confirmKmlDownload"
    >
      <b-form-group label="نوع التصدير / Export scope">
        <b-form-select
          v-model="kmlDownloadScope"
          :options="kmlDownloadScopeOptions"
          :disabled="kmlActionLoading"
          @change="handleKmlDownloadTargetChange"
        />
      </b-form-group>
      <b-form-group
        v-if="kmlDownloadScope === 'location'"
        label="اختر الموقع / Choose location"
      >
        <b-form-select
          v-model="selectedKmlLocationId"
          :options="kmlLocationOptions"
          :disabled="kmlActionLoading || !kmlLocationOptions.length"
        />
        <small
          v-if="!kmlLocationOptions.length"
          class="text-muted d-block mt-50"
        >
          لا توجد مواقع متاحة للتصدير / No project locations available for location export.
        </small>
      </b-form-group>
      <b-form-group label="ملاحظة رأس التقرير / Header note (optional)">
        <b-form-textarea
          v-model="kmlHeaderNote"
          rows="3"
          :maxlength="KML_HEADER_NOTE_MAX_LENGTH"
          :disabled="kmlActionLoading"
          placeholder="نص اختياري يظهر تحت عنوان «📍 بيان رفع مساحي» في ملف KML"
        />
        <small class="text-muted d-block mt-50">
          {{ kmlHeaderNoteLength }} / {{ KML_HEADER_NOTE_MAX_LENGTH }}
          — اترك الحقل فارغاً لتنزيل KML بدون ملاحظة / Leave empty to download without a header note.
        </small>
      </b-form-group>
      <div
        v-if="kmlActionLoading"
        class="text-center py-1"
      >
        <b-spinner small />
        <span class="ml-50 text-muted">جاري تنزيل ملف KML...</span>
      </div>
    </b-modal>
    <b-modal
      
      v-model="showDxfExportModal"
      title="تصدير ملف أوتوكاد (DXF)"
      scrollable
      modal-class="dxf-export-modal"
      :no-close-on-backdrop="exportingDxf"
      :no-close-on-esc="exportingDxf"
      @hidden="resetDxfExportValidation"
    >
      <div :class="{ 'opacity-50': exportingDxf }">
        <fieldset :disabled="exportingDxf">
          <h6 class="font-weight-bold mb-1">نوع الهندسة</h6>
          <div class="dxf-export-checkbox-row d-flex flex-wrap align-items-center mb-50">
            <b-form-checkbox
              v-model="dxfExportGeometrySelectAll"
              inline
              class="mb-0 ml-2"
              @change="onDxfExportGeometrySelectAllChange"
            >
              تحديد الكل
            </b-form-checkbox>
            <b-form-checkbox
              v-for="opt in dxfGeometryOptions"
              :key="`dxf-geom-${opt.value}`"
              v-model="dxfExportGeometryChecked[opt.value]"
              inline
              class="mb-0 ml-2"
              @change="syncDxfExportGeometrySelectAll"
            >
              {{ opt.label }}
            </b-form-checkbox>
          </div>
          <small class="text-muted d-block mb-1">اختر نوعاً واحداً على الأقل</small>

          <h6 class="font-weight-bold mb-1 mt-1">مصدر البيانات</h6>
          <div class="dxf-export-checkbox-row d-flex flex-wrap align-items-center mb-50">
            <b-form-checkbox
              v-model="dxfExportLayersSelectAll"
              inline
              class="mb-0 ml-2"
              @change="onDxfExportLayersSelectAllChange"
            >
              تحديد الكل
            </b-form-checkbox>
            <b-form-checkbox
              v-for="opt in dxfLayerOptions"
              :key="`dxf-layer-${opt.value}`"
              v-model="dxfExportSourceLayersChecked[opt.value]"
              inline
              class="mb-0 ml-2"
              @change="syncDxfExportLayersSelectAll"
            >
              {{ opt.label }}
            </b-form-checkbox>
          </div>
          <small class="text-muted d-block mb-1">اختر مصدراً واحداً على الأقل</small>

          <h6 class="font-weight-bold mb-1 mt-1">خيارات</h6>
          <b-form-checkbox v-model="dxfExportIncludeCartouche">
            إضافة خرطوشة (إطار ومعلومات المشروع)
          </b-form-checkbox>
        </fieldset>

        <b-alert
          v-if="dxfExportValidationError"
          show
          variant="warning"
          class="mt-1 mb-0"
        >
          {{ dxfExportValidationError }}
        </b-alert>
        <p
          v-if="exportingDxf"
          class="text-primary small mt-1 mb-0"
        >
          <b-spinner small class="mr-50" />
          جاري إنشاء ملف DXF…
        </p>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end dxf-export-modal-footer">
          <b-button
            variant="outline-secondary"
            class="ml-1"
            :disabled="exportingDxf"
            @click="showDxfExportModal = false"
          >
            إلغاء
          </b-button>
          <b-button
            variant="primary"
            :disabled="!canConfirmDxfExport || exportingDxf"
            @click="confirmDxfExport"
          >
            <b-spinner
              v-if="exportingDxf"
              small
              class="mr-50"
            />
            تصدير
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="geodesia-sheet-import-modal"
      v-model="showGeodesiaSheetImportModal"
      title="استيراد جدول Geodesia / Trimble (Excel)"
      size="xl"
      scrollable
      hide-footer
      no-enforce-focus
      no-fade
      modal-class="gis-glass-modal coordinates-survey-import-modal"
      content-class="gis-glass-modal__content"
      body-class="gis-glass-modal__body"
      header-class="gis-glass-modal__header"
      @show="onGeodesiaSheetImportModalShow"
      @shown="onGeodesiaSheetImportModalShown"
      @hidden="onGeodesiaSheetImportModalHidden"
    >
      <b-form-group label="اختر ملف Excel">
        <b-form-file
          v-model="geodesiaSheetFile"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          placeholder="اختر ملف .xlsx أو .xls"
          drop-placeholder="اسحب الملف هنا"
          :disabled="importingGeodesiaSheet"
          @input="onGeodesiaSheetFileInput"
        />
        <small class="text-muted">الصيغ المدعومة: .xlsx و .xls فقط</small>
      </b-form-group>

      <div
        v-if="importingGeodesiaSheet"
        class="text-center my-3"
      >
        <b-spinner class="mb-2" />
        <p class="text-muted mb-0">
          جاري رفع الملف ومعالجته...
        </p>
      </div>

      <b-alert
        v-if="geodesiaSheetImportError"
        variant="danger"
        show
        class="mt-2 mb-0"
      >
        {{ geodesiaSheetImportError }}
      </b-alert>

      <div
        v-if="geodesiaSheetImportResult"
        class="mt-3"
      >
        <b-alert
          :variant="Number(geodesiaSheetImportResult.errors_count || 0) > 0 ? 'warning' : 'success'"
          show
        >
          <p class="mb-1">
            <strong>اسم الملف:</strong> {{ geodesiaSheetImportResult.file_name }}
          </p>
          <p class="mb-1">
            <strong>مقروءة:</strong> {{ geodesiaSheetImportResult.parsed_points_count }}
            — <strong>محفوظة:</strong> {{ geodesiaSheetImportResult.stored_points_count }}
            <span v-if="Number(geodesiaSheetImportResult.errors_count || 0) > 0">
              — <strong>أخطاء:</strong> {{ geodesiaSheetImportResult.errors_count }}
            </span>
          </p>
        </b-alert>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="importingGeodesiaSheet"
          @click="showGeodesiaSheetImportModal = false"
        >
          إغلاق
        </b-button>
        <b-button
          variant="primary"
          :disabled="!geodesiaSheetFile || importingGeodesiaSheet"
          @click="submitGeodesiaSheetImport"
        >
          <b-spinner
            v-if="importingGeodesiaSheet"
            small
            class="mr-50"
          />
          استيراد
        </b-button>
      </div>
    </b-modal>
    <div
      ref="geodesiaFileInputsHost"
      class="d-none"
    >
    <input
      ref="geodesiaJxlFileInput"
      type="file"
      accept=".jxl"
      class="d-none"
      @change="onGeodesiaSurveyFileSelected('jxl', $event)"
    >
    <input
      ref="geodesiaRw5FileInput"
      type="file"
      accept=".rw5"
      class="d-none"
      @change="onGeodesiaSurveyFileSelected('rw5', $event)"
    >
    <input
      ref="geodesiaRawFileInput"
      type="file"
      accept=".raw"
      class="d-none"
      @change="onGeodesiaSurveyFileSelected('raw', $event)"
    >
    <input
      ref="geodesiaKmzFileInput"
      type="file"
      accept=".kmz"
      class="d-none"
      @change="onKmzFileSelected"
    >
    <input
      ref="geodesiaKmlFileInput"
      type="file"
      accept=".kml"
      class="d-none"
      @change="onKmlFileSelected"
    >
    <input
      ref="geodesiaDxfFileInput"
      type="file"
      accept=".dxf"
      class="d-none"
      @change="onDxfFileSelected"
    >
    <input
      ref="geodesiaHtmlFileInput"
      type="file"
      accept=".html,.htm"
      class="d-none"
      @change="onHtmlFileSelected"
    >
    <input
      ref="geodesiaShpFileInput"
      type="file"
      accept=".zip"
      class="d-none"
      @change="onShpFileSelected"
    >
    </div>
    <b-modal
      v-model="showGeodesiaPolygonModal"
      :title="geodesiaPolygonModalTitle"
      scrollable
      hide-footer
      :no-close-on-backdrop="creatingGeodesiaPolygon"
      @hidden="resetGeodesiaPolygonModal"
    >
      <p class="text-muted small mb-1">
        اختر 3 نقاط على الأقل. سيتم ربطها بالترتيب حسب رقم النقطة.
      </p>
      <div class="d-flex flex-wrap mb-1">
        <b-button
          size="sm"
          variant="outline-secondary"
          class="mr-50"
          @click="selectAllGeodesiaPolygonPoints"
        >
          تحديد الكل
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="clearGeodesiaPolygonPointSelection"
        >
          إلغاء التحديد
        </b-button>
      </div>
      <div class="geodesia-polygon-point-select d-flex flex-wrap">
        <b-form-checkbox
          v-for="(point, index) in geodesiaSheetPoints"
          :key="'geo-poly-' + index"
          v-model="selectedGeodesiaPointIndexes"
          :value="index"
          class="geodesia-polygon-point-item"
        >
          نقطة {{ point.displayNumber }}
          <small
            v-if="point.label && String(point.label) !== String(point.displayNumber)"
            class="text-muted"
          >
            — {{ point.label }}
          </small>
        </b-form-checkbox>
      </div>
      <b-alert
        v-if="geodesiaPolygonSelectionError"
        variant="warning"
        show
        class="mt-1 mb-0"
      >
        {{ geodesiaPolygonSelectionError }}
      </b-alert>
      <p class="text-muted small mt-1 mb-0">
        المحدد: {{ selectedGeodesiaPointIndexes.length }} / {{ geodesiaSheetPoints.length }} نقطة
      </p>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="creatingGeodesiaPolygon"
          @click="showGeodesiaPolygonModal = false"
        >
          إلغاء
        </b-button>
        <b-button
          variant="primary"
          :disabled="!canConfirmGeodesiaPolygon || creatingGeodesiaPolygon"
          @click="confirmGeodesiaPolygonFromSelection"
        >
          <b-spinner
            v-if="creatingGeodesiaPolygon"
            small
            class="mr-50"
          />
          إنشاء المضلع
        </b-button>
      </div>
    </b-modal>
    <b-modal
      v-model="showShapeSchemaModal"
      title="Generate Shape ZIP"
      ok-title="Generate"
      cancel-title="Cancel"
      :ok-disabled="downloadingShapeZip || shapeSchemasLoading"
      @shown="loadShapeSchemasForExport"
      @ok="confirmShapeZipDownload"
    >
      <b-form-group label="Schema (Optional)">
        <b-form-select
          v-model="selectedShapeSchemaId"
          :options="shapeSchemaOptions"
          :disabled="shapeSchemasLoading || downloadingShapeZip"
        />
      </b-form-group>
      <b-form-group label="Type (Optional)">
        <b-form-select
          v-model="type"
          :options="typeOptions"
          :disabled="downloadingShapeZip"
        />
      </b-form-group>
      <small class="text-muted">
        Leave empty to generate using default schema behavior.
      </small>
    </b-modal>
  </div>
</template>

<script>
import {
  BCollapse,
  BCard,
  BButton,
  BTabs,
  BTab,
  BRow,
  BCol,
  BTable,
  BSpinner,
  BModal,
  BFormGroup,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BAlert,
  VBTooltip,
  BFormTextarea,
} from 'bootstrap-vue'
import CoordinatesMap from '@/views/modules/projects/CoordinatesMap.vue'
import CoordinatesMapGoogle from '@/views/modules/projects/CoordinatesMapGoogle.vue'
import MapProjectLocationsPanel from '@/views/modules/projects/Components/MapProjectLocationsPanel.vue'
import MapFullscreenSurveyDock from '@/views/modules/projects/Components/MapFullscreenSurveyDock.vue'
import MapFloatPanel from '@/views/modules/projects/Components/MapFloatPanel.vue'
import { mapGetters } from 'vuex'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import Projects from '@/api/projects/projects'
import geodesiaApi from '@/api/geodesia/geodesia'
import { isClientPreviewType, previewPointsFromFile } from '@/utils/filePreview'
import projectShapeSchemasApi from '@/api/settings/projectShapeSchemas'
import html2canvas from 'html2canvas'
import Ripple from 'vue-ripple-directive'
import {
  DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
  determineAdministrativeLocation,
  emptyAdministrativeDetermineRows,
  getDetermineAdministrativeBoundaryErrorMessage,
} from '@/utils/administrativeBoundaries'
import { getSurveyPointColorHex } from '@/utils/surveyPointColors'

const DXF_GEOMETRY_OPTIONS = [
  { value: 'points', label: 'نقاط' },
  { value: 'polygons', label: 'مضلعات' },
  { value: 'lines', label: 'خطوط' },
]

const DXF_LAYER_OPTIONS = [
  { value: 'jxl', label: 'JXL' },
  { value: 'raw', label: 'RAW' },
  { value: 'rw5', label: 'RW5' },
  { value: 'kml', label: 'KML' },
  { value: 'kmz', label: 'KMZ' },
  { value: 'geodesia_sheet', label: 'Geodesia Sheet' },
]

const DXF_LAYER_LABELS = DXF_LAYER_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label
  return acc
}, {})

const KML_HEADER_NOTE_STORAGE_KEY = 'kmlExportHeaderNote'
const KML_HEADER_NOTE_MAX_LENGTH = 2000
const KML_HEADER_NOTE_DEFAULT = 'لزوم استكمال إجراءات التعامل طبقاً لقانون رقم 144 لسنة 2017 في شأن قواعد التصرف في أملاك الدولة'

function mapToolbarTooltip(title, placement = 'bottom') {
  return {
    title,
    placement,
    trigger: 'hover',
    container: 'body',
    boundary: 'window',
    fallbackPlacement: 'flip',
    offset: 8,
    noninteractive: true,
    delay: { show: 150, hide: 0 },
  }
}

function mapPopupToolbarTooltip(title) {
  return mapToolbarTooltip(title, 'top')
}

function createDxfExportCheckedState(options) {
  return options.reduce((acc, opt) => {
    acc[opt.value] = false
    return acc
  }, {})
}

const FULLSCREEN_SURVEY_PREVIEW_ITEMS = [
  
  {
    key: 'geodesia_sheet',
    label: 'Geodesia Sheet',
    src: require('@/assets/images/icons/TrimbleIcon.jpeg'),
    title: 'عرض نقاط geodesia sheet على الخريطة',
    hideTitle: 'إخفاء نقاط geodesia sheet من الخريطة',
    uploadTitle: 'رفع أو تحديث Geodesia Sheet',
  },
  {
    key: 'jxl',
    label: 'JXL',
    src: require('@/assets/images/icons/jxl.svg'),
    title: 'عرض نقاط JXL على الخريطة',
    hideTitle: 'إخفاء نقاط JXL من الخريطة',
    uploadTitle: 'رفع أو تحديث JXL',
  },
  {
    key: 'dxf',
    label: 'AutoCAD DXF',
    src: require('@/assets/images/icons/autoCadIcon.jpeg'),
    title: 'عرض نقاط DXF على الخريطة',
    hideTitle: 'إخفاء نقاط DXF من الخريطة',
    uploadTitle: 'رفع أو تحديث DXF',
  },
  {
    key: 'html',
    label: 'HTML',
    src: require('@/assets/images/icons/HTMLIcon.jpeg'),
    title: 'عرض نقاط HTML على الخريطة',
    hideTitle: 'إخفاء نقاط HTML من الخريطة',
    uploadTitle: 'رفع أو تحديث HTML',
  },
  {
    key: 'kml',
    label: 'KML',
    src: require('@/assets/images/icons/KMLIcon.jpeg'),
    title: 'عرض نقاط KML على الخريطة',
    hideTitle: 'إخفاء نقاط KML من الخريطة',
    uploadTitle: 'رفع أو تحديث KML',
  },
  {
    key: 'kmz',
    label: 'KMZ',
    src: require('@/assets/images/icons/kmz.png'),
    title: 'عرض نقاط KMZ على الخريطة',
    hideTitle: 'إخفاء نقاط KMZ من الخريطة',
    uploadTitle: 'رفع أو تحديث KMZ',
  },
  {
    key: 'shp',
    label: 'SHP',
    src: require('@/assets/images/icons/SHPIcon.jpeg'),
    title: 'عرض نقاط SHP على الخريطة',
    hideTitle: 'إخفاء نقاط SHP من الخريطة',
    uploadTitle: 'رفع أو تحديث Shapefile',
  },
  {
    key: 'raw',
    label: 'RAW',
    src: require('@/assets/images/icons/RawData.png'),
    title: 'عرض نقاط RAW على الخريطة',
    hideTitle: 'إخفاء نقاط RAW من الخريطة',
    uploadTitle: 'رفع أو تحديث RAW',
  },
  {
    key: 'rw5',
    label: 'RW5',
    src: require('@/assets/images/icons/rw5.webp'),
    title: 'عرض نقاط RW5 على الخريطة',
    hideTitle: 'إخفاء نقاط RW5 من الخريطة',
    uploadTitle: 'رفع أو تحديث RW5',
  },
]

export default {
  name: 'CoordinateDisplayCard',
  components: {
    BCollapse,
    BCard,
    BButton,
    BTabs,
    BTab,
    BRow,
    BCol,
    FeatherIcon,
    BTable,
    BSpinner,
    BModal,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormFile,
    BAlert,
    BFormTextarea,
    CoordinatesMap,
    CoordinatesMapGoogle,
    MapProjectLocationsPanel,
    MapFullscreenSurveyDock,
    MapFloatPanel,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    /** Force an engine; when null the user's saved choice is used (ArcGIS by default). */
    showGoogleMap: {
      type: Boolean,
      default: null,
    },
    coordinate: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      default: 'إحداثيات الموقع',
    },
    subtitle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'MapPinIcon',
    },
    iconVariant: {
      type: String,
      default: 'bg-primary-light',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    showTabs: {
      type: Boolean,
      default: true,
    },
    showMapButton: {
      type: Boolean,
      default: true,
    },
    noCoordinatesMessage: {
      type: String,
      default: '',
    },
    /** Numeric project location (parcel) id — required for JXL download */
    projectLocationId: {
      type: [Number, String],
      default: null,
    },
    /** Project surveying code (survey_coding / surveying_code) — used as JXL filename, same sanitization as backend */
    surveyingCode: {
      type: [String, Number],
      default: '',
    },
    projectId: {
      type: [Number, String],
      default: null,
    },
    /** All project locations — used to draw sibling parcels on the map (read-only). */
    projectLocations: {
      type: Array,
      default: () => [],
    },
    /**
     * Explicit sibling locations for the map. Each item: { locationId, coordinates, label? }.
     * When empty, siblings are derived from projectLocations.
     */
    otherProjectLocations: {
      type: Array,
      default: () => [],
    },
    /** Coordinate type used when deriving sibling polygons from projectLocations. */
    mapSiblingCoordinatesType: {
      type: String,
      default: 'technical_office',
    },
    /** Show map even when fewer than 3 coordinates (empty map, draw mode, user location center). */
    alwaysShowMap: {
      type: Boolean,
      default: false,
    },
    /** Show map control to save drawn polygon as a new project location. */
    enableSaveAsNewLocation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    esriMapSwitchChecked() {
      return this.switchingMapEngine ? !this.pendingMapEngineGoogle : !this.useGoogleMap
    },
    surveyDockPanelClass() {
      return this.mapToolbarInFullscreen
        ? 'map-fullscreen-survey-float is-fullscreen-visible'
        : 'map-fullscreen-survey-float'
    },
    surveyDockLayoutKey() {
      return this.mapToolbarInFullscreen ? 'fullscreen' : 'inline'
    },
    mapEngineSwitchLoaderText() {
      return this.pendingMapEngineGoogle
        ? 'جاري تحميل خريطة Google...'
        : 'جاري تحميل خريطة Esri...'
    },
    fullscreenSurveyPreviewItems() {
      return FULLSCREEN_SURVEY_PREVIEW_ITEMS.map(item => ({
        ...item,
        color: getSurveyPointColorHex(item.key),
      }))
    },
    fullscreenSurveyFileFlags() {
      return FULLSCREEN_SURVEY_PREVIEW_ITEMS.reduce((acc, item) => {
        acc[item.key] = this.hasFullscreenSurveyFile(item.key)
        return acc
      }, {})
    },
    fullscreenSurveyActiveKeys() {
      return this.activeSurveyPreviewTypes
    },
    fullscreenSurveyLoadingKey() {
      if (this.previewingGeodesiaSheet || this.importingGeodesiaSheet) return 'geodesia_sheet'
      if (this.previewingJxlSurvey) return 'jxl'
      if (this.importingGeodesiaSurveyFile && this.geodesiaImportingType) {
        return this.geodesiaImportingType
      }
      return this.previewingProjectSurveyFileType || null
    },
    fullscreenSurveyBusy() {
      return this.importingGeodesiaSurveyFile || this.importingGeodesiaSheet
    },
    showInlineMap() {
      if (this.alwaysShowMap) return true
      const coords = Array.isArray(this.coordinate)
        ? this.coordinate
        : (this.coordinate ? [this.coordinate] : [])
      return coords.length > 2
    },
    hasGeodesiaSheet() {
      if (this.project && this.project.has_geodesia_sheet != null) {
        return !!this.project.has_geodesia_sheet
      }
      return this.localHasGeodesiaSheet
    },
    hasJxl() {
      if (this.project && this.project.has_jxl != null) {
        return !!this.project.has_jxl
      }
      return this.localHasJxl
    },
    geodesiaSheetPreviewActiveForSheet() {
      return this.isSurveyPreviewTypeActive('geodesia_sheet')
    },
    jxlPreviewActive() {
      return this.isSurveyPreviewTypeActive('jxl')
    },
    geodesiaPolygonModalTitle() {
      return this.activeSurveyImportType === 'jxl'
        ? 'اختر نقاط JXL لإنشاء المضلع'
        : 'اختر نقاط Geodesia لإنشاء المضلع'
    },
    canExportGeodesiaSheetKml() {
      const file = this.geodesiaSheetFileRecord
      if (!file || file.file_type !== 'geodesia_sheet') return false
      const fileId = Number(file.id)
      if (!Number.isFinite(fileId) || fileId <= 0) return false
      return Number(file.points_count || 0) > 0
    },
    canConfirmGeodesiaPolygon() {
      return this.selectedGeodesiaPointIndexes.length >= 3
    },
    mapDisplayCoordinates() {
      if (Array.isArray(this.draftMapCoordinates)) {
        return this.draftMapCoordinates
      }
      return Array.isArray(this.coordinate)
        ? this.coordinate
        : (this.coordinate ? [this.coordinate] : [])
    },
    showNoCoordinatesHint() {
      if (!this.alwaysShowMap || !this.noCoordinatesMessage) return false
      const coords = Array.isArray(this.coordinate)
        ? this.coordinate
        : (this.coordinate ? [this.coordinate] : [])
      return coords.length < 3
    },
    isProjectDetailsRoute() {
      return this.$route.path.includes('project-details')
    },
    id() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    ...mapGetters({
      loadExportKml: 'projects/loadExportKml',
      loadExportExcel: 'projects/loadExportExcel',
      project: 'projects/project',
    }),
    resolvedProjectId() {
      const fromProp = this.projectId
      if (fromProp !== null && fromProp !== undefined && fromProp !== '') return Number(fromProp)
      const fromRoute = this.$route?.params?.id
      if (fromRoute !== null && fromRoute !== undefined && fromRoute !== '') return Number(fromRoute)
      return null
    },
    canViewAdministrativeBoundaries() {
      try {
        return typeof this.hasPermission === 'function'
          && this.hasPermission('view administrative_boundaries')
      } catch (e) {
        return false
      }
    },
    administrativeBoundaryRows() {
      return this.administrativeBoundaryResult?.rows || emptyAdministrativeDetermineRows()
    },
    // selectedAdministrativeBoundaryRows() {
    //   return this.selectedAdministrativeBoundaryResult?.rows || emptyAdministrativeDetermineRows()
    // },
    activeAdministrativeBoundaryHighlight() {
      const active = this.administrativeBoundaryResult
      return active?.geometry ? active : null
    },
    kmlActionLoading() {
      return this.loadExportKml || this.downloadingProjectKml
    },
    canDownloadProjectKml() {
      const id = this.resolvedProjectId
      return Number.isFinite(id) && id > 0
    },
    kmlDownloadScopeOptions() {
      return [
        { value: 'project', text: 'كل المشروع / Entire project' },
        { value: 'location', text: 'موقع محدد / Specific location' },
      ]
    },
    kmlLocationOptions() {
      const options = []
      const seen = new Set()
      const source = Array.isArray(this.projectLocations) ? this.projectLocations : []

      source.forEach((loc, index) => {
        const id = this.toPositiveId(loc?.id ?? loc?.location_id)
        if (!id || seen.has(id)) return
        seen.add(id)
        const rawName = loc?.land_number || loc?.location_name || loc?.location_no || loc?.surveying_code || loc?.code || ''
        const cleanName = String(rawName || '').trim()
        const suffix = cleanName ? ` - ${cleanName}` : ''
        options.push({
          value: id,
          text: `موقع ${index + 1} (${id})${suffix} / Location ${index + 1} (${id})${suffix}`,
        })
      })

      const currentLocationId = this.toPositiveId(this.projectLocationId)
      if (currentLocationId && !seen.has(currentLocationId)) {
        options.unshift({
          value: currentLocationId,
          text: `الموقع الحالي (${currentLocationId}) / Current location (${currentLocationId})`,
        })
      }

      return options
    },
    canConfirmKmlDownload() {
      if (this.kmlHeaderNoteLength > KML_HEADER_NOTE_MAX_LENGTH) return false
      if (this.kmlDownloadScope === 'project') {
        return this.canDownloadProjectKml
      }
      return !!this.toPositiveId(this.selectedKmlLocationId)
    },
    kmlHeaderNoteLength() {
      return String(this.kmlHeaderNote || '').length
    },
    canDownloadShapeZip() {
      const id = this.resolvedProjectId
      return Number.isFinite(id) && id > 0
    },
    coordinateFields() {
      return [
        { key: 'index', label: '#', thStyle: { width: '50px' } },
        { key: 'latitude', label: 'Latitude' },
        { key: 'longitude', label: 'Longitude' },
        // { key: 'dms_latitude', label: 'DMS Latitude' },
        // { key: 'dms_longitude', label: 'DMS Longitude' },
        // { key: 'etm_east', label: 'ETM East' },
        // { key: 'etm_north', label: 'ETM North' },
        { key: 'utm_east', label: 'UTM East' },
        { key: 'utm_north', label: 'UTM North' },
        // { key: 'coordinate_system', label: 'System', sortable: true },
        // { key: 'accuracy', label: 'Accuracy' },
        // { key: 'actions', label: 'Actions', thStyle: { width: '120px' } }
      ]
    },
    hasCoordinates() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return (
        coord
        && (coord.latitude
          || coord.longitude
          || coord.utm_east
          || coord.utm_north
          || coord.etm_east
          || coord.etm_north
          || coord.x
          || coord.y)
      )
    },
    hasDecimalDegrees() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(coord && coord.latitude && coord.longitude)
    },
    hasDMS() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(coord && coord.dms_latitude && coord.dms_longitude)
    },
    hasUTM() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(coord && coord.utm_east && coord.utm_north)
    },
    hasETM() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(coord && coord.etm_east && coord.etm_north)
    },
    hasWebMercator() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(coord && coord.x && coord.y)
    },
    hasAdditionalInfo() {
      const coord = Array.isArray(this.coordinate) ? this.coordinate[0] : this.coordinate
      return !!(
        coord
        && (coord.coordinate_system
          || coord.accuracy
          || coord.recorded_at)
      )
    },
    showJxlDownload() {
      const id = this.projectLocationId
      return id !== null && id !== undefined && id !== ''
    },
    canCreateMapLocation() {
      return !!this.enableSaveAsNewLocation
        && typeof this.hasPermission === 'function'
        && this.hasPermission('edit projects')
    },
    otherLocationsForMap() {
      if (Array.isArray(this.otherProjectLocations) && this.otherProjectLocations.length) {
        return this.otherProjectLocations
          .map((entry, index) => {
            const coordinates = this.getValidMapCoordinates(entry?.coordinates)
            if (coordinates.length < 3) return null
            return {
              locationId: entry?.locationId ?? entry?.location_id ?? null,
              label: entry?.label || `موقع ${index + 1}`,
              coordinates,
            }
          })
          .filter(Boolean)
      }

      const currentId = this.projectLocationId
      if (!Array.isArray(this.projectLocations) || this.projectLocations.length < 2) {
        return []
      }

      return this.projectLocations
        .filter(loc => {
          if (!loc) return false
          if (currentId === null || currentId === undefined || currentId === '') return true
          return String(loc.id) !== String(currentId)
        })
        .map((loc, index) => {
          const coordinates = this.getValidMapCoordinates(this.getLocationCoordinatesForMap(loc))
          if (coordinates.length < 3) return null
          return {
            locationId: loc.id,
            label: this.getOtherLocationMapLabel(loc, index),
            coordinates,
          }
        })
        .filter(Boolean)
    },
    /** Basename + .jxl from surveying code (invalid filename chars → _), matches server export rule */
    jxlFilenameFromSurveyingCode() {
      const raw = this.surveyingCode
      if (raw === '' || raw === null || raw === undefined || String(raw).trim() === '') return ''
      const base = String(raw).trim().replace(/[\\/:*?"<>|]/g, '_')
      if (!base) return ''
      return /\.jxl$/i.test(base) ? base : `${base}.jxl`
    },
    shapeSchemaOptions() {
      const options = [{ value: null, text: 'Default (no schema selected)' }]
      this.shapeSchemas.forEach(schema => {
        options.push({
          value: schema.id,
          text: schema.name,
        })
      })
      return options
    },
    dxfExportSelectedGeometryTypes() {
      return DXF_GEOMETRY_OPTIONS
        .filter(opt => this.dxfExportGeometryChecked[opt.value])
        .map(opt => opt.value)
    },
    dxfExportSelectedSourceLayers() {
      return DXF_LAYER_OPTIONS
        .filter(opt => this.dxfExportSourceLayersChecked[opt.value])
        .map(opt => opt.value)
    },
    canConfirmDxfExport() {
      return this.dxfExportSelectedGeometryTypes.length > 0
        && this.dxfExportSelectedSourceLayers.length > 0
    },
    dxfExportLocalStorageKey() {
      const userId = this.$store?.state?.users?.auth?.id
      return userId ? `project-dxf-export-prefs-${userId}` : 'project-dxf-export-prefs'
    },
    filteredCoordinates() {
      // Normalize coordinate to always be an array
      let coordinates = []

      if (Array.isArray(this.coordinate)) {
        coordinates = this.coordinate
      } else if (this.coordinate && typeof this.coordinate === 'object') {
        // If it's a single coordinate object, wrap it in an array
        coordinates = [this.coordinate]
      }

      // Remove the last coordinate if there's more than one
      //if (coordinates.length > 1) {
       // return coordinates.slice(0, -1)
      //}

      return coordinates
    },
    surveySiteUtmPoints() {
      return this.normalizeSketchUtmCoordinates(this.filteredCoordinates)
    },
    surveyHasSitePolygon() {
      return this.surveySiteUtmPoints.length >= 3
    },
    surveySiteMapKey() {
      return this.surveySiteUtmPoints.map(p => `${p.utmEast},${p.utmNorth}`).join('|')
    },
    surveySketchPatternIds() {
      const key = (this.surveySiteMapKey || 'x').replace(/[^a-zA-Z0-9_-]/g, '') || 'x'
      const sid = `coord-sketch-${key}`
      return {
        grid: `${sid}-grid`,
        hatch: `${sid}-hatch`,
      }
    },
    surveySiteCoordinateSketch() {
      const utmPoints = this.surveySiteUtmPoints
      if (utmPoints.length < 3) {
        return null
      }

      const padX = 14
      const padY = 14
      const width = 100
      const height = 100
      const drawWidth = width - padX * 2
      const drawHeight = height - padY * 2

      const { projectPoint, svgUnitsPerMeter } = this.createSketchMeterProjector(
        utmPoints,
        padX,
        padY,
        drawWidth,
        drawHeight,
      )

      const planar = utmPoints.map(projectPoint)
      const pointsStr = planar.map(p => `${p.x},${p.y}`).join(' ')
      const useMeterProjection = Number.isFinite(svgUnitsPerMeter) && svgUnitsPerMeter > 0

      const centroidX = planar.reduce((s, p) => s + p.x, 0) / planar.length
      const centroidY = planar.reduce((s, p) => s + p.y, 0) / planar.length

      const pointInPlanarPolygon = (x, y) => {
        let inside = false
        const n = planar.length
        for (let a = 0, b = n - 1; a < n; b = a++) {
          const xi = planar[a].x
          const yi = planar[a].y
          const xj = planar[b].x
          const yj = planar[b].y
          if ((yi > y) !== (yj > y)) {
            const dyij = yj - yi
            if (Math.abs(dyij) < 1e-12) continue
            const xCross = ((xj - xi) * (y - yi)) / dyij + xi
            if (x < xCross) inside = !inside
          }
        }
        return inside
      }

      const labelOutsidePolygon = (mx, my, px, py, mag) => {
        const tryMag = m => {
          const ox = px * m
          const oy = py * m
          const n1x = mx + ox
          const n1y = my + oy
          const n2x = mx - ox
          const n2y = my - oy
          const in1 = pointInPlanarPolygon(n1x, n1y)
          const in2 = pointInPlanarPolygon(n2x, n2y)
          if (!in1 && in2) return { lx: n1x, ly: n1y }
          if (in1 && !in2) return { lx: n2x, ly: n2y }
          if (!in1 && !in2) {
            const d1 = (n1x - centroidX) ** 2 + (n1y - centroidY) ** 2
            const d2 = (n2x - centroidX) ** 2 + (n2y - centroidY) ** 2
            return d1 >= d2 ? { lx: n1x, ly: n1y } : { lx: n2x, ly: n2y }
          }
          let bump = m
          for (let k = 0; k < 10; k += 1) {
            bump *= 1.42
            const o1x = mx + px * bump
            const o1y = my + py * bump
            const o2x = mx - px * bump
            const o2y = my - py * bump
            if (!pointInPlanarPolygon(o1x, o1y)) return { lx: o1x, ly: o1y }
            if (!pointInPlanarPolygon(o2x, o2y)) return { lx: o2x, ly: o2y }
          }
          const o1x = mx + px * bump
          const o1y = my + py * bump
          const o2x = mx - px * bump
          const o2y = my - py * bump
          const d1 = (o1x - centroidX) ** 2 + (o1y - centroidY) ** 2
          const d2 = (o2x - centroidX) ** 2 + (o2y - centroidY) ** 2
          return d1 >= d2 ? { lx: o1x, ly: o1y } : { lx: o2x, ly: o2y }
        }
        return tryMag(mag)
      }

      const segments = []
      let sumEdgeM = 0
      let sumEdgePx = 0
      for (let i = 0; i < planar.length; i += 1) {
        const j = (i + 1) % planar.length
        const pa = planar[i]
        const pb = planar[j]
        const lengthM = this.utmDistanceM(utmPoints[i], utmPoints[j])
        const mx = (pa.x + pb.x) / 2
        const my = (pa.y + pb.y) / 2
        let dx = pb.x - pa.x
        let dy = pb.y - pa.y
        const plen = Math.sqrt(dx * dx + dy * dy) || 1
        dx /= plen
        dy /= plen
        const offsetMag = Math.min(10, Math.max(7.2, plen * 0.18))
        const px = -dy
        const py = dx
        let { lx, ly } = labelOutsidePolygon(mx, my, px, py, offsetMag)
        for (let g = 0; g < 12 && pointInPlanarPolygon(lx, ly); g += 1) {
          const vx = lx - mx
          const vy = ly - my
          lx = mx + vx * 1.38
          ly = my + vy * 1.38
        }
        let angleDeg = (Math.atan2(pb.y - pa.y, pb.x - pa.x) * 180) / Math.PI
        if (angleDeg > 90) angleDeg -= 180
        if (angleDeg < -90) angleDeg += 180
        segments.push({
          mx,
          my,
          lx,
          ly,
          lengthM,
          angleDeg: Math.round(angleDeg * 100) / 100,
        })
        sumEdgeM += lengthM
        sumEdgePx += plen
      }

      const mPerViewUnit = useMeterProjection
        ? 1 / svgUnitsPerMeter
        : (sumEdgePx > 0 ? sumEdgeM / sumEdgePx : 1)
      const maxEdgeM = segments.reduce((m, s) => Math.max(m, s.lengthM), 0)
      const niceScaleMeters = raw => {
        if (!Number.isFinite(raw) || raw <= 0) return 10
        const exp = Math.floor(Math.log10(raw))
        const pow10 = 10 ** exp
        const n = raw / pow10
        const nice = n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10
        return nice * pow10
      }

      let scaleBar = null
      if (segments.length && Number.isFinite(mPerViewUnit) && mPerViewUnit > 0) {
        const scaleM = niceScaleMeters(maxEdgeM * 0.32)
        let barW = scaleM / mPerViewUnit
        const maxBarW = 26
        const minBarW = 7
        barW = Math.min(maxBarW, Math.max(minBarW, barW))
        const actualM = barW * mPerViewUnit
        const label = Math.abs(actualM - Math.round(actualM)) < 0.08
          ? `${Math.round(actualM)} م`
          : `${actualM.toFixed(2)} م`
        scaleBar = {
          x1: 7,
          x2: 7 + barW,
          y: 93.2,
          label,
        }
      }

      const vertices = planar.map((p, i) => {
        let vx = centroidX - p.x
        let vy = centroidY - p.y
        const vlen = Math.sqrt(vx * vx + vy * vy) || 1
        vx /= vlen
        vy /= vlen
        // const r = Math.min(2.6, Math.max(1.9, 5.2 / Math.sqrt(planar.length)))
        // const r = 0.3
        const r = Math.min(0.5, Math.max(0.25, 1 / Math.sqrt(planar.length)))

        const labelPull = r + 3.4
        return {
          cx: p.x,
          cy: p.y,
          tx: p.x + vx * labelPull,
          ty: p.y + vy * labelPull,
          index: i + 1,
          r,
        }
      })

      return {
        pointsStr,
        segments,
        vertices,
        scaleBar,
      }
    },
  },
  data() {
    return {
      typeOptions: [
        { text: 'UTM', value: 'UTM' },
        { text: 'latLong', value: 'latLong' },
      ],
      showSketch: false,
      useGoogleMap: false,
      mapDrawHistory: [],
      mapDrawHistoryIndex: -1,
      mapDrawMoveActive: false,
      googleMapEngineMounted: false,
      arcgisMapEngineMounted: false,
      switchingMapEngine: false,
      pendingMapEngineGoogle: false,
      mapRenderKey: 0,
      showMapPopup: false,
      mapToolbarInFullscreen: false,
      mapFullscreenToolbarHidden: false,
      fullscreenToolbarTarget: null,
      mapFullscreenNotice: null,
      showCoordinatesTablePreview: false,
      showKmlDownloadModal: false,
      takingScreenshot: false,
      downloadingJxl: false,
      downloadingProjectKml: false,
      downloadingShapeZip: false,
      kmlDownloadScope: 'location',
      selectedKmlLocationId: null,
      kmlHeaderNote: '',
      KML_HEADER_NOTE_MAX_LENGTH,
      showDxfExportModal: false,
      exportingDxf: false,
      exportingJxlHtml: false,
      dxfExportValidationError: null,
      dxfGeometryOptions: DXF_GEOMETRY_OPTIONS,
      dxfLayerOptions: DXF_LAYER_OPTIONS,
      dxfExportGeometryChecked: createDxfExportCheckedState(DXF_GEOMETRY_OPTIONS),
      dxfExportSourceLayersChecked: createDxfExportCheckedState(DXF_LAYER_OPTIONS),
      dxfExportGeometrySelectAll: false,
      dxfExportLayersSelectAll: false,
      dxfExportIncludeCartouche: true,
      showShapeSchemaModal: false,
      shapeSchemasLoading: false,
      shapeSchemas: [],
      selectedShapeSchemaId: null,
      projectsApi: null,
      type: null,
      showGeodesiaSheetImportModal: false,
      geodesiaSheetFile: null,
      importingGeodesiaSheet: false,
      geodesiaSheetImportError: null,
      geodesiaSheetImportResult: null,
      previewingGeodesiaSheet: false,
      geodesiaSheetPreviewActive: false,
      geodesiaSheetFileRecord: null,
      loadingGeodesiaSheetFileMeta: false,
      downloadingGeodesiaSheetKml: false,
      localHasGeodesiaSheet: false,
      geodesiaSheetPoints: [],
      allGeodesiaSheetPoints: [],
      creatingGeodesiaPolygon: false,
      showGeodesiaPolygonModal: false,
      selectedGeodesiaPointIndexes: [],
      geodesiaPolygonSelectionError: null,
      draftMapCoordinates: null,
      importingGeodesiaSurveyFile: false,
      geodesiaImportingType: null,
      previewingJxlSurvey: false,
      previewingProjectSurveyFileType: null,
      localHasJxl: false,
      activeSurveyImportType: null,
      activeSurveyPreviewTypes: [],
      fullscreenSurveyReplaceMessage: '',
      fullscreenSurveyConfirmLabel: '',
      inlineMapVisibilityObserver: null,
      administrativeBoundariesYear: DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
      loadingAdministrativeBoundary: false,
      administrativeBoundaryResult: null,
      administrativeBoundaryError: null,
      loadingSelectedAdministrativeBoundary: false,
      selectedAdministrativeBoundaryResult: null,
      selectedAdministrativeBoundaryError: null,
      clickedMapPoint: null,
      determineBoundaryRequestId: 0,
      determineSelectedBoundaryRequestId: 0,
    }
  },
  watch: {
    showGoogleMap: {
      immediate: true,
      handler(prop) {
        const value = typeof prop === 'boolean' ? prop : this.readMapEnginePreference() === 'google'
        this.useGoogleMap = value
        if (value) this.googleMapEngineMounted = true
        else this.arcgisMapEngineMounted = true
      },
    },
    useGoogleMap(val) {
      if (val) this.googleMapEngineMounted = true
      else this.arcgisMapEngineMounted = true
      if (this.geodesiaSheetPreviewActive) {
        this.geodesiaSheetPreviewActive = false
      }
      this.activeSurveyPreviewTypes = []
      this.$nextTick(() => {
        this.getActiveMapRef()?.emitDrawHistorySync?.()
        this.ensureFullscreenMapFitsAfterEngineSwitch()
        if (this.activeAdministrativeBoundaryHighlight) {
          setTimeout(() => {
            this.highlightMatchedAdministrativeBoundaryOnMaps(this.activeAdministrativeBoundaryHighlight)
          }, 400)
        } else {
          this.determineProjectAdministrativeBoundary()
        }
      })
    },
    showInlineMap: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.setupInlineMapVisibilityObserver()
            this.focusInlineMapView()
            this.determineProjectAdministrativeBoundary()
          })
        }
      },
      immediate: true,
    },
    projectLocationId() {
      this.draftMapCoordinates = null
      const normalizedLocationId = this.toPositiveId(this.projectLocationId)
      if (normalizedLocationId) {
        this.selectedKmlLocationId = normalizedLocationId
        this.kmlDownloadScope = 'location'
      }
    },
    hasGeodesiaSheet: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadGeodesiaSheetFileRecord()
        } else {
          this.geodesiaSheetFileRecord = null
        }
      },
    },
    resolvedProjectId() {
      if (this.hasGeodesiaSheet) {
        this.loadGeodesiaSheetFileRecord()
      }
      this.clearSelectedAdministrativeBoundary()
      this.determineProjectAdministrativeBoundary()
    },
  },
  created() {
    this.projectsApi = new Projects()
    const normalizedLocationId = this.toPositiveId(this.projectLocationId)
    if (normalizedLocationId) {
      this.selectedKmlLocationId = normalizedLocationId
    } else if (this.kmlLocationOptions.length) {
      this.selectedKmlLocationId = this.kmlLocationOptions[0].value
    } else {
      this.kmlDownloadScope = 'project'
    }
  },
  mounted() {
    this.setupInlineMapVisibilityObserver()
    this.determineProjectAdministrativeBoundary()
    this.bindMapToolbarFullscreenListeners()
  },
  beforeDestroy() {
    this.teardownInlineMapVisibilityObserver()
    this.unbindMapToolbarFullscreenListeners()
    this.stopFullscreenAlertWatch()
    this.clearMapFullscreenNotice()
    this.restoreOverlayAlertsFromFullscreen()
    this.restoreMapToolbarsFromFullscreen()
    this.restoreGeodesiaFileInputsHost()
    this.resolveFullscreenSurveyReplace(false)
  },
  methods: {
    mapToolbarTooltip,
    mapPopupToolbarTooltip,
    mapEnginePreferenceKey() {
      const userId = this.$store?.state?.users?.auth?.id
      return userId ? `map-engine-preference-${userId}` : 'map-engine-preference'
    },
    readMapEnginePreference() {
      try {
        return window.localStorage.getItem(this.mapEnginePreferenceKey()) === 'google' ? 'google' : 'arcgis'
      } catch (e) {
        return 'arcgis'
      }
    },
    saveMapEnginePreference(engine) {
      try {
        window.localStorage.setItem(this.mapEnginePreferenceKey(), engine === 'google' ? 'google' : 'arcgis')
      } catch (e) {
        // storage unavailable (private mode)
      }
    },
    onMapDrawHistorySync(payload, fromGoogle = this.useGoogleMap) {
      if (!!fromGoogle !== !!this.useGoogleMap) return
      this.mapDrawHistory = Array.isArray(payload?.entries) ? payload.entries : []
      this.mapDrawHistoryIndex = Number.isInteger(payload?.index) ? payload.index : -1
      this.mapDrawMoveActive = !!payload?.moveActive
    },
    onMapDrawMove() {
      this.getActiveMapRef()?.toggleSketchTool?.('move')
    },
    onMapDrawUndo() {
      this.getActiveMapRef()?.undoDrawAction?.()
    },
    onMapDrawRedo() {
      this.getActiveMapRef()?.redoDrawAction?.()
    },
    onMapDrawJump(index) {
      this.getActiveMapRef()?.jumpDrawHistory?.(index)
    },
    isSurveyPreviewTypeActive(key) {
      return this.activeSurveyPreviewTypes.includes(key)
    },
    isFullscreenSurveyPreviewActive(key) {
      return this.isSurveyPreviewTypeActive(key)
    },
    hasFullscreenSurveyFile(key) {
      const normalized = String(key || '').toLowerCase()
      if (normalized === 'geodesia_sheet') return this.hasGeodesiaSheet
      if (normalized === 'jxl') return this.hasJxl
      const flag = this.getSurveyFilePresenceFlag(normalized)
      if (this.project && this.project[flag] != null) return !!this.project[flag]
      if (['kmz', 'kml', 'dxf', 'html', 'shp'].includes(normalized)) {
        return !!(this.project && this.project.has_jxl)
      }
      return false
    },
    getSurveyFilePresenceFlag(type) {
      const flagMap = {
        geodesia_sheet: 'has_geodesia_sheet',
        jxl: 'has_jxl',
        rw5: 'has_rw5',
        raw: 'has_raw',
        kmz: 'has_kmz',
        kml: 'has_kml',
        dxf: 'has_dxf',
        html: 'has_html',
        shp: 'has_shp',
      }
      return flagMap[String(type || '').toLowerCase()] || null
    },
    isFullscreenSurveyPreviewLoading(key) {
      return this.fullscreenSurveyLoadingKey === key
    },
    isFullscreenSurveyPreviewDisabled(key) {
      return this.fullscreenSurveyBusy || this.isFullscreenSurveyPreviewLoading(key)
    },
    getFullscreenSurveyPreviewTitle(item) {
      if (!item) return ''
      if (!this.hasFullscreenSurveyFile(item.key)) {
        return `لا يوجد ملف ${item.label} — اضغط للرفع`
      }
      return this.isFullscreenSurveyPreviewActive(item.key)
        ? (item.hideTitle || item.title)
        : item.title
    },
    onFullscreenSurveyPreviewClick(key) {
      if (this.isFullscreenSurveyPreviewDisabled(key)) return
      if (!this.hasFullscreenSurveyFile(key)) {
        this.onFullscreenSurveyUploadClick(key)
        return
      }
      if (key === 'geodesia_sheet') {
        this.handleGeodesiaSheetPreviewToggle()
        return
      }
      if (key === 'jxl') {
        this.handleJxlPreviewToggle()
        return
      }
      if (this.isFullscreenSurveyPreviewActive(key)) {
        this.clearImportedPointsOnMaps(key)
        this.notifyUser('success', 'تم إخفاء النقاط من الخريطة')
        return
      }
      this.handleProjectSurveyFilePreview(key)
    },
    async onFullscreenSurveyUploadClick(key) {
      if (this.fullscreenSurveyBusy) return
      const normalized = String(key || '').toLowerCase()
      if (normalized === 'geodesia_sheet') {
        const confirmationMessage = this.getGeodesiaReplaceConfirmation(normalized)
        if (confirmationMessage) {
          const confirmed = await this.confirmSurveyFileReplace(confirmationMessage)
          if (!confirmed) return
        }
        this.openGeodesiaSheetImportModalSafely()
        return
      }
      await this.handleGeodesiaImportClick(normalized)
    },
    openGeodesiaSheetImportModalSafely() {
      this.showGeodesiaSheetImportModal = true
      this.$nextTick(() => this.bringOverlayAlertsAboveFullscreen())
    },
    onGeodesiaSheetImportModalShow() {
      this.startFullscreenAlertWatch()
      this.bringOverlayAlertsAboveFullscreen()
    },
    onGeodesiaSheetImportModalShown() {
      this.bringOverlayAlertsAboveFullscreen()
      requestAnimationFrame(() => this.bringOverlayAlertsAboveFullscreen())
    },
    onGeodesiaSheetImportModalHidden() {
      this.resetGeodesiaSheetImport()
      if (!this.getFullscreenElement()) {
        this.stopFullscreenAlertWatch()
      }
    },
    confirmSurveyFileReplace(message) {
      if (this.getFullscreenElement()) {
        return this.promptFullscreenSurveyReplace(message)
      }
      return this.$bvModal.msgBoxConfirm(
        message,
        {
          title: 'تأكيد التحديث',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: 'نعم، تحديث',
          cancelTitle: 'إلغاء',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      ).then(value => !!value).catch(() => false)
    },
    confirmSurveyFileUpload(message) {
      if (this.getFullscreenElement()) {
        return this.promptFullscreenSurveyReplace(message, 'رفع وحفظ')
      }
      return this.$bvModal.msgBoxConfirm(
        message,
        {
          title: 'معاينة قبل الرفع',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'رفع وحفظ',
          cancelTitle: 'إلغاء',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      ).then(value => !!value).catch(() => false)
    },
    promptFullscreenSurveyReplace(message, confirmLabel = '') {
      this.resolveFullscreenSurveyReplace(false)
      return new Promise(resolve => {
        this._fullscreenSurveyReplaceResolver = resolve
        this.fullscreenSurveyReplaceMessage = message
        this.fullscreenSurveyConfirmLabel = confirmLabel
      })
    },
    resolveFullscreenSurveyReplace(value) {
      const resolver = this._fullscreenSurveyReplaceResolver
      this._fullscreenSurveyReplaceResolver = null
      this.fullscreenSurveyReplaceMessage = ''
      this.fullscreenSurveyConfirmLabel = ''
      if (typeof resolver === 'function') resolver(!!value)
    },
    restoreGeodesiaFileInputsHost() {
      const host = this.$refs.geodesiaFileInputsHost
      const parent = this.$el
      if (!host || !parent) return
      if (host.parentNode !== parent) parent.appendChild(host)
    },
    moveGeodesiaFileInputsIntoFullscreen(fullscreenEl) {
      const host = this.$refs.geodesiaFileInputsHost
      if (!host || !fullscreenEl) return
      if (host.parentNode !== fullscreenEl) fullscreenEl.appendChild(host)
    },
    bindMapToolbarFullscreenListeners() {
      this._onMapToolbarFullscreenChange = () => this.syncMapToolbarFullscreen()
      document.addEventListener('fullscreenchange', this._onMapToolbarFullscreenChange)
      document.addEventListener('webkitfullscreenchange', this._onMapToolbarFullscreenChange)
    },
    unbindMapToolbarFullscreenListeners() {
      if (!this._onMapToolbarFullscreenChange) return
      document.removeEventListener('fullscreenchange', this._onMapToolbarFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', this._onMapToolbarFullscreenChange)
      this._onMapToolbarFullscreenChange = null
    },
    getFullscreenElement() {
      return document.fullscreenElement
        || document.webkitFullscreenElement
        || document.mozFullScreenElement
        || document.msFullscreenElement
        || null
    },
    getFullscreenAlertSelectors() {
      return [
        '.Vue-Toastification__container',
        '.swal2-container',
        '.modal-backdrop',
        '#gis-add-location-modal',
        '#geodesia-sheet-import-modal',
        '.modal.gis-glass-modal',
        '.modal.coordinates-survey-import-modal',
      ]
    },
    bringOverlayAlertsAboveFullscreen() {
      const fsEl = this.getFullscreenElement()
      if (!fsEl) return
      this.getFullscreenAlertSelectors().forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (el && !fsEl.contains(el)) fsEl.appendChild(el)
        })
      })
    },
    restoreOverlayAlertsFromFullscreen() {
      this.getFullscreenAlertSelectors().forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          if (el && el.parentElement !== document.body) {
            document.body.appendChild(el)
          }
        })
      })
    },
    startFullscreenAlertWatch() {
      if (this._fullscreenAlertObserver) return
      this._fullscreenAlertObserver = new MutationObserver(() => {
        this.bringOverlayAlertsAboveFullscreen()
      })
      this._fullscreenAlertObserver.observe(document.body, { childList: true, subtree: true })
      this.bringOverlayAlertsAboveFullscreen()
    },
    stopFullscreenAlertWatch() {
      if (!this._fullscreenAlertObserver) return
      this._fullscreenAlertObserver.disconnect()
      this._fullscreenAlertObserver = null
    },
    clearMapFullscreenNotice() {
      if (this._mapFullscreenNoticeTimer) {
        window.clearTimeout(this._mapFullscreenNoticeTimer)
        this._mapFullscreenNoticeTimer = null
      }
      this.mapFullscreenNotice = null
    },
    showMapFullscreenNotice(type, message) {
      const text = String(message || '').trim()
      if (!text) return
      this.mapFullscreenNotice = {
        type: ['success', 'warning', 'error', 'info'].includes(type) ? type : 'info',
        message: text,
      }
      if (this._mapFullscreenNoticeTimer) {
        window.clearTimeout(this._mapFullscreenNoticeTimer)
      }
      this._mapFullscreenNoticeTimer = window.setTimeout(() => {
        this.mapFullscreenNotice = null
        this._mapFullscreenNoticeTimer = null
      }, 4500)
    },
    notifyUser(type, message) {
      const text = String(message || '').trim()
      if (!text) return
      if (this.getFullscreenElement()) {
        this.showMapFullscreenNotice(type, text)
        this.$nextTick(() => this.bringOverlayAlertsAboveFullscreen())
        requestAnimationFrame(() => this.bringOverlayAlertsAboveFullscreen())
        return
      }
      const toastFn = this.$toast?.[type]
      if (typeof toastFn === 'function') toastFn(text)
    },
    isElementInFullscreen(mapRef, fullscreenEl) {
      if (!fullscreenEl) return false
      const root = this.getActiveMapFullscreenRoot()
      if (root && (fullscreenEl === root || root.contains(fullscreenEl) || fullscreenEl.contains(root))) {
        return true
      }
      if (!mapRef) return false
      const mapEl = mapRef.$el || mapRef
      if (!mapEl || !mapEl.contains) return false
      return fullscreenEl === mapEl
        || mapEl.contains(fullscreenEl)
        || fullscreenEl.contains(mapEl)
    },
    moveToolbarInto(toolbar, host, target) {
      if (!toolbar || !host) return
      if (target) {
        if (toolbar.parentNode !== target) target.appendChild(toolbar)
        toolbar.classList.add('map-toolbar-actions--fullscreen')
        toolbar.classList.toggle('is-collapsed', this.mapFullscreenToolbarHidden)
        this.mapToolbarInFullscreen = true
        this.fullscreenToolbarTarget = toolbar === this.$refs.popupMapToolbar ? 'popup' : 'inline'
        return
      }
      if (toolbar.parentNode !== host) host.appendChild(toolbar)
      toolbar.classList.remove('map-toolbar-actions--fullscreen')
      toolbar.classList.remove('is-collapsed')
    },
    restoreMapToolbarsFromFullscreen() {
      this.moveToolbarInto(this.$refs.inlineMapToolbar, this.$refs.inlineMapToolbarHost, null)
      this.moveToolbarInto(this.$refs.popupMapToolbar, this.$refs.popupMapToolbarHost, null)
      this.restoreSurveyDocksFromFullscreen()
      this.restoreFullscreenToolbarShowFabs()
      this.mapToolbarInFullscreen = false
      this.mapFullscreenToolbarHidden = false
      this.fullscreenToolbarTarget = null
    },
    surveyDockEl(panel) {
      return panel && (panel.$el || panel)
    },
    moveSurveyDockInto(panel, host, target) {
      const el = this.surveyDockEl(panel)
      if (!el || !host) return
      if (target) {
        if (el.parentNode !== target) target.appendChild(el)
        return
      }
      if (el.parentNode !== host) host.appendChild(el)
    },
    restoreSurveyDocksFromFullscreen() {
      this.moveSurveyDockInto(this.$refs.inlineSurveyDock, this.$refs.inlineSurveyDockHost, null)
      this.moveSurveyDockInto(this.$refs.popupSurveyDock, this.$refs.popupSurveyDockHost, null)
      this.$nextTick(() => this.syncSurveyDockLayout())
    },
    syncSurveyDockLayout() {
      this.$refs.inlineSurveyDock?.syncLayoutPosition?.()
      this.$refs.popupSurveyDock?.syncLayoutPosition?.()
    },
    restoreFullscreenToolbarShowFabs() {
      const inlineFab = this.$refs.inlineToolbarShowFab
      const popupFab = this.$refs.popupToolbarShowFab
      const inlineRoot = this.$refs.inlineMapFullscreenRoot
      const popupRoot = this.$refs.popupMapFullscreenRoot
      if (inlineFab && inlineRoot && inlineFab.parentNode !== inlineRoot) inlineRoot.appendChild(inlineFab)
      if (popupFab && popupRoot && popupFab.parentNode !== popupRoot) popupRoot.appendChild(popupFab)
    },
    toggleFullscreenMapToolbar() {
      if (!this.mapToolbarInFullscreen) return
      this.mapFullscreenToolbarHidden = !this.mapFullscreenToolbarHidden
      this.$nextTick(() => this.placeFullscreenToolbarShowFab())
    },
    placeFullscreenToolbarShowFab() {
      if (!this.mapFullscreenToolbarHidden) return
      const fullscreenEl = this.getFullscreenElement()
      const fab = this.fullscreenToolbarTarget === 'popup'
        ? this.$refs.popupToolbarShowFab
        : this.$refs.inlineToolbarShowFab
      if (!fullscreenEl || !fab) return
      if (fab.parentNode !== fullscreenEl) fullscreenEl.appendChild(fab)
    },
    syncMapToolbarFullscreen() {
      const fullscreenEl = this.getFullscreenElement()
      if (!fullscreenEl) {
        this.stopFullscreenAlertWatch()
        this.restoreOverlayAlertsFromFullscreen()
        this.clearMapFullscreenNotice()
        this.restoreMapToolbarsFromFullscreen()
        this.restoreGeodesiaFileInputsHost()
        this.resolveFullscreenSurveyReplace(false)
        return
      }

      this.startFullscreenAlertWatch()
      this.bringOverlayAlertsAboveFullscreen()
      this.moveGeodesiaFileInputsIntoFullscreen(fullscreenEl)

      const inlineMap = this.useGoogleMap ? this.$refs.inlineGoogleMap : this.$refs.inlineArcgisMap
      const popupMap = this.useGoogleMap ? this.$refs.popupGoogleMap : this.$refs.popupArcgisMap
      if (this.isElementInFullscreen(inlineMap, fullscreenEl)) {
        this.moveToolbarInto(this.$refs.popupMapToolbar, this.$refs.popupMapToolbarHost, null)
        this.moveToolbarInto(this.$refs.inlineMapToolbar, this.$refs.inlineMapToolbarHost, fullscreenEl)
        this.moveSurveyDockInto(this.$refs.popupSurveyDock, this.$refs.popupSurveyDockHost, null)
        this.moveSurveyDockInto(this.$refs.inlineSurveyDock, this.$refs.inlineSurveyDockHost, fullscreenEl)
        this.$nextTick(() => {
          this.placeFullscreenToolbarShowFab()
          this.syncSurveyDockLayout()
        })
        return
      }
      if (this.isElementInFullscreen(popupMap, fullscreenEl)) {
        this.moveToolbarInto(this.$refs.inlineMapToolbar, this.$refs.inlineMapToolbarHost, null)
        this.moveToolbarInto(this.$refs.popupMapToolbar, this.$refs.popupMapToolbarHost, fullscreenEl)
        this.moveSurveyDockInto(this.$refs.inlineSurveyDock, this.$refs.inlineSurveyDockHost, null)
        this.moveSurveyDockInto(this.$refs.popupSurveyDock, this.$refs.popupSurveyDockHost, fullscreenEl)
        this.$nextTick(() => {
          this.placeFullscreenToolbarShowFab()
          this.syncSurveyDockLayout()
        })
        return
      }
      this.restoreMapToolbarsFromFullscreen()
    },
    toPositiveId(value) {
      const normalized = Number(value)
      if (!Number.isFinite(normalized) || normalized <= 0) return null
      return normalized
    },
    clearSelectedAdministrativeBoundary() {
      this.clickedMapPoint = null
      this.selectedAdministrativeBoundaryResult = null
      this.selectedAdministrativeBoundaryError = null
      this.loadingSelectedAdministrativeBoundary = false
      this.determineSelectedBoundaryRequestId += 1
      if (this.administrativeBoundaryResult) {
        this.highlightMatchedAdministrativeBoundaryOnMaps(this.administrativeBoundaryResult)
      } else {
        this.clearMatchedAdministrativeBoundaryOnMaps()
      }
    },
    // onMapPointClick({ latitude, longitude } = {}) {
    //   const lat = Number(latitude)
    //   const lng = Number(longitude)
    //   if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
    //   if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return
    //   this.clickedMapPoint = { latitude: lat, longitude: lng }
    //   this.determineSelectedAdministrativeBoundary({
    //     latitude: lat,
    //     longitude: lng,
    //   })
    // },
    async determineProjectAdministrativeBoundary() {
      if (!this.showInlineMap && !this.showMapPopup) return
      if (!this.canViewAdministrativeBoundaries) return

      const projectId = this.toPositiveId(this.resolvedProjectId)
      if (!projectId) return

      const requestId = this.determineBoundaryRequestId + 1
      this.determineBoundaryRequestId = requestId
      this.loadingAdministrativeBoundary = true
      this.administrativeBoundaryError = null

      try {
        const matched = await determineAdministrativeLocation({
          project_id: projectId,
          year: this.administrativeBoundariesYear || DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
        })
        if (requestId !== this.determineBoundaryRequestId) return

        this.administrativeBoundaryResult = matched

        if (!this.selectedAdministrativeBoundaryResult) {
          if (matched?.geometry) {
            this.highlightMatchedAdministrativeBoundaryOnMaps(matched)
          } else {
            this.clearMatchedAdministrativeBoundaryOnMaps()
          }
        }
        this.$emit('administrative-boundary-determined', {
          ...matched,
          model_type: matched.modelType,
          model_id: matched.modelId,
          type: matched.type,
          governorate_model_id: matched.byType?.governorate?.modelId ?? null,
          center_model_id: matched.byType?.center?.modelId ?? null,
          city_model_id: matched.byType?.city?.modelId ?? null,
          district_model_id: matched.byType?.district?.modelId ?? null,
          source: 'project',
        })
      } catch (error) {
        if (requestId !== this.determineBoundaryRequestId) return
        this.administrativeBoundaryResult = null
        this.administrativeBoundaryError = getDetermineAdministrativeBoundaryErrorMessage(error)
        if (!this.selectedAdministrativeBoundaryResult) {
          this.clearMatchedAdministrativeBoundaryOnMaps()
        }
      } finally {
        if (requestId === this.determineBoundaryRequestId) {
          this.loadingAdministrativeBoundary = false
        }
      }
    },
    /* async determineSelectedAdministrativeBoundary({ latitude, longitude } = {}) {
      if (!this.showInlineMap && !this.showMapPopup) return
      if (!this.canViewAdministrativeBoundaries) return

      const lat = Number(latitude)
      const lng = Number(longitude)
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
      if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return

      const requestId = this.determineSelectedBoundaryRequestId + 1
      this.determineSelectedBoundaryRequestId = requestId
      this.loadingSelectedAdministrativeBoundary = true
      this.selectedAdministrativeBoundaryError = null

      try {
        const matched = await determineAdministrativeLocation({
          latitude: lat,
          longitude: lng,
          year: this.administrativeBoundariesYear || DEFAULT_ADMINISTRATIVE_BOUNDARIES_YEAR,
        })
        if (requestId !== this.determineSelectedBoundaryRequestId) return

        this.selectedAdministrativeBoundaryResult = matched

        if (matched?.geometry) {
          this.highlightMatchedAdministrativeBoundaryOnMaps(matched)
        } else if (this.administrativeBoundaryResult?.geometry) {
          this.highlightMatchedAdministrativeBoundaryOnMaps(this.administrativeBoundaryResult)
        } else {
          this.clearMatchedAdministrativeBoundaryOnMaps()
        }
        this.$emit('selected-administrative-boundary-determined', {
          ...matched,
          model_type: matched.modelType,
          model_id: matched.modelId,
          type: matched.type,
          governorate_model_id: matched.byType?.governorate?.modelId ?? null,
          center_model_id: matched.byType?.center?.modelId ?? null,
          city_model_id: matched.byType?.city?.modelId ?? null,
          district_model_id: matched.byType?.district?.modelId ?? null,
          source: 'map_click',
          latitude: lat,
          longitude: lng,
        })
      } catch (error) {
        if (requestId !== this.determineSelectedBoundaryRequestId) return
        this.selectedAdministrativeBoundaryResult = null
        this.selectedAdministrativeBoundaryError = getDetermineAdministrativeBoundaryErrorMessage(error)
        if (this.administrativeBoundaryResult) {
          this.highlightMatchedAdministrativeBoundaryOnMaps(this.administrativeBoundaryResult)
        } else {
          this.clearMatchedAdministrativeBoundaryOnMaps()
        }
      } finally {
        if (requestId === this.determineSelectedBoundaryRequestId) {
          this.loadingSelectedAdministrativeBoundary = false
        }
      }
    }, */
    getMountedMapRefs() {
      return [
        this.$refs.inlineGoogleMap,
        this.$refs.inlineArcgisMap,
        this.$refs.popupGoogleMap,
        this.$refs.popupArcgisMap,
      ].filter(Boolean)
    },
    getActiveMapRefs() {
      return this.getMountedMapRefs()
    },
    highlightMatchedAdministrativeBoundaryOnMaps(matched) {
      const geometry = matched?.geometry
      const attributes = matched?.boundary || {}
      this.getActiveMapRefs().forEach(mapRef => {
        if (typeof mapRef.highlightMatchedAdministrativeBoundary === 'function') {
          mapRef.highlightMatchedAdministrativeBoundary(geometry, attributes)
        }
      })
    },
    clearMatchedAdministrativeBoundaryOnMaps() {
      this.getActiveMapRefs().forEach(mapRef => {
        if (typeof mapRef.clearMatchedAdministrativeBoundary === 'function') {
          mapRef.clearMatchedAdministrativeBoundary()
        }
      })
    },
    loadKmlHeaderNoteFromStorage() {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          const saved = window.localStorage.getItem(KML_HEADER_NOTE_STORAGE_KEY)
          if (saved !== null) {
            this.kmlHeaderNote = saved
            return
          }
        }
      } catch (e) {
        // ignore storage read failures
      }
      this.kmlHeaderNote = KML_HEADER_NOTE_DEFAULT
    },
    saveKmlHeaderNoteToStorage() {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem(KML_HEADER_NOTE_STORAGE_KEY, this.kmlHeaderNote || '')
        }
      } catch (e) {
        // ignore quota errors
      }
    },
    getEffectiveKmlHeaderNote() {
      const trimmed = String(this.kmlHeaderNote || '').trim()
      return trimmed || undefined
    },
    openKmlDownloadModal() {
      if (this.kmlActionLoading) return
      this.loadKmlHeaderNoteFromStorage()
      const defaultLocationId = this.toPositiveId(this.projectLocationId) || this.kmlLocationOptions[0]?.value || null
      if (defaultLocationId) {
        this.kmlDownloadScope = 'location'
        this.selectedKmlLocationId = defaultLocationId
      } else {
        this.kmlDownloadScope = 'project'
        this.selectedKmlLocationId = null
      }
      this.showKmlDownloadModal = true
    },
    handleKmlDownloadTargetChange(value) {
      if (value !== 'location') return
      if (!this.toPositiveId(this.selectedKmlLocationId) && this.kmlLocationOptions.length) {
        this.selectedKmlLocationId = this.kmlLocationOptions[0].value
      }
    },
    async confirmKmlDownload(event) {
      if (event?.preventDefault) event.preventDefault()
      if (!this.canConfirmKmlDownload || this.kmlActionLoading) return

      this.saveKmlHeaderNoteToStorage()

      let success = false
      if (this.kmlDownloadScope === 'project') {
        success = await this.downloadProjectLocationsKml()
      } else {
        const locationId = this.toPositiveId(this.selectedKmlLocationId)
        if (!locationId) return
        success = await this.exportKml(locationId)
      }

      if (success) {
        this.showKmlDownloadModal = false
      }
    },
    onMapCoordinatesChanged(updatedCoordinates) {
      if (Array.isArray(updatedCoordinates) && updatedCoordinates.length >= 3) {
        this.draftMapCoordinates = updatedCoordinates.map(coord => ({ ...coord }))
      }
      this.$emit('coordinates-changed', updatedCoordinates)
    },
    onMapCoordinatesSaved(payload) {
      if (Array.isArray(payload?.coordinates)) {
        this.draftMapCoordinates = [...payload.coordinates]
      }
      this.$emit('coordinates-saved', payload)
    },
    onMapSaveAsNewLocation(payload) {
      this.$emit('save-as-new-location', payload)
    },
    getMapRefsForImportedPoints() {
      return this.getMountedMapRefs().filter(
        ref => ref && typeof ref.plotImportedPoints === 'function',
      )
    },
    clearImportedPointsOnMaps(type) {
      const normalizedType = type ? String(type).toLowerCase() : null
      this.getMapRefsForImportedPoints().forEach(mapRef => {
        mapRef.clearImportedPoints?.(normalizedType || undefined)
      })
      if (normalizedType) {
        this.activeSurveyPreviewTypes = this.activeSurveyPreviewTypes.filter(key => key !== normalizedType)
        if (this.activeSurveyImportType === normalizedType) {
          this.activeSurveyImportType = this.activeSurveyPreviewTypes[this.activeSurveyPreviewTypes.length - 1] || null
        }
        this.geodesiaSheetPreviewActive = this.activeSurveyPreviewTypes.length > 0
        return
      }
      this.activeSurveyPreviewTypes = []
      this.geodesiaSheetPreviewActive = false
      this.activeSurveyImportType = null
    },
    plotImportedPointsOnMaps(points, type, options = {}) {
      const { fitToPoints = true, updatePointPool = true } = options
      const mapRefs = this.getMapRefsForImportedPoints()
      if (!mapRefs.length) {
        this.notifyUser('warning', 'الخريطة غير جاهزة لعرض النقاط')
        return false
      }
      const pointList = Array.isArray(points) ? [...points] : []
      const normalizedType = String(type || '').toLowerCase()
      if (updatePointPool) {
        this.allGeodesiaSheetPoints = [...pointList]
        this.geodesiaSheetPoints = [...pointList]
        this.activeSurveyImportType = normalizedType
      }
      mapRefs.forEach(mapRef => {
        mapRef.plotImportedPoints(pointList, normalizedType, { fitToPoints })
      })
      this.geodesiaSheetPreviewActive = true
      if (normalizedType && !this.activeSurveyPreviewTypes.includes(normalizedType)) {
        this.activeSurveyPreviewTypes = [...this.activeSurveyPreviewTypes, normalizedType]
      }
      return true
    },
    extractGeodesiaPointOrder(value, fallbackIndex = 0) {
      if (value == null || value === '') {
        return fallbackIndex
      }
      const str = String(value).trim()
      const direct = Number(str)
      if (Number.isFinite(direct) && str !== '') return direct
      const match = str.match(/\d+/)
      if (match) return Number(match[0])
      return fallbackIndex
    },
    sortGeodesiaPointsForPolygon(points) {
      return [...(points || [])].sort((left, right) => {
        const orderLeft = left?.sortOrder ?? this.extractGeodesiaPointOrder(left?.point_name ?? left?.label, 0)
        const orderRight = right?.sortOrder ?? this.extractGeodesiaPointOrder(right?.point_name ?? right?.label, 0)
        return orderLeft - orderRight
      })
    },
    resolveGeodesiaPointDisplayNumber(point, sortedIndex) {
      const fromPoint = this.extractGeodesiaPointOrder(
        point?.point_name ?? point?.point_number ?? point?.label,
        null,
      )
      if (fromPoint != null && Number.isFinite(fromPoint)) {
        return String(fromPoint)
      }
      return String(sortedIndex + 1)
    },
    isValidMapCoordinate(latitude, longitude) {
      if (latitude == null || longitude == null) return false
      const lat = Number(latitude)
      const lng = Number(longitude)
      if (Number.isNaN(lat) || Number.isNaN(lng)) return false
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return false
      return true
    },
    normalizeGeodesiaPreviewPoints(coordinates) {
      const points = (coordinates || []).map((item, idx) => {
        const rawLat = item?.latitude ?? item?.lat
        const rawLng = item?.longitude ?? item?.lng
        if (!this.isValidMapCoordinate(rawLat, rawLng)) return null
        const longitude = Number(rawLng)
        const latitude = Number(rawLat)
        const pointName = item?.point_name
        const pointNumber = item?.point_number
        let label = ''
        if (pointName != null && String(pointName).trim() !== '') {
          label = String(pointName).trim()
        } else if (pointNumber != null && String(pointNumber).trim() !== '') {
          label = String(pointNumber).trim()
        } else if (item?.id != null) {
          label = String(item.id)
        } else {
          label = String(idx + 1)
        }
        const sortOrder = this.extractGeodesiaPointOrder(pointName ?? pointNumber ?? label, idx)
        return {
          longitude,
          latitude,
          label,
          point_name: pointName,
          point_number: pointNumber,
          sortOrder,
        }
      }).filter(Boolean)

      return this.sortGeodesiaPointsForPolygon(points).map((point, sortedIndex) => ({
        ...point,
        displayNumber: this.resolveGeodesiaPointDisplayNumber(point, sortedIndex),
      }))
    },
    geodesiaPointsToPolygonCoordinates(points) {
      return this.sortGeodesiaPointsForPolygon(points).map(point => ({
        latitude: Number(point.latitude),
        longitude: Number(point.longitude),
        type: 'technical_office',
        x: Number(point.longitude),
        y: Number(point.latitude),
      }))
    },
    getGeodesiaPointsByIndexes(indexes) {
      const selected = new Set((indexes || []).map(idx => Number(idx)))
      return this.sortGeodesiaPointsForPolygon(
        this.geodesiaSheetPoints.filter((_, idx) => selected.has(Number(idx))),
      )
    },
    getActiveMapFullscreenRoot() {
      if (this.showMapPopup) {
        return this.$refs.popupMapFullscreenRoot
          || this.$el?.querySelector?.('.map-popup-shell__map.map-fullscreen-root')
          || null
      }
      return this.$refs.inlineMapFullscreenRoot
        || this.$el?.querySelector?.('.inline-map-wrapper.map-fullscreen-root')
        || null
    },
    getActiveMapRef() {
      if (this.showMapPopup) {
        return this.useGoogleMap
          ? (this.$refs.popupGoogleMap || null)
          : (this.$refs.popupArcgisMap || null)
      }
      return this.useGoogleMap
        ? (this.$refs.inlineGoogleMap || null)
        : (this.$refs.inlineArcgisMap || null)
    },
    moveActiveToolbarInto(target) {
      if (this.showMapPopup) {
        this.moveToolbarInto(this.$refs.inlineMapToolbar, this.$refs.inlineMapToolbarHost, null)
        this.moveToolbarInto(this.$refs.popupMapToolbar, this.$refs.popupMapToolbarHost, target)
        return
      }
      this.moveToolbarInto(this.$refs.popupMapToolbar, this.$refs.popupMapToolbarHost, null)
      this.moveToolbarInto(this.$refs.inlineMapToolbar, this.$refs.inlineMapToolbarHost, target)
    },
    async promoteMapFullscreenToStableRoot() {
      const fullscreenEl = this.getFullscreenElement()
      if (!fullscreenEl) return false

      const root = this.getActiveMapFullscreenRoot()
      if (!root) return false

      const mapRef = this.getActiveMapRef()
      const mapIsFullscreen = this.isElementInFullscreen(mapRef, fullscreenEl)
        || fullscreenEl === root
        || root.contains(fullscreenEl)
        || fullscreenEl.contains(root)
      if (!mapIsFullscreen) return false

      // Keep the toolbar and survey dock on the stable wrapper so they are not destroyed with the map canvas.
      this.moveActiveToolbarInto(root)
      if (this.showMapPopup) {
        this.moveSurveyDockInto(this.$refs.inlineSurveyDock, this.$refs.inlineSurveyDockHost, null)
        this.moveSurveyDockInto(this.$refs.popupSurveyDock, this.$refs.popupSurveyDockHost, root)
      } else {
        this.moveSurveyDockInto(this.$refs.popupSurveyDock, this.$refs.popupSurveyDockHost, null)
        this.moveSurveyDockInto(this.$refs.inlineSurveyDock, this.$refs.inlineSurveyDockHost, root)
      }

      if (fullscreenEl === root) return true

      const request = root.requestFullscreen
        || root.webkitRequestFullscreen
        || root.msRequestFullscreen
      if (!request) return false

      try {
        const result = request.call(root)
        if (result && typeof result.then === 'function') await result
        return true
      } catch (error) {
        return false
      }
    },
    resolveMapRef(mapRef) {
      if (Array.isArray(mapRef)) return mapRef[0] || null
      return mapRef || null
    },
    isMapEngineReady(mapRef) {
      const cmp = this.resolveMapRef(mapRef)
      return !!(cmp && (cmp.map || cmp.view))
    },
    async waitForMapEngineReady(mapRef, timeoutMs = 12000) {
      const started = Date.now()
      let cmp = this.resolveMapRef(mapRef)
      while (!cmp && Date.now() - started < timeoutMs) {
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 50))
        cmp = this.resolveMapRef(mapRef)
      }
      if (!cmp) return null
      if (typeof cmp.initMap === 'function' && !cmp.map && !cmp.view) {
        cmp.initMap()
      }
      if (typeof cmp.whenMapReady === 'function') {
        await cmp.whenMapReady(Math.max(250, timeoutMs - (Date.now() - started)))
        return cmp
      }
      while (!this.isMapEngineReady(cmp) && Date.now() - started < timeoutMs) {
        await new Promise(resolve => setTimeout(resolve, 50))
      }
      return cmp
    },
    lockActiveMapFullscreenSize() {
      const root = this.getActiveMapFullscreenRoot()
      if (!root) return null
      const height = Math.round(root.getBoundingClientRect().height || root.clientHeight || 0)
      if (height > 0) root.style.minHeight = `${height}px`
      return root
    },
    unlockActiveMapFullscreenSize(root) {
      if (!root) return
      window.setTimeout(() => {
        if (root.style) root.style.minHeight = ''
      }, 800)
    },
    getTargetEngineRef(wantGoogle) {
      if (this.showMapPopup) {
        return wantGoogle ? this.$refs.popupGoogleMap : this.$refs.popupArcgisMap
      }
      return wantGoogle ? this.$refs.inlineGoogleMap : this.$refs.inlineArcgisMap
    },
    onEsriMapSwitchChange(checked) {
      const wantEsri = typeof checked === 'boolean'
        ? checked
        : !!(checked && checked.target && checked.target.checked)
      this.switchMapEngine(!wantEsri)
    },
    mapEngineClass(isGoogleEngine) {
      const isActive = this.useGoogleMap === isGoogleEngine
      const isIncoming = this.switchingMapEngine && this.pendingMapEngineGoogle === isGoogleEngine
      return {
        'map-engine--active': isActive,
        'map-engine--hidden': !isActive,
        'map-engine--initializing': isIncoming && !isActive,
      }
    },
    async switchMapEngine(next) {
      const wantGoogle = !!next
      if (this.switchingMapEngine) return
      if (wantGoogle === this.useGoogleMap) return
      this.switchingMapEngine = true
      this.pendingMapEngineGoogle = wantGoogle
      const wasFullscreen = !!this.getFullscreenElement()
      const root = this.lockActiveMapFullscreenSize()
      try {
        await this.promoteMapFullscreenToStableRoot()
        if (wantGoogle) this.googleMapEngineMounted = true
        else this.arcgisMapEngineMounted = true
        await this.$nextTick()
        await this.waitForMapEngineReady(this.getTargetEngineRef(wantGoogle))
        this.useGoogleMap = wantGoogle
        this.saveMapEnginePreference(wantGoogle ? 'google' : 'arcgis')
        await this.$nextTick()
        this.getActiveMapRef()?.refreshMapSize?.()
        this.getActiveMapRef()?.focusCurrentPolygon?.()
        if (wasFullscreen && !this.getFullscreenElement()) {
          await this.enterActiveMapFullscreen()
        } else if (wasFullscreen) {
          this.syncMapToolbarFullscreen()
        }
      } finally {
        this.unlockActiveMapFullscreenSize(root)
        this.switchingMapEngine = false
      }
    },
    async ensureFullscreenMapFitsAfterEngineSwitch() {
      const refreshActive = () => {
        const map = this.getActiveMapRef()
        map?.refreshMapSize?.()
        map?.focusCurrentPolygon?.()
      }

      this.$nextTick(refreshActive)
      window.setTimeout(refreshActive, 250)
      window.setTimeout(refreshActive, 700)

      const root = this.getActiveMapFullscreenRoot()
      const fullscreenEl = this.getFullscreenElement()
      if (!fullscreenEl) return
      const alreadyOnRoot = !!(root && (
        fullscreenEl === root
        || root.contains(fullscreenEl)
        || fullscreenEl.contains(root)
      ))
      if (!alreadyOnRoot) {
        await this.enterActiveMapFullscreen()
      }
      this.syncMapToolbarFullscreen()
      refreshActive()
    },
    /**
     * Re-enter map fullscreen after a remount (e.g. switching location tab after save).
     * Waits until the active map instance is ready.
     */
    async enterActiveMapFullscreen(maxAttempts = 50) {
      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        const map = this.getActiveMapRef()
        const mapReady = !!(map && (map.view || map.map) && typeof map.enterMapFullscreen === 'function')
        if (mapReady) {
          const ok = await map.enterMapFullscreen()
          if (ok !== false) return true
        }
        await new Promise(resolve => {
          setTimeout(resolve, 100)
        })
      }
      return false
    },
    openGeodesiaPolygonModal() {
      if (this.geodesiaSheetPoints.length < 3) {
        this.$toast?.warning?.('يلزم 3 نقاط على الأقل لإنشاء مضلع')
        return
      }
      this.selectedGeodesiaPointIndexes = []
      this.geodesiaPolygonSelectionError = null
      this.showGeodesiaPolygonModal = true
    },
    resetGeodesiaPolygonModal() {
      this.selectedGeodesiaPointIndexes = []
      this.geodesiaPolygonSelectionError = null
      this.creatingGeodesiaPolygon = false
    },
    selectAllGeodesiaPolygonPoints() {
      this.selectedGeodesiaPointIndexes = this.geodesiaSheetPoints.map((_, idx) => idx)
      this.geodesiaPolygonSelectionError = null
    },
    clearGeodesiaPolygonPointSelection() {
      this.selectedGeodesiaPointIndexes = []
    },
    confirmGeodesiaPolygonFromSelection() {
      const selectedIndexes = [...new Set(this.selectedGeodesiaPointIndexes.map(idx => Number(idx)))]
      if (selectedIndexes.length < 3) {
        this.geodesiaPolygonSelectionError = 'اختر 3 نقاط على الأقل'
        return
      }

      const selectedPoints = this.getGeodesiaPointsByIndexes(selectedIndexes)
      if (selectedPoints.length < 3 || selectedPoints.length !== selectedIndexes.length) {
        this.geodesiaPolygonSelectionError = 'تعذر تحديد النقاط المختارة — أعد اختيار النقاط من القائمة'
        return
      }

      const mapRef = this.getActiveMapRef()
      if (typeof mapRef?.createPolygonFromImportedPoints !== 'function') {
        this.geodesiaPolygonSelectionError = 'الخريطة غير جاهزة لإنشاء المضلع'
        return
      }

      this.creatingGeodesiaPolygon = true
      try {
        const polygonCoords = this.geodesiaPointsToPolygonCoordinates(selectedPoints)

        const created = mapRef.createPolygonFromImportedPoints(polygonCoords)
        if (!created) {
          this.geodesiaPolygonSelectionError = 'تعذر إنشاء المضلع من النقاط المحددة'
          return
        }

        this.draftMapCoordinates = polygonCoords.map(coord => ({ ...coord }))
        this.plotImportedPointsOnMaps(this.allGeodesiaSheetPoints, this.activeSurveyImportType || 'geodesia_sheet', {
          fitToPoints: false,
          updatePointPool: false,
        })
        mapRef.focusCurrentPolygon?.()
        this.showGeodesiaPolygonModal = false

        const pointLabels = selectedPoints.map(point => point.displayNumber).join(', ')
        this.$toast?.success?.(`تم رسم مضلع من ${polygonCoords.length} نقطة (${pointLabels}) — احفظه من زر الحفظ على الخريطة`)
      } finally {
        this.creatingGeodesiaPolygon = false
      }
    },
    geodesiaSheetMessageKeyToText(key) {
      const map = {
        no_points_found_in_geodesia_sheet: 'تمت قراءة الورقة ولم يُعثر على صفوف شرق/شمال صالحة.',
        failed_to_read_file_content: 'تعذر قراءة الملف أو الملف فارغ.',
        failed_to_import_geodesia_sheet_file: 'فشل استيراد ملف الجدول على الخادم.',
      }
      return map[key] || null
    },
    resolveGeodesiaSheetHttpError(err) {
      const errorData = err?.response?.data
      const fieldErr = errorData?.errors?.geodesia_sheet_file
      if (fieldErr) {
        return Array.isArray(fieldErr) ? fieldErr[0] : fieldErr
      }
      const msg = typeof errorData?.message === 'string' ? errorData.message.trim() : ''
      if (msg) {
        const mapped = this.geodesiaSheetMessageKeyToText(msg)
        if (mapped) return mapped
        return msg
      }
      return 'حدث خطأ أثناء استيراد ملف Geodesia Sheet'
    },
    onGeodesiaSheetFileInput(file) {
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      if (!file || !file.name) return
      const lower = file.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        this.$nextTick(() => {
          this.geodesiaSheetFile = null
        })
      }
    },
    resetGeodesiaSheetImport() {
      this.geodesiaSheetFile = null
      this.geodesiaSheetImportError = null
      this.importingGeodesiaSheet = false
    },
    markProjectHasGeodesiaSheet() {
      this.localHasGeodesiaSheet = true
      if (this.project) {
        this.$set(this.project, 'has_geodesia_sheet', true)
      }
    },
    previewGeodesiaCoordinatesOnMap(coordinates, type = 'geodesia_sheet') {
      const points = this.normalizeGeodesiaPreviewPoints(coordinates)
      if (!points.length) {
        this.$toast?.warning?.('لا توجد إحداثيات صالحة للمعاينة على الخريطة')
        return false
      }
      this.allGeodesiaSheetPoints = [...points]
      this.geodesiaSheetPoints = [...points]
      return this.plotImportedPointsOnMaps(points, type)
    },
    getLatestProjectSurveyFile(files) {
      if (!Array.isArray(files) || !files.length) return null
      return [...files].sort((left, right) => {
        const leftTime = new Date(left?.created_at || 0).getTime()
        const rightTime = new Date(right?.created_at || 0).getTime()
        return rightTime - leftTime
      })[0]
    },
    async fetchGeodesiaSheetSurveyFiles() {
      const projectId = this.resolvedProjectId
      if (!projectId) {
        throw Object.assign(new Error('معرف المشروع غير متاح'), { response: null })
      }

      const response = await geodesiaApi.getProjectSurveyFile(projectId, 'geodesia_sheet')
      if (!response || !response.success) {
        throw Object.assign(new Error(this.extractProjectSurveyFileError(response)), { response })
      }

      const data = response.data || {}
      return Array.isArray(data.files) ? data.files : []
    },
    async loadGeodesiaSheetFileRecord() {
      if (!this.hasGeodesiaSheet || !this.resolvedProjectId) {
        this.geodesiaSheetFileRecord = null
        return
      }
      if (this.loadingGeodesiaSheetFileMeta) return

      this.loadingGeodesiaSheetFileMeta = true
      try {
        const files = await this.fetchGeodesiaSheetSurveyFiles()
        const latestFile = this.getLatestProjectSurveyFile(files)
        this.geodesiaSheetFileRecord = latestFile?.file_type === 'geodesia_sheet' ? latestFile : null
      } catch (error) {
        console.error('Failed to load geodesia sheet file metadata:', error)
        this.geodesiaSheetFileRecord = null
      } finally {
        this.loadingGeodesiaSheetFileMeta = false
      }
    },
    extractProjectSurveyFileError(error) {
      const errorData = error?.response?.data || error?.data || error
      if (errorData?.errors) {
        const firstFieldError = Object.values(errorData.errors).find(value => Array.isArray(value) && value.length)
        if (firstFieldError) return firstFieldError[0]
      }
      if (typeof errorData?.message === 'string' && errorData.message.trim()) {
        return errorData.message
      }
      return 'تعذر جلب ملفات المسح للمشروع'
    },
    async handleGeodesiaSheetPreviewToggle() {
      if (this.geodesiaSheetPreviewActiveForSheet) {
        this.clearImportedPointsOnMaps('geodesia_sheet')
        this.notifyUser('success', 'تم إخفاء نقاط Geodesia Sheet من الخريطة')
        return
      }
      const projectId = this.resolvedProjectId
      if (!projectId) {
        this.notifyUser('warning', 'معرف المشروع غير متاح')
        return
      }

      this.previewingGeodesiaSheet = true
      try {
        const files = await this.fetchGeodesiaSheetSurveyFiles()
        if (!files.length) {
          this.notifyUser('warning', 'لا توجد ملفات مساحية لهذا النوع في المشروع')
          return
        }

        const latestFile = this.getLatestProjectSurveyFile(files)
        this.geodesiaSheetFileRecord = latestFile?.file_type === 'geodesia_sheet' ? latestFile : null
        const coordinates = latestFile?.coordinates || []
        const previewPoints = this.normalizeGeodesiaPreviewPoints(coordinates)
        if (!previewPoints.length) {
          this.notifyUser('warning', 'لا توجد إحداثيات صالحة للمعاينة على الخريطة')
          return
        }

        if (this.previewGeodesiaCoordinatesOnMap(coordinates, 'geodesia_sheet')) {
          const fileName = latestFile?.file_name || 'Geodesia Sheet'
          this.notifyUser('success', `تم عرض ${previewPoints.length} نقطة من ${fileName}`)
        }
      } catch (error) {
        console.error('Failed to preview geodesia sheet:', error)
        this.notifyUser('error', this.extractProjectSurveyFileError(error))
      } finally {
        this.previewingGeodesiaSheet = false
      }
    },
    async downloadGeodesiaSheetKml() {
      if (this.downloadingGeodesiaSheetKml) return

      if (!this.geodesiaSheetFileRecord?.id) {
        await this.loadGeodesiaSheetFileRecord()
      }

      if (!this.canExportGeodesiaSheetKml) {
        this.$toast?.warning?.('لا توجد نقاط قابلة للتصدير')
        return
      }

      const geodesiaSheetFileId = Number(this.geodesiaSheetFileRecord.id)
      this.downloadingGeodesiaSheetKml = true
      try {
        const response = await this.projectsApi.downloadGeodesiaSheetKml(geodesiaSheetFileId)
        const status = response.status
        let { data: blob } = response

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/vnd.google-earth.kml+xml' })
        }

        const contentType = String(response.headers['content-type'] || blob.type || '').toLowerCase()
        const maybeJson = status >= 400 || contentType.includes('application/json') || await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.geodesiaSheetKmlErrorMessage(payload)), { payload, status })
        }

        if (!contentType.includes('kml')) {
          blob = new Blob([blob], { type: 'application/vnd.google-earth.kml+xml' })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const surveyingCode = this.sanitizeFilePart(this.project?.surveying_code ?? this.surveyingCode)
        const projectId = this.resolvedProjectId
        const filename = fromHeader
          || (surveyingCode
            ? `${surveyingCode}_geodesia_sheet.kml`
            : (Number.isFinite(projectId) && projectId > 0
              ? `project-${projectId}_geodesia_sheet.kml`
              : `geodesia-sheet-${geodesiaSheetFileId}.kml`))
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف KML')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const status = error.status || error.response?.status
        let msg = this.geodesiaSheetKmlErrorMessage(payload || {})
        if (status === 403) msg = 'ليس لديك صلاحية لتصدير هذا الملف'
        else if (status === 404) msg = 'ملف Geodesia Sheet غير موجود'
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingGeodesiaSheetKml = false
      }
    },
    async submitGeodesiaSheetImport() {
      const projectId = this.resolvedProjectId
      if (!this.geodesiaSheetFile || !projectId) {
        this.geodesiaSheetImportError = 'معرف المشروع أو الملف غير متاح'
        return
      }
      const lower = this.geodesiaSheetFile.name.toLowerCase()
      if (!lower.endsWith('.xlsx') && !lower.endsWith('.xls')) {
        this.geodesiaSheetImportError = 'يجب اختيار ملف بصيغة .xlsx أو .xls'
        return
      }

      this.importingGeodesiaSheet = true
      this.geodesiaSheetImportError = null
      this.geodesiaSheetImportResult = null
      try {
        const response = await geodesiaApi.importGeodesiaSheetFile(this.geodesiaSheetFile, projectId)
        if (response && response.success) {
          const importData = response.data || {}
          this.geodesiaSheetImportResult = importData
          this.showGeodesiaSheetImportModal = false
          this.markProjectHasGeodesiaSheet()

          const errorsCount = Number(importData?.errors_count || 0)
          const storedCount = Number(importData?.stored_points_count || 0)
          const parsedCount = Number(importData?.parsed_points_count || 0)
          if (errorsCount > 0) {
            this.$toast?.warning?.(`استيراد جزئي — مقروءة: ${parsedCount} | محفوظة: ${storedCount} | أخطاء: ${errorsCount}`)
          } else {
            this.$toast?.success?.(`تم استيراد ${storedCount} نقطة من ${importData.file_name || 'Geodesia Sheet'}`)
          }

          if (importData.geodesia_sheet_file_id != null) {
            this.geodesiaSheetFileRecord = {
              id: importData.geodesia_sheet_file_id,
              file_type: 'geodesia_sheet',
              points_count: storedCount,
              file_name: importData.file_name,
            }
          } else {
            await this.loadGeodesiaSheetFileRecord()
          }

          this.previewGeodesiaCoordinatesOnMap(importData.coordinates, 'geodesia_sheet')
        } else {
          this.geodesiaSheetImportError = this.resolveGeodesiaSheetHttpError({ response: { data: response } })
        }
      } catch (error) {
        console.error('Failed to import Geodesia sheet file:', error)
        this.geodesiaSheetImportError = this.resolveGeodesiaSheetHttpError(error)
      } finally {
        this.importingGeodesiaSheet = false
      }
    },
    getGeodesiaFileInputRef(type) {
      const inputRefs = {
        jxl: 'geodesiaJxlFileInput',
        rw5: 'geodesiaRw5FileInput',
        raw: 'geodesiaRawFileInput',
        kmz: 'geodesiaKmzFileInput',
        kml: 'geodesiaKmlFileInput',
        dxf: 'geodesiaDxfFileInput',
        html: 'geodesiaHtmlFileInput',
        shp: 'geodesiaShpFileInput',
      }
      const refName = inputRefs[String(type || '').toLowerCase()]
      return refName ? this.$refs[refName] : null
    },
    openGeodesiaFilePicker(type) {
      const input = this.getGeodesiaFileInputRef(type)
      if (!input) return
      const fullscreenEl = this.getFullscreenElement()
      if (fullscreenEl) this.moveGeodesiaFileInputsIntoFullscreen(fullscreenEl)
      input.value = ''
      input.click()
    },
    getGeodesiaReplaceConfirmation(type) {
      const normalizedType = String(type || '').toLowerCase()
      if (!this.hasFullscreenSurveyFile(normalizedType)) return null
      const labels = {
        geodesia_sheet: 'Geodesia Sheet',
        jxl: 'JXL',
        rw5: 'RW5',
        raw: 'RAW',
        kmz: 'KMZ',
        kml: 'KML',
        dxf: 'DXF',
        html: 'HTML',
        shp: 'Shapefile',
      }
      const label = labels[normalizedType] || normalizedType.toUpperCase()
      return `هل أنت متأكد من تحديث ملف ${label} لهذا المشروع؟`
    },
    async handleGeodesiaImportClick(type) {
      const normalizedType = String(type || '').toLowerCase()
      const confirmationMessage = this.getGeodesiaReplaceConfirmation(normalizedType)
      if (confirmationMessage) {
        const confirmed = await this.confirmSurveyFileReplace(confirmationMessage)
        if (!confirmed) return
      }
      this.openGeodesiaFilePicker(normalizedType)
    },
    /** Parse KML/KMZ/SHP in the browser and show it on the map; resolves false if the user cancels. */
    async previewSurveyFileBeforeUpload(type, file) {
      let points = []
      this.geodesiaImportingType = type
      try {
        points = await previewPointsFromFile(type, file)
      } catch (error) {
        console.warn(`Client preview failed for ${type}, uploading directly:`, error)
        return true
      } finally {
        this.geodesiaImportingType = null
      }
      const previewPoints = this.normalizeGeodesiaPreviewPoints(points)
      // Projected shapefiles without a .prj can't be shown client-side; the backend still handles them.
      if (!previewPoints.length) return true
      if (!this.previewGeodesiaCoordinatesOnMap(points, type)) return true
      const confirmed = await this.confirmSurveyFileUpload(
        `تمت معاينة ${previewPoints.length} نقطة من ${file.name} على الخريطة. هل تريد رفع الملف وحفظه في المشروع؟`,
      )
      if (!confirmed) {
        this.clearImportedPointsOnMaps(type)
        this.notifyUser('info', 'تم إلغاء رفع الملف')
      }
      return confirmed
    },
    async runSurveyFileImport({
      type,
      file,
      event,
      importApi,
      extensions,
      extensionMessage,
    }) {
      if (!file) return

      const normalizedType = String(type || '').toLowerCase()
      const projectId = this.resolvedProjectId
      if (!projectId) {
        this.notifyUser('warning', 'معرف المشروع غير متاح')
        if (event?.target) event.target.value = ''
        return
      }

      const lowerName = file.name.toLowerCase()
      const allowedExtensions = Array.isArray(extensions) ? extensions : []
      if (!allowedExtensions.some(ext => lowerName.endsWith(ext))) {
        this.notifyUser('error', extensionMessage || this.getGeodesiaSurveyExtensionMessage(normalizedType))
        if (event?.target) event.target.value = ''
        return
      }

      if (typeof importApi !== 'function') {
        this.notifyUser('error', 'واجهة الاستيراد غير متاحة')
        if (event?.target) event.target.value = ''
        return
      }

      if (isClientPreviewType(normalizedType)) {
        const proceed = await this.previewSurveyFileBeforeUpload(normalizedType, file)
        if (!proceed) {
          if (event?.target) event.target.value = ''
          return
        }
      }

      this.importingGeodesiaSurveyFile = true
      this.geodesiaImportingType = normalizedType
      try {
        const response = await importApi(file, projectId)
        if (response && response.success) {
          const importData = response.data || {}
          const errorsCount = Number(importData?.errors_count || 0)
          const storedCount = Number(importData?.stored_points_count || 0)
          const parsedCount = Number(importData?.parsed_points_count || 0)
          if (errorsCount > 0) {
            this.notifyUser('warning', `استيراد جزئي — مقروءة: ${parsedCount} | محفوظة: ${storedCount} | أخطاء: ${errorsCount}`)
          } else {
            this.notifyUser('success', `تم استيراد ${storedCount} نقطة من ${importData.file_name || normalizedType.toUpperCase()}`)
          }
          this.markProjectHasSurveyFile(normalizedType)
          this.previewGeodesiaCoordinatesOnMap(importData.coordinates, normalizedType)
        } else {
          this.notifyUser('error', this.extractGeodesiaImportError(response, normalizedType))
        }
      } catch (error) {
        console.error(`Failed to import ${normalizedType} file:`, error)
        this.notifyUser('error', this.extractGeodesiaImportError(error, normalizedType))
      } finally {
        this.importingGeodesiaSurveyFile = false
        this.geodesiaImportingType = null
        if (event?.target) event.target.value = ''
      }
    },
    handleDxfImportClick() {
      this.openGeodesiaFilePicker('dxf')
    },
    onDxfFileSelected(event) {
      this.runSurveyFileImport({
        type: 'dxf',
        file: event?.target?.files?.[0],
        event,
        importApi: geodesiaApi.importDxfFile.bind(geodesiaApi),
        extensions: ['.dxf'],
        extensionMessage: 'يجب اختيار ملف بصيغة .dxf فقط',
      })
    },
    handleDxfSurveyPreview() {
      this.handleProjectSurveyFilePreview('dxf')
    },
    handleHtmlImportClick() {
      this.openGeodesiaFilePicker('html')
    },
    onHtmlFileSelected(event) {
      this.runSurveyFileImport({
        type: 'html',
        file: event?.target?.files?.[0],
        event,
        importApi: geodesiaApi.importHtmlFile.bind(geodesiaApi),
        extensions: ['.html', '.htm'],
        extensionMessage: 'يجب اختيار ملف بصيغة .html أو .htm فقط',
      })
    },
    handleHtmlSurveyPreview() {
      this.handleProjectSurveyFilePreview('html')
    },
    handleKmlImportClick() {
      this.openGeodesiaFilePicker('kml')
    },
    onKmlFileSelected(event) {
      this.runSurveyFileImport({
        type: 'kml',
        file: event?.target?.files?.[0],
        event,
        importApi: geodesiaApi.importKmlFile.bind(geodesiaApi),
        extensions: ['.kml'],
        extensionMessage: 'يجب اختيار ملف بصيغة .kml فقط',
      })
    },
    handleKmlSurveyPreview() {
      this.handleProjectSurveyFilePreview('kml')
    },
    handleKmzImportClick() {
      this.openGeodesiaFilePicker('kmz')
    },
    onKmzFileSelected(event) {
      this.runSurveyFileImport({
        type: 'kmz',
        file: event?.target?.files?.[0],
        event,
        importApi: geodesiaApi.importKmzFile.bind(geodesiaApi),
        extensions: ['.kmz'],
        extensionMessage: 'يجب اختيار ملف بصيغة .kmz فقط',
      })
    },
    handleKmzSurveyPreview() {
      this.handleProjectSurveyFilePreview('kmz')
    },
    handleShpImportClick() {
      this.openGeodesiaFilePicker('shp')
    },
    onShpFileSelected(event) {
      this.runSurveyFileImport({
        type: 'shp',
        file: event?.target?.files?.[0],
        event,
        importApi: geodesiaApi.importShpFile.bind(geodesiaApi),
        extensions: ['.zip'],
        extensionMessage: 'يجب اختيار ملف ZIP يحتوي على shapefile (.shp)',
      })
    },
    handleShpSurveyPreview() {
      this.handleProjectSurveyFilePreview('shp')
    },
    handleGeodesiaSheetImportClick() {
      this.openGeodesiaSheetImportModalSafely()
    },
    isGeodesiaSurveyFile(type, file) {
      if (!file || !file.name) return false
      const extensionMap = {
        jxl: ['.jxl'],
        rw5: ['.rw5'],
        raw: ['.raw'],
        kmz: ['.kmz'],
        kml: ['.kml'],
        dxf: ['.dxf'],
        html: ['.html', '.htm'],
        shp: ['.zip'],
      }
      const extensions = extensionMap[String(type || '').toLowerCase()]
      if (!extensions) return false
      const lowerName = file.name.toLowerCase()
      return extensions.some(ext => lowerName.endsWith(ext))
    },
    getGeodesiaSurveyFileField(type) {
      const fieldMap = {
        jxl: 'jxl_file',
        rw5: 'rw5_file',
        raw: 'raw_file',
        kmz: 'kmz_file',
        kml: 'kml_file',
        dxf: 'dxf_file',
        html: 'html_file',
        shp: 'shp_file',
        geodesia_sheet: 'geodesia_sheet_file',
      }
      return fieldMap[String(type || '').toLowerCase()] || null
    },
    getGeodesiaSurveyImportApi(type) {
      const apiMap = {
        jxl: geodesiaApi.importJxlFile,
        rw5: geodesiaApi.importRw5File,
        raw: geodesiaApi.importRawFile,
        kmz: geodesiaApi.importKmzFile,
        kml: geodesiaApi.importKmlFile,
        dxf: geodesiaApi.importDxfFile,
        html: geodesiaApi.importHtmlFile,
        shp: geodesiaApi.importShpFile,
      }
      return apiMap[String(type || '').toLowerCase()] || null
    },
    getGeodesiaSurveyExtensionMessage(type) {
      const messageMap = {
        jxl: 'يجب اختيار ملف بصيغة .jxl فقط',
        rw5: 'يجب اختيار ملف بصيغة .rw5 فقط',
        raw: 'يجب اختيار ملف بصيغة .raw فقط',
        kmz: 'يجب اختيار ملف بصيغة .kmz فقط',
        kml: 'يجب اختيار ملف بصيغة .kml فقط',
        dxf: 'يجب اختيار ملف بصيغة .dxf فقط',
        html: 'يجب اختيار ملف بصيغة .html أو .htm فقط',
        shp: 'يجب اختيار ملف ZIP يحتوي على shapefile (.shp)',
      }
      return messageMap[String(type || '').toLowerCase()] || 'صيغة الملف غير مدعومة'
    },
    extractGeodesiaImportError(error, type) {
      const duplicateMessage = 'الملف المرفق موجود بالفعل بهذا الاسم برجاء استخدام اسم اخر'
      const messageKeyMap = {
        no_points_found_in_shp: 'لم يُعثر على إحداثيات في ملف Shapefile',
        no_points_found_in_html: 'لم يُعثر على نقاط مسح في تقرير HTML',
        failed_to_import_shp_file: 'فشل استيراد ملف Shapefile',
        failed_to_import_html_file: 'فشل استيراد ملف HTML',
        failed_to_read_file_content: 'تعذر قراءة محتوى الملف',
      }
      const fieldName = this.getGeodesiaSurveyFileField(type)
      const errorData = error?.response?.data || error?.data || error
      const fieldErrors = fieldName && errorData?.errors?.[fieldName]
      if (Array.isArray(fieldErrors) && fieldErrors.length) {
        return fieldErrors[0]
      }
      if (typeof errorData?.message === 'string' && errorData.message.trim()) {
        const mapped = messageKeyMap[errorData.message.trim()]
        if (mapped) return mapped
        if (errorData.message.includes('موجود بالفعل')) {
          return duplicateMessage
        }
        return errorData.message
      }
      if (typeof errorData === 'string' && errorData.trim()) {
        return errorData
      }
      return 'حدث خطأ أثناء استيراد الملف'
    },
    markProjectHasSurveyFile(type) {
      const normalizedType = String(type || '').toLowerCase()
      const flagMap = {
        jxl: 'has_jxl',
        rw5: 'has_rw5',
        raw: 'has_raw',
        kmz: 'has_kmz',
        kml: 'has_kml',
        dxf: 'has_dxf',
        html: 'has_html',
        shp: 'has_shp',
        geodesia_sheet: 'has_geodesia_sheet',
      }
      const flag = flagMap[normalizedType]
      if (normalizedType === 'jxl') {
        this.localHasJxl = true
      }
      if (normalizedType === 'geodesia_sheet') {
        this.localHasGeodesiaSheet = true
      }
      if (!this.project) return
      if (flag) this.$set(this.project, flag, true)
      if (['kmz', 'kml', 'dxf', 'html', 'shp'].includes(normalizedType)) {
        this.$set(this.project, 'has_jxl', true)
      }
    },
    markProjectHasJxl() {
      this.markProjectHasSurveyFile('jxl')
    },
    async fetchJxlSurveyFiles() {
      const projectId = this.resolvedProjectId
      if (!projectId) {
        throw Object.assign(new Error('معرف المشروع غير متاح'), { response: null })
      }

      const response = await geodesiaApi.getProjectSurveyFile(projectId, 'jxl')
      if (!response || !response.success) {
        throw Object.assign(new Error(this.extractProjectSurveyFileError(response)), { response })
      }

      const data = response.data || {}
      return Array.isArray(data.files) ? data.files : []
    },
    async handleJxlPreviewToggle() {
      if (this.jxlPreviewActive) {
        this.clearImportedPointsOnMaps('jxl')
        this.$toast?.success?.('تم إخفاء نقاط JXL من الخريطة')
        return
      }

      const projectId = this.resolvedProjectId
      if (!projectId) {
        this.$toast?.warning?.('معرف المشروع غير متاح')
        return
      }

      this.previewingJxlSurvey = true
      try {
        const files = await this.fetchJxlSurveyFiles()
        if (!files.length) {
          this.$toast?.warning?.('لا توجد ملفات JXL في المشروع')
          return
        }

        const latestFile = this.getLatestProjectSurveyFile(files)
        const coordinates = latestFile?.coordinates || []
        const previewPoints = this.normalizeGeodesiaPreviewPoints(coordinates)
        if (!previewPoints.length) {
          this.$toast?.warning?.('لا توجد إحداثيات صالحة للمعاينة على الخريطة')
          return
        }

        if (this.previewGeodesiaCoordinatesOnMap(coordinates, 'jxl')) {
          const fileName = latestFile?.file_name || 'JXL'
          this.$toast?.success?.(`تم عرض ${previewPoints.length} نقطة من ${fileName}`)
        }
      } catch (error) {
        console.error('Failed to preview JXL:', error)
        this.$toast?.error?.(this.extractProjectSurveyFileError(error))
      } finally {
        this.previewingJxlSurvey = false
      }
    },
    async handleProjectSurveyFilePreview(type) {
      const normalizedType = String(type || '').toLowerCase()
      const projectId = this.resolvedProjectId
      if (!projectId) {
        this.notifyUser('warning', 'معرف المشروع غير متاح')
        return
      }

      this.previewingProjectSurveyFileType = normalizedType
      try {
        const response = await geodesiaApi.getProjectSurveyFile(projectId, normalizedType)
        if (!response || !response.success) {
          this.notifyUser('error', this.extractProjectSurveyFileError(response))
          return
        }

        const data = response.data || {}
        const filesCount = Number(data.files_count || 0)
        if (!filesCount || !Array.isArray(data.files) || !data.files.length) {
          this.notifyUser('warning', 'لا توجد ملفات مساحية لهذا النوع في المشروع')
          return
        }

        const latestFile = this.getLatestProjectSurveyFile(data.files)
        const coordinates = latestFile?.coordinates || []
        const previewPoints = this.normalizeGeodesiaPreviewPoints(coordinates)
        if (!previewPoints.length) {
          this.notifyUser('warning', 'لا توجد إحداثيات صالحة للمعاينة على الخريطة')
          return
        }

        if (this.previewGeodesiaCoordinatesOnMap(coordinates, normalizedType)) {
          const fileName = latestFile?.file_name || normalizedType.toUpperCase()
          this.notifyUser('success', `تم عرض ${previewPoints.length} نقطة من ${fileName}`)
        }
      } catch (error) {
        console.error(`Failed to preview ${normalizedType} project survey file:`, error)
        this.notifyUser('error', this.extractProjectSurveyFileError(error))
      } finally {
        this.previewingProjectSurveyFileType = null
      }
    },
    async onGeodesiaSurveyFileSelected(type, event) {
      const normalizedType = String(type || '').toLowerCase()
      const importApi = this.getGeodesiaSurveyImportApi(normalizedType)
      const extensionMap = {
        jxl: ['.jxl'],
        rw5: ['.rw5'],
        raw: ['.raw'],
        kmz: ['.kmz'],
        kml: ['.kml'],
        dxf: ['.dxf'],
        html: ['.html', '.htm'],
        shp: ['.zip'],
      }
      await this.runSurveyFileImport({
        type: normalizedType,
        file: event?.target?.files?.[0],
        event,
        importApi: importApi ? importApi.bind(geodesiaApi) : null,
        extensions: extensionMap[normalizedType] || [],
        extensionMessage: this.getGeodesiaSurveyExtensionMessage(normalizedType),
      })
    },
    openMapPopup() {
      const active = document.activeElement
      if (active instanceof HTMLElement && active !== document.body) {
        active.blur()
      }
      this.showMapPopup = true
    },
    onMapLocationCreate() {
      this.$emit('create-location')
    },
    onMapLocationEditData(location) {
      this.$emit('edit-location-data', location)
    },
    onMapLocationEditPolygon(location) {
      this.$emit('edit-location-polygon', location)
    },
    locationHasMapPolygon(location) {
      const coords = this.getValidMapCoordinates(this.getLocationCoordinatesForMap(location || {}))
      return coords.length >= 3
    },
    async beginParcelPolygonEdit(location = null) {
      const map = this.getActiveMapRef()
      if (!map) return false
      await this.waitForMapEngineReady(map, 4000)
      await this.$nextTick()
      await new Promise(resolve => window.setTimeout(resolve, 160))
      map.focusCurrentPolygon?.()
      const target = location || null
      const hasPolygon = target
        ? this.locationHasMapPolygon(target)
        : this.getValidMapCoordinates(this.mapDisplayCoordinates).length >= 3
      if (hasPolygon) {
        if (typeof map.enableParcelEdit === 'function') {
          map.enableParcelEdit()
          return true
        }
        if (typeof map.startParcelEdit === 'function') {
          await map.startParcelEdit()
          return true
        }
        return false
      }
      if (typeof map.startPolygonDrawMode === 'function') {
        map.startPolygonDrawMode()
        return true
      }
      return false
    },
    getLocationCoordinatesForMap(location) {
      const raw = location?.coordinates
      if (!Array.isArray(raw)) return []
      const type = this.mapSiblingCoordinatesType
      const typed = raw.filter(coord => coord && coord.type === type)
      const list = typed.length ? typed : raw
      return Array.isArray(list) ? list : []
    },
    isValidMapCoordinate(latitude, longitude) {
      if (latitude == null || longitude == null) return false
      const lat = Number(latitude)
      const lng = Number(longitude)
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return false
      return true
    },
    resolveMapCoordinatePair(coord) {
      if (!coord || typeof coord !== 'object') return null
      const latCandidates = [coord.latitude, coord.lat, coord.y]
      const lngCandidates = [coord.longitude, coord.lng, coord.x]
      for (let i = 0; i < latCandidates.length; i += 1) {
        const lat = Number(latCandidates[i])
        const lng = Number(lngCandidates[i])
        if (this.isValidMapCoordinate(lat, lng)) {
          return {
            ...coord,
            latitude: lat,
            longitude: lng,
          }
        }
      }
      return null
    },
    getValidMapCoordinates(coordinates) {
      if (!Array.isArray(coordinates)) return []
      return coordinates
        .map(coord => this.resolveMapCoordinatePair(coord))
        .filter(Boolean)
    },
    getOtherLocationMapLabel(location, index) {
      const land = location?.land_number
      if (land !== null && land !== undefined && String(land).trim() !== '') {
        return `قطعة ${land}`
      }
      const code = location?.code
      if (code !== null && code !== undefined && String(code).trim() !== '') {
        return `رمز ${code}`
      }
      return `موقع ${index + 1}`
    },
    async refreshMap() {
      const mapCmp = this.getActiveMapRef()
      if (mapCmp?.reloadMapLayers) {
        await mapCmp.reloadMapLayers()
      }
      if (mapCmp?.refreshMapSize || mapCmp?.focusCurrentPolygon) {
        mapCmp?.refreshMapSize?.()
        mapCmp?.focusCurrentPolygon?.()
      }
    },
    setupInlineMapVisibilityObserver() {
      if (typeof IntersectionObserver === 'undefined' || !this.showInlineMap) return

      this.teardownInlineMapVisibilityObserver()
      this.$nextTick(() => {
        const el = this.$el?.querySelector?.('.inline-map-wrapper')
        if (!el) return

        this.inlineMapVisibilityObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.focusInlineMapView()
          }
        }, { threshold: 0.15 })

        this.inlineMapVisibilityObserver.observe(el)
      })
    },
    teardownInlineMapVisibilityObserver() {
      if (this.inlineMapVisibilityObserver) {
        this.inlineMapVisibilityObserver.disconnect()
        this.inlineMapVisibilityObserver = null
      }
    },
    focusInlineMapView() {
      this.$nextTick(() => {
        const map = this.$refs.inlineGoogleMap || this.$refs.inlineArcgisMap
        const active = this.getActiveMapRef() || map
        active?.refreshMapSize?.()
        active?.focusCurrentPolygon?.()
      })
      window.setTimeout(() => {
        const active = this.getActiveMapRef()
        active?.refreshMapSize?.()
        active?.focusCurrentPolygon?.()
        if (this.activeAdministrativeBoundaryHighlight) {
          this.highlightMatchedAdministrativeBoundaryOnMaps(this.activeAdministrativeBoundaryHighlight)
        }
      }, 250)
    },
    onMapPopupShown() {
      const active = document.activeElement
      if (active instanceof HTMLElement && active !== document.body) {
        active.blur()
      }
      this.$nextTick(() => {
        const map = this.getActiveMapRef()
        map?.refreshMapSize?.()
        if (this.activeAdministrativeBoundaryHighlight) {
          this.highlightMatchedAdministrativeBoundaryOnMaps(this.activeAdministrativeBoundaryHighlight)
        } else {
          this.determineProjectAdministrativeBoundary()
        }
        setTimeout(() => map?.refreshMapSize?.(), 150)
        setTimeout(() => map?.refreshMapSize?.(), 400)
      })
    },
    parseDownloadFilename(contentDisposition, fallbackName) {
      if (!contentDisposition || typeof contentDisposition !== 'string') return fallbackName

      const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]).replace(/["']/g, '')
        } catch (e) {
          return utf8Match[1].replace(/["']/g, '')
        }
      }

      const simpleMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
      if (simpleMatch && simpleMatch[1]) {
        return simpleMatch[1].trim()
      }

      return fallbackName
    },
    jxlErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_coordinates_for_jxl: 'لا توجد إحداثيات للتصدير (مكتب فني أو حقول).',
        jxl_export_failed: detail || 'فشل إنشاء ملف JXL.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تحميل ملف JXL'
    },
    shapeZipErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_coordinates_for_shape_export: 'لا توجد إحداثيات متاحة لتصدير ملف Shape ZIP.',
        shape_export_failed: detail || 'فشل إنشاء ملف Shape ZIP.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تنزيل ملف Shape ZIP'
    },
    geodesiaSheetKmlErrorMessage(payload) {
      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_coordinates_for_shape_export: 'لا توجد إحداثيات قابلة للتصدير في Geodesia Sheet.',
        project_does_not_have_geodesia_sheet_file: 'المشروع لا يحتوي على شيت جيوديسيا',
        shape_export_failed: detail || 'فشل تصدير ملف KML.',
      }
      if (key && map[key]) return map[key]
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تصدير Geodesia Sheet كملف KML'
    },
    projectLocationsKmlErrorMessage(payload, status) {
      if (status === 403) {
        return 'لا تملك صلاحية تنزيل KML لهذا المشروع أو لا تملك صلاحية الفرع الحالي / You do not have permission or branch access for this project KML.'
      }
      if (status === 404) {
        return 'المشروع غير موجود / Project not found.'
      }
      if (status === 422) {
        return 'نص ملاحظة رأس التقرير يتجاوز الحد المسموح (2000 حرف) / Header note exceeds maximum length (2000 characters).'
      }
      if (status >= 500) {
        return 'حدث خطأ في الخادم أثناء تصدير KML للمشروع / Server error while exporting project KML.'
      }

      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      if (detail) return detail
      if (typeof payload?.message === 'string' && payload.message.trim()) return payload.message.trim()
      return 'تعذر تنزيل ملف KML للمشروع / Unable to download project KML.'
    },
    projectLocationKmlErrorMessage(payload, status) {
      if (status === 403) {
        return 'لا تملك صلاحية تنزيل KML لهذا الموقع أو لا تملك صلاحية الفرع الحالي / You do not have permission or branch access for this location KML.'
      }
      if (status === 404) {
        return 'موقع المشروع غير موجود / Project location not found.'
      }
      if (status === 422) {
        return 'نص ملاحظة رأس التقرير يتجاوز الحد المسموح (2000 حرف) / Header note exceeds maximum length (2000 characters).'
      }
      if (status >= 500) {
        return 'حدث خطأ في الخادم أثناء تصدير KML / Server error while exporting KML.'
      }

      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      if (detail) return detail
      if (typeof payload?.message === 'string' && payload.message.trim()) return payload.message.trim()
      return 'تعذر تنزيل ملف KML / Unable to download KML.'
    },
    async parseErrorResponseData(data) {
      if (data instanceof Blob) {
        const text = await data.text()
        try {
          return JSON.parse(text)
        } catch (e) {
          return { message: text }
        }
      }
      return data || {}
    },
    triggerBlobDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    async isJsonBlob(blob) {
      if (!(blob instanceof Blob)) return false
      const contentType = String(blob.type || '').toLowerCase()
      if (contentType.includes('application/json') || contentType.includes('text/json')) return true
      try {
        const text = (await blob.text()).trim()
        return text.startsWith('{') || text.startsWith('[')
      } catch (e) {
        return false
      }
    },
    async downloadProjectLocationsKml() {
      const projectId = this.toPositiveId(this.resolvedProjectId)
      if (!projectId) return false
      if (this.downloadingProjectKml) return false

      this.downloadingProjectKml = true
      try {
        const response = await this.projectsApi.exportProjectLocationsKml(projectId, {
          headerNote: this.getEffectiveKmlHeaderNote(),
        })
        const status = Number(response?.status || 0)
        let { data: blob } = response

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/vnd.google-earth.kml+xml' })
        }

        const maybeJson = status >= 400 || await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(
            new Error(this.projectLocationsKmlErrorMessage(payload, status)),
            { payload, status },
          )
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const filename = this.parseDownloadFilename(contentDisposition, `project-${projectId}.kml`)
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف KML للمشروع بنجاح / Project KML downloaded successfully')
        return true
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const status = Number(error.status || error.response?.status || 0)
        this.$toast?.error?.(this.projectLocationsKmlErrorMessage(payload || {}, status))
        return false
      } finally {
        this.downloadingProjectKml = false
      }
    },
    async downloadCoordinatesJxl() {
      const id = this.projectLocationId
      if (id === null || id === undefined || id === '') return

      this.downloadingJxl = true
      try {
        const response = await this.projectsApi.exportCoordinatesJxl(id)
        const contentType = String(response.headers['content-type'] || '').toLowerCase()
        let { data: blob } = response

        if (contentType.includes('application/json')) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.jxlErrorMessage(payload)), { payload })
        }

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/xml' })
        }

        const cd = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(cd, '') || '').trim()
        const filename = this.jxlFilenameFromSurveyingCode
          || fromHeader
          || `location-${id}.jxl`
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف JXL')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.jxlErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingJxl = false
      }
    },
    sanitizeFilePart(value) {
      return String(value || '')
        .trim()
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '')
        .replace(/\s+/g, '_')
    },
    getExcelFallbackFilename() {
      const ownerNameRaw = this.project?.owners?.[0]?.name || 'owner'
      const pid = this.resolvedProjectId
      const surveyingCodeRaw = this.project?.surveying_code ?? this.surveyingCode ?? `project-${pid}`
      const ownerName = this.sanitizeFilePart(ownerNameRaw) || 'owner'
      const surveyingCode = this.sanitizeFilePart(surveyingCodeRaw) || `project-${pid}`
      return `${ownerName}_${surveyingCode}.xlsx`
    },
    exportExcel(projectLocationId) {
      if (!this.resolvedProjectId) return

      this.$store.dispatch('projects/exportExcel', { projectLocationId })
        .then(response => {
          const responseData = response?.data ?? response
          const blob = responseData instanceof Blob
            ? responseData
            : new Blob([responseData], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          const contentDisposition = response?.headers?.['content-disposition'] || ''
          const filename = this.parseDownloadFilename(contentDisposition, this.getExcelFallbackFilename())

          this.triggerBlobDownload(blob, filename)
        })
        .catch(error => {
          const status = error?.response?.status
          let message = 'Failed to export Excel file'
          if (status === 403) message = "You don't have permission to export this project"
          else if (status === 404) message = 'Project not found'

          this.$swal({
            icon: 'error',
            title: message,
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        })
    },
    async exportProjectJxlHtml() {
      const projectId = this.resolvedProjectId
      if (!Number.isFinite(projectId) || projectId <= 0) return
      if (this.exportingJxlHtml) return

      this.exportingJxlHtml = true
      try {
        const response = await this.projectsApi.exportProjectJxlHtml(projectId)
        const status = response.status
        let { data: blob } = response

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob])
        }

        const maybeJson = status >= 400 || await this.isJsonBlob(blob)
        if (maybeJson) {
          const errorPayload = await this.parseErrorResponseData(blob)
          const msg = (typeof errorPayload?.message === 'string' && errorPayload.message)
            || 'تعذر تصدير HTML من JXL'
          throw Object.assign(new Error(msg), { payload: errorPayload })
        }

        if (!String(blob.type || '').toLowerCase().includes('html')) {
          blob = new Blob([blob], { type: 'text/html' })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const surveyingCode = this.sanitizeFilePart(this.project?.surveying_code ?? this.surveyingCode)
        const filename = fromHeader
          || (surveyingCode ? `${surveyingCode}.html` : `project_${projectId}.html`)
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف HTML')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = (typeof payload?.message === 'string' && payload.message)
          || error.message
          || 'تعذر تصدير HTML من JXL'
        this.$toast?.error?.(msg)
      } finally {
        this.exportingJxlHtml = false
      }
    },
    async exportKml(locationId) {
      const normalizedLocationId = this.toPositiveId(locationId)
      if (!normalizedLocationId) return false

      try {
        const response = await this.$store.dispatch('projects/exportKml', {
          id: normalizedLocationId,
          headerNote: this.getEffectiveKmlHeaderNote(),
        })
        let blob = response?.data ?? response
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/vnd.google-earth.kml+xml' })
        }

        const maybeJson = await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(
            new Error(this.projectLocationKmlErrorMessage(payload, Number(response?.status || 0))),
            { payload, status: Number(response?.status || 0) },
          )
        }

        const contentDisposition = response?.headers?.['content-disposition']
          || response?.headers?.['Content-Disposition']
          || ''
        const filename = this.parseDownloadFilename(contentDisposition, `location_${normalizedLocationId}.kml`)
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('تم تنزيل ملف KML للموقع بنجاح / Location KML downloaded successfully')
        return true
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const status = Number(error.status || error.response?.status || 0)
        const msg = this.projectLocationKmlErrorMessage(payload || {}, status)
        this.$toast?.error?.(msg)
        return false
      }
    },
    async loadShapeSchemasForExport() {
      this.shapeSchemasLoading = true
      try {
        const response = await projectShapeSchemasApi.list()
        this.shapeSchemas = Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : [])
      } catch (error) {
        this.shapeSchemas = []
      } finally {
        this.shapeSchemasLoading = false
      }
    },
    resetDxfExportCheckboxState() {
      this.dxfExportGeometryChecked = createDxfExportCheckedState(DXF_GEOMETRY_OPTIONS)
      this.dxfExportSourceLayersChecked = createDxfExportCheckedState(DXF_LAYER_OPTIONS)
      this.dxfExportGeometrySelectAll = false
      this.dxfExportLayersSelectAll = false
      this.dxfExportIncludeCartouche = true
    },
    resetDxfExportValidation() {
      this.dxfExportValidationError = null
    },
    loadDxfExportPrefsFromStorage() {
      try {
        const raw = localStorage.getItem(this.dxfExportLocalStorageKey)
        if (!raw) return
        const prefs = JSON.parse(raw)
        if (prefs.geometry && typeof prefs.geometry === 'object') {
          DXF_GEOMETRY_OPTIONS.forEach(opt => {
            if (Object.prototype.hasOwnProperty.call(prefs.geometry, opt.value)) {
              this.$set(this.dxfExportGeometryChecked, opt.value, !!prefs.geometry[opt.value])
            }
          })
        }
        if (prefs.layers && typeof prefs.layers === 'object') {
          DXF_LAYER_OPTIONS.forEach(opt => {
            if (Object.prototype.hasOwnProperty.call(prefs.layers, opt.value)) {
              this.$set(this.dxfExportSourceLayersChecked, opt.value, !!prefs.layers[opt.value])
            }
          })
        }
        if (typeof prefs.include_cartouche === 'boolean') {
          this.dxfExportIncludeCartouche = prefs.include_cartouche
        }
        this.syncDxfExportGeometrySelectAll()
        this.syncDxfExportLayersSelectAll()
      } catch (e) {
        // ignore corrupt prefs
      }
    },
    saveDxfExportPrefsToStorage() {
      try {
        const prefs = {
          geometry: { ...this.dxfExportGeometryChecked },
          layers: { ...this.dxfExportSourceLayersChecked },
          include_cartouche: this.dxfExportIncludeCartouche,
        }
        localStorage.setItem(this.dxfExportLocalStorageKey, JSON.stringify(prefs))
      } catch (e) {
        // ignore quota errors
      }
    },
    openDxfExportModal() {
      this.resetDxfExportCheckboxState()
      this.resetDxfExportValidation()
      this.loadDxfExportPrefsFromStorage()
      this.showDxfExportModal = true
    },
    onDxfExportGeometrySelectAllChange(checked) {
      DXF_GEOMETRY_OPTIONS.forEach(opt => {
        this.$set(this.dxfExportGeometryChecked, opt.value, !!checked)
      })
      this.dxfExportValidationError = null
    },
    onDxfExportLayersSelectAllChange(checked) {
      DXF_LAYER_OPTIONS.forEach(opt => {
        this.$set(this.dxfExportSourceLayersChecked, opt.value, !!checked)
      })
      this.dxfExportValidationError = null
    },
    syncDxfExportGeometrySelectAll() {
      this.dxfExportGeometrySelectAll = DXF_GEOMETRY_OPTIONS.every(
        opt => this.dxfExportGeometryChecked[opt.value],
      )
      this.dxfExportValidationError = null
    },
    syncDxfExportLayersSelectAll() {
      this.dxfExportLayersSelectAll = DXF_LAYER_OPTIONS.every(
        opt => this.dxfExportSourceLayersChecked[opt.value],
      )
      this.dxfExportValidationError = null
    },
    buildDxfExportPayload() {
      return {
        geometry_types: this.dxfExportSelectedGeometryTypes,
        source_layers: this.dxfExportSelectedSourceLayers,
        include_cartouche: !!this.dxfExportIncludeCartouche,
      }
    },
    dxfExportErrorMessage(payload) {
      const key = payload?.message
      const errors = payload?.errors && typeof payload.errors === 'object' ? payload.errors : {}
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : Object.values(errors).flat().filter(Boolean).join(' ')

      if (key === 'project_missing_selected_files' && Array.isArray(errors.missing_source_layers)) {
        const labels = errors.missing_source_layers
          .map(layer => DXF_LAYER_LABELS[layer] || layer)
          .join('، ')
        return `المشروع لا يحتوي على: ${labels}`
      }

      const map = {
        no_survey_files_at_all: 'المشروع لا يحتوي على ملفات مسح',
        no_exportable_coordinates: 'لا توجد إحداثيات قابلة للتصدير في الاختيار الحالي',
        project_missing_selected_files: detail || 'المشروع لا يحتوي على الملفات المحددة',
      }

      if (errors.geometry_types?.length) {
        return errors.geometry_types.join(' ')
      }
      if (errors.source_layers?.length) {
        return errors.source_layers.join(' ')
      }

      if (key && map[key]) return map[key]
      if (typeof payload?.message === 'string' && payload.message && payload.success === false) {
        return payload.message
      }
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تصدير ملف DXF'
    },
    async confirmDxfExport() {
      if (this.exportingDxf) return

      if (this.dxfExportSelectedGeometryTypes.length === 0) {
        this.dxfExportValidationError = 'يجب اختيار نوع هندسة واحد على الأقل'
        return
      }
      if (this.dxfExportSelectedSourceLayers.length === 0) {
        this.dxfExportValidationError = 'يجب اختيار مصدر ملف واحد على الأقل'
        return
      }

      this.dxfExportValidationError = null
      const projectId = this.resolvedProjectId
      if (!Number.isFinite(projectId) || projectId <= 0) return

      const payload = this.buildDxfExportPayload()
      this.exportingDxf = true
      try {
        const response = await this.projectsApi.exportProjectDxf(projectId, payload)
        const status = response.status
        let { data: blob } = response

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob])
        }

        const maybeJson = status >= 400 || await this.isJsonBlob(blob)
        if (maybeJson) {
          const errorPayload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.dxfExportErrorMessage(errorPayload)), { payload: errorPayload })
        }

        if (String(blob.type || '').toLowerCase() !== 'application/dxf') {
          blob = new Blob([blob], { type: 'application/dxf' })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const surveyingCode = this.sanitizeFilePart(this.project?.surveying_code ?? this.surveyingCode)
        const filename = fromHeader
          || (surveyingCode ? `${surveyingCode}.dxf` : `project_${projectId}.dxf`)
        this.triggerBlobDownload(blob, filename)
        this.saveDxfExportPrefsToStorage()
        this.showDxfExportModal = false
        this.$toast?.success?.('تم تنزيل ملف DXF')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.dxfExportErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.exportingDxf = false
      }
    },
    openShapeSchemaModal() {
      this.selectedShapeSchemaId = null
      this.type = null
      this.showShapeSchemaModal = true
    },
    confirmShapeZipDownload(event) {
      event.preventDefault()
      this.type = null
      this.showShapeSchemaModal = false
      this.downloadShapeZip(this.selectedShapeSchemaId, this.type)
    },
    async downloadShapeZip(schemaId = null, type = null) {
      const projectId = this.resolvedProjectId
      if (!Number.isFinite(projectId) || projectId <= 0) return

      this.downloadingShapeZip = true
      try {
        const response = await this.projectsApi.downloadProjectShapeZipDivided(projectId, schemaId, type)
        let { data: blob } = response
        if (!(blob instanceof Blob)) {
          blob = new Blob([blob], { type: 'application/zip' })
        }

        const maybeJson = await this.isJsonBlob(blob)
        if (maybeJson) {
          const payload = await this.parseErrorResponseData(blob)
          throw Object.assign(new Error(this.shapeZipErrorMessage(payload)), { payload })
        }

        const contentDisposition = response.headers['content-disposition']
          || response.headers['Content-Disposition']
          || ''
        const fromHeader = (this.parseDownloadFilename(contentDisposition, '') || '').trim()
        const filename = fromHeader || `project_${projectId}_shapefile.zip`
        this.triggerBlobDownload(blob, filename)
        this.$toast?.success?.('Shape ZIP downloaded successfully')
      } catch (error) {
        let payload = error.payload
        if (!payload && error.response?.data) {
          payload = await this.parseErrorResponseData(error.response.data)
        }
        const msg = this.shapeZipErrorMessage(payload || {})
        this.$toast?.error?.(msg)
      } finally {
        this.downloadingShapeZip = false
      }
    },
    async takeMapScreenshot() {
      this.takingScreenshot = true
      try {
        const mapComponent = this.getActiveMapRef()
        const dataUrl = await mapComponent?.takeScreenshot?.()
        if (!dataUrl) throw new Error('Screenshot data is empty')

        const link = document.createElement('a')
        link.href = dataUrl
        link.download = `map-screenshot-${Date.now()}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toast?.success?.('تم حفظ لقطة شاشة الخريطة')
      } catch (error) {
        this.$toast?.error?.('تعذر أخذ لقطة شاشة للخريطة')
      } finally {
        this.takingScreenshot = false
      }
    },
    formatDate(dateString) {
      if (!dateString) return null
      try {
        const date = new Date(dateString)
        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return dateString
      }
    },
    parseCoordScalar(value) {
      if (value == null || value === '') return NaN
      if (typeof value === 'number' && Number.isFinite(value)) return value
      const digitMap = {
        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
      }
      let s = String(value).trim().replace(/[٠-٩]/g, ch => digitMap[ch] || ch)
      s = s.replace(/,/g, '')
      const n = parseFloat(s)
      return Number.isFinite(n) ? n : NaN
    },
    coordLatLngPairFromPoint(c) {
      const lat = this.parseCoordScalar(c.latitude ?? c.lat)
      const lng = this.parseCoordScalar(c.longitude ?? c.lng ?? c.long)
      return [lat, lng]
    },
    normalizeSketchUtmCoordinates(coordinates) {
      if (!Array.isArray(coordinates)) return []
      const points = coordinates
        .map(coord => ({
          utmEast: Number(coord?.utm_east ?? coord?.utm_est),
          utmNorth: Number(coord?.utm_north),
        }))
        .filter(point => Number.isFinite(point.utmEast) && Number.isFinite(point.utmNorth))

      if (points.length < 3) return []

      const deduped = points.filter((point, index) => {
        if (index === 0) return true
        const prev = points[index - 1]
        return point.utmEast !== prev.utmEast || point.utmNorth !== prev.utmNorth
      })

      if (deduped.length > 2) {
        const first = deduped[0]
        const last = deduped[deduped.length - 1]
        if (first.utmEast === last.utmEast && first.utmNorth === last.utmNorth) {
          deduped.pop()
        }
      }

      return deduped.length >= 3 ? deduped : []
    },
    utmDistanceM(a, b) {
      const de = b.utmEast - a.utmEast
      const dn = b.utmNorth - a.utmNorth
      return Math.sqrt(de * de + dn * dn)
    },
    getUtmMeters(point) {
      return { eastM: point.utmEast, northM: point.utmNorth }
    },
    createSketchMeterProjector(allUtmPoints, padX, padY, drawWidth, drawHeight) {
      if (!Array.isArray(allUtmPoints) || !allUtmPoints.length) {
        return {
          projectPoint: () => ({ x: padX, y: padY }),
          svgUnitsPerMeter: 1,
        }
      }

      const meterPoints = allUtmPoints.map(p => this.getUtmMeters(p))

      let minE = Infinity
      let maxE = -Infinity
      let minN = Infinity
      let maxN = -Infinity
      meterPoints.forEach(({ eastM, northM }) => {
        minE = Math.min(minE, eastM)
        maxE = Math.max(maxE, eastM)
        minN = Math.min(minN, northM)
        maxN = Math.max(maxN, northM)
      })

      const rangeE = Math.max(maxE - minE, 1)
      const rangeN = Math.max(maxN - minN, 1)
      const scaleE = drawWidth / rangeE
      const scaleN = drawHeight / rangeN
      const svgUnitsPerMeter = Math.min(scaleE, scaleN)
      const usedWidth = rangeE * svgUnitsPerMeter
      const usedHeight = rangeN * svgUnitsPerMeter
      const offsetX = padX + (drawWidth - usedWidth) / 2
      const offsetY = padY + (drawHeight - usedHeight) / 2

      return {
        svgUnitsPerMeter,
        projectPoint: point => {
          const { eastM, northM } = this.getUtmMeters(point)
          return {
            x: offsetX + (eastM - minE) * svgUnitsPerMeter,
            y: offsetY + (maxN - northM) * svgUnitsPerMeter,
          }
        },
      }
    },
    formatSketchEdgeLengthM(meters) {
      if (!Number.isFinite(meters)) return '—'
      return `${meters.toFixed(2)} م`
    },
    toArabicIndicDigits(num) {
      const digits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
      return String(num)
        .split('')
        .map(ch => {
          const d = parseInt(ch, 10)
          return Number.isNaN(d) ? ch : digits[d]
        })
        .join('')
    },
    async downloadSketchPng() {
      const sketchWrap = this.$refs.siteSketchWrap
      if (!sketchWrap) return

      try {
        const canvas = await html2canvas(sketchWrap, {
          backgroundColor: '#faf8f4',
          scale: Math.max(2, window.devicePixelRatio || 1),
          useCORS: true,
          logging: false,
        })

        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = `site-sketch-${Date.now()}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        this.$toast?.error?.('تعذر تنزيل الرسم التخطيطي')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.import-buttons-container{
  width:7rem;
  border: 1px solid #b9b9b9;
  border-radius: 2px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.25rem;
  .icon-container{
    flex-shrink: 0;
    width: 3.5rem !important;
    .img{
      width:3.5rem !important;
      height:3.5rem !important;
    }
  }
  .buttons-container{
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    align-content: flex-start;
    gap: 0.25rem;
    min-width: 0;
    margin-top:3px;
    .btnSM{
      padding: 0.2rem 0.2rem !important;
    }
  }
}
.coordinate-display-card {
  .geodesia-survey-import-actions {
    gap: 8px;
  }

  .geodesia-survey-import-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .geodesia-survey-existing-file {
    gap: 4px;
    font-size: 12px;
  }

  .geodesia-survey-preview-button {
    min-width: auto;
    line-height: 1;
    color: inherit;
  }

  .geodesia-survey-kml-export-button {
    min-width: auto;
    line-height: 1;
    color: inherit;
  }

  .geodesia-survey-import-button {
    white-space: nowrap;
  }

  .geodesia-polygon-point-select {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #ebe9f1;
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    gap: 0.5rem 1rem;
  }

  .geodesia-polygon-point-item {
    flex: 0 0 auto;
    margin-bottom: 0 !important;
    margin-left:30px;
    white-space: nowrap;
    border: 1px solid #d8d6de;
    border-radius: 6px;
    padding: 0.35rem 0.75rem 0.35rem 0.35rem;
    background: #fff;
    transition: border-color 0.15s ease, background-color 0.15s ease;

    &:has(.custom-control-input:checked) {
      border-color: #7367f0;
      background: rgba(115, 103, 240, 0.08);
    }
  }

  .inline-map-wrapper {
    width: 100%;
    overflow: visible;
    border-radius: 8px;

    @media (max-width: 767.98px) {
      overflow: visible;
      max-width: 100%;
      margin-inline: -0.5rem;
      width: calc(100% + 1rem);
    }
  }

  .map-toolbar-actions {
    width: 100%;
    flex-wrap: nowrap !important;
    overflow-x: auto;
    gap: 0.15rem !important;

    .map-toolbar-btn--icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0.35rem 0.5rem;
      min-width: 2.25rem;
      min-height: 2.25rem;
      margin: 0 !important;

      .feather-icon {
        margin: 0 !important;
      }
    }

    .admin-boundary-badge {
      position: relative;
      display: inline-flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 0.45rem 0.7rem;
      flex: 1 1 auto;
      min-width: 0;
      margin-inline-start: auto;
      overflow-x: auto;
      padding: 0.3rem 0.55rem;
      border-radius: 6px;
      background: rgba(10, 51, 69, 0.05);
      border: 1px solid rgba(10, 51, 69, 0.12);
      font-size: 0.78rem;
      line-height: 1.3;
      white-space: nowrap;
      color: #0a3345;

      &__title {
        color: #6c757d;
        font-weight: 700;
        flex-shrink: 0;
      }

      &__item {
        color: #0a3345;

        &.is-empty {
          color: #8a9399;

          strong {
            font-weight: 500;
          }
        }
      }

      &__loader {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
      }

      &--loading {
        min-height: 2.1rem;
        pointer-events: none;

        &::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 1;
          background: rgba(255, 255, 255, 0.62);
          border-radius: inherit;
        }
      }

      &--selected {
        background: rgba(0, 140, 90, 0.06);
        border-color: rgba(0, 110, 70, 0.2);
      }
    }

    @media (max-width: 767.98px) {
      .map-toolbar-btn--icon {
        min-height: 2.35rem;
      }

      .admin-boundary-badge {
        margin-inline-start: 0.25rem;
      }
    }
  }

  .map-toolbar-actions--popup {
    @media (max-width: 767.98px) {
      justify-content: stretch !important;
    }
  }

  .dxf-export-checkbox-row {
    @media (max-width: 575.98px) {
      flex-direction: column !important;
      align-items: stretch !important;

      ::v-deep .custom-control-inline {
        display: block;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-inline: 0 !important;
        margin-bottom: 0.35rem;
      }
    }
  }

  .coordinate-card {
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 2px solid #e9ecef;

    &.has-coordinates {
      border-color: #28c76f;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
    }
  }

  .coordinate-header {
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
  }

  .coordinate-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.bg-primary-light {
      background-color: rgba(102, 126, 234, 0.1);
    }
    &.bg-success-light {
      background-color: rgba(40, 199, 111, 0.1);
    }
    &.bg-danger-light {
      background-color: rgba(234, 84, 85, 0.1);
    }
    &.bg-warning-light {
      background-color: rgba(255, 193, 7, 0.1);
    }
    &.bg-info-light {
      background-color: rgba(13, 202, 240, 0.1);
    }
  }

  .no-coordinates {
    background: #f8f9fa;
    border-radius: 8px;
  }

  .coordinate-tabs {
    ::v-deep .nav-pills {
      border-bottom: 2px solid #f0f0f0;
      margin-bottom: 16px;

      .nav-link {
        border-radius: 8px 8px 0 0;
        margin-right: 4px;
        font-weight: 500;

        &.active {
          background-color: #667eea;
          color: white;
        }
      }
    }
  }

  .coordinate-section {
    background: #f8f9fa;
    border-radius: 8px;
  }

  .coordinate-grid {
    background: #fafbfc;
    border-radius: 8px;
  }

  .coordinate-group {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;

    &:hover {
      border-color: #667eea;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
    }
  }

  .coordinate-group-header {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 12px;
  }

  .coordinate-item {
    padding: 12px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;

    &:hover {
      background: #f8f9fa;
      border-color: #667eea;
    }
  }

  .coordinate-item-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .coordinate-item-label {
    font-size: 0.75rem;
    color: #6c757d;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
  }

  .coordinate-item-value {
    font-size: 0.95rem;
    color: #2c3e50;
    font-weight: 600;
    margin-top: 4px;

    code {
      background: #f1f3f5;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 0.9rem;
      color: #667eea;
      font-weight: 600;
    }
  }

  .gap-2 {
    gap: 0.5rem;
  }

  .site-sketch-from-coords {
    .coordinate-sketch-wrap {
      position: relative;
      width: 100%;
      margin: 10px;
      min-height: 12rem;
    }

    .site-polygon-sketch-svg {
      width: 100%;
      height: auto;
      min-height: 12rem;
      max-height: 25rem;
      display: block;
    }

    .sketch-edge-length {
      fill: #0a3345;
      font-size: 3.5px;
      font-weight: 700;
      font-family: "Segoe UI", "Tahoma", "Noto Kufi Arabic", sans-serif;
      paint-order: stroke fill;
      stroke: #faf8f4;
      stroke-width: 0.5px;
      direction: ltr;
      unicode-bidi: isolate;
    }

    .sketch-length-guide {
      stroke: #0a3345;
      stroke-width: 0.35px;
      stroke-dasharray: 0.8 0.8;
      opacity: 0.7;
    }

    .sketch-vertex-dot {
      fill: #ffffff;
    }

    .sketch-vertex-index {
      fill: #0a3345;
      font-size: 4.2px;
      font-weight: 800;
      font-family: "Segoe UI", "Tahoma", "Noto Kufi Arabic", sans-serif;
      paint-order: stroke fill;
      stroke: #faf8f4;
      stroke-width: 0.55px;
    }

    .sketch-scale-caption {
      fill: #0a3345;
      font-size: 2.5px;
      font-weight: 600;
      font-family: "Noto Kufi Arabic", "Segoe UI", sans-serif;
      opacity: 0.85;
    }

    .sketch-scale-value {
      fill: #0a3345;
      font-size: 3px;
      font-weight: 700;
      font-family: "Segoe UI", "Tahoma", "Noto Kufi Arabic", sans-serif;
    }
  }

  .compass-rose {
    position: absolute;
    width: 30px;
    height: 40px;
    // border: 1px solid #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: rgba(255, 255, 255, 0.9);
    z-index: 10;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    .compass-n {
      font-weight: 900;
      font-size: 0.6rem;
      color: #c0392b;
    }
    .compass-rose-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      /* Keep compass arrow aligned to North (up). */
      /*transform: rotate(-90deg);
      transform-origin: center center;*/
    }
  }

  .compass-top-left {
    top: 6px;
    right: 6px;
  }
}
.sketch-container {
      align-items: center;
      justify-content: center;
      display: flex;
      .img {
        // width: 90%;
        max-height: 25rem !important;
        display: block;
      }

      &.site-sketch-from-coords {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
      }
    }
</style>

<style lang="scss">
/* Modal is teleported to body — needs unscoped rules */
.dxf-export-modal {
  @media (max-width: 575.98px) {
    .modal-dialog {
      margin: 0.5rem auto;
      max-width: calc(100% - 1rem);
    }

    .dxf-export-modal-footer {
      flex-direction: column-reverse !important;
      align-items: stretch;
      gap: 0.5rem;

      .btn {
        width: 100%;
        margin: 0 !important;
      }
    }
  }
}

.coordinates-map-popup-modal {
  .modal-content {
    display: flex;
    flex-direction: column;
    max-height: 96dvh;
  }

  .modal-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .map-popup-shell {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    height: min(78dvh, 820px);
  }

  .map-popup-shell__map {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .map-popup-shell__map .coordinates-map-wrapper,
  .map-popup-shell__map .coordinates-map-wrapper--popup,
  .map-popup-shell__map .map-container-wrapper {
    flex: 1;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .map-popup-shell__map .coordinates-arcgis-map,
  .map-popup-shell__map .coordinates-google-map {
    flex: 1 !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  .map-toolbar-actions--popup {
    flex-shrink: 0;
    flex-wrap: wrap !important;
    overflow: visible;
    gap: 0.35rem !important;
    margin-top: 0.45rem !important;
    padding-top: 0.4rem;
    border-top: 1px solid rgba(10, 51, 69, 0.1);
  }

  .map-toolbar-btn--icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.35rem 0.5rem;
    min-width: 2.35rem;
    min-height: 2.35rem;
    margin: 0 !important;
  }

  .admin-boundary-badge {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0.45rem 0.7rem;
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.35rem 0.55rem;
    border-radius: 6px;
    background: rgba(10, 51, 69, 0.05);
    border: 1px solid rgba(10, 51, 69, 0.12);
    font-size: 0.78rem;
    line-height: 1.3;
    white-space: nowrap;
    color: #0a3345;
  }

  .admin-boundary-badge__title {
    color: #6c757d;
    font-weight: 700;
    flex-shrink: 0;
  }

  .admin-boundary-badge__item.is-empty {
    color: #8a9399;
  }

  .admin-boundary-badge__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
  }

  .admin-boundary-badge--loading {
    min-height: 2.1rem;
    pointer-events: none;
  }

  .admin-boundary-badge--loading::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: rgba(255, 255, 255, 0.62);
    border-radius: inherit;
  }

  @media (max-width: 767.98px) {
    .modal-dialog {
      margin: 0;
      width: 100%;
      max-width: 100%;
      min-height: 100dvh;
      height: 100dvh;
    }

    .modal-content {
      min-height: 100dvh;
      height: 100dvh;
      max-height: 100dvh;
      border-radius: 0;
    }

    .modal-header {
      flex-shrink: 0;
      padding: 0.5rem 0.65rem;
    }

    .modal-body {
      padding: 0.35rem 0.35rem 0;
      overflow: hidden;
    }

    .modal-body .coordinates-map-wrapper {
      overflow: visible;
    }

    .map-toolbar-actions--popup {
      margin-top: 0.35rem !important;
      padding: 0.4rem 0.15rem calc(0.55rem + env(safe-area-inset-bottom, 0px));
    }

    .map-toolbar-btn--icon {
      min-height: 2.6rem;
    }

    .admin-boundary-badge {
      font-size: 0.72rem;
    }

    .map-popup-shell {
      height: auto;
      flex: 1;
    }

    .map-toolbar-host {
      flex-shrink: 0;
    }
  }
}

.map-toolbar-host {
  width: 100%;
}

.map-toolbar-fullscreen-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.15rem;
  height: 2.15rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(10, 51, 69, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.86);
  color: #0a3345;
  cursor: pointer;
}

.map-toolbar-actions--fullscreen .map-toolbar-fullscreen-toggle {
  display: inline-flex;
}

.map-toolbar-actions--fullscreen {
  position: absolute !important;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000001;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center;
  gap: 0.35rem !important;
  width: 100%;
  max-width: 100%;
  margin: 0 !important;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.45rem 0.55rem calc(0.55rem + env(safe-area-inset-bottom, 0px)) !important;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 0;
  box-shadow: none;
}

.map-toolbar-actions--fullscreen.is-collapsed {
  display: none !important;
}

.map-toolbar-show-fab {
  position: absolute;
  left: 50%;
  bottom: calc(0.7rem + env(safe-area-inset-bottom, 0px));
  z-index: 2000007;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 2.35rem;
  padding: 0.35rem 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  background: rgba(10, 51, 69, 0.92);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1;
  transform: translateX(-50%);
  box-shadow: 0 8px 24px rgba(10, 51, 69, 0.28);
  cursor: pointer;
  pointer-events: auto;
}

.map-toolbar-actions--fullscreen .admin-boundary-badge {
  flex: 1 1 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(10, 51, 69, 0.08);
}

.map-fullscreen-root {
  position: relative;
  isolation: isolate;
  overflow: visible;
}

.inline-map-wrapper.map-fullscreen-root {
  overflow: visible;
}

.map-survey-dock-host {
  position: absolute;
  /*! rtl:begin:ignore */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*! rtl:end:ignore */
  z-index: 1000000;
  pointer-events: none;
}

.map-fullscreen-survey-float {
  display: none;
  top: auto;
  /*! rtl:begin:ignore */
  left: 50%;
  right: auto;
  /*! rtl:end:ignore */
  bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  z-index: 1000000;
  width: auto;
  max-width: calc(100% - 0.7rem);
  overflow: visible;
  pointer-events: auto;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.42);
  box-shadow: 0 8px 24px rgba(10, 51, 69, 0.16);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.map-fullscreen-root:fullscreen .map-fullscreen-survey-float {
  display: flex !important;
  bottom: calc(5.65rem + env(safe-area-inset-bottom, 0px));
}

.map-fullscreen-root:-webkit-full-screen .map-fullscreen-survey-float {
  display: flex !important;
  bottom: calc(5.65rem + env(safe-area-inset-bottom, 0px));
}

.map-fullscreen-survey-float.is-fullscreen-visible {
  display: flex !important;
  bottom: calc(5.65rem + env(safe-area-inset-bottom, 0px));
}

@media (min-width: 768px) {
  .map-fullscreen-root:fullscreen .map-fullscreen-survey-float,
  .map-fullscreen-root:-webkit-full-screen .map-fullscreen-survey-float,
  .map-fullscreen-survey-float.is-fullscreen-visible {
    top: max(0.75rem, env(safe-area-inset-top, 0px));
    bottom: auto;
    max-width: min(calc(100% - 12.5rem), 36rem);
  }
}

.map-project-locations-stack {
  position: absolute;
  /*! rtl:begin:ignore */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*! rtl:end:ignore */
  z-index: 45;
  width: 100%;
  height: 100%;
  max-height: none;
  pointer-events: none;
}

.map-project-locations-panel,
.map-draw-actions-panel {
  width: min(8.4rem, calc(42% - 1.4rem));
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.38);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.42);
  box-shadow: 0 8px 24px rgba(10, 51, 69, 0.12);
}

.map-project-locations-panel {
  /*! rtl:begin:ignore */
  left: 0.5rem;
  right: auto;
  /*! rtl:end:ignore */
  top: 17.5rem;
  height: auto;
  max-height: min(50vh, 50%);
}

.map-draw-actions-panel {
  /*! rtl:begin:ignore */
  left: calc(0.5rem + min(8.4rem, calc(42% - 1.4rem)) + 0.45rem);
  right: auto;
  /*! rtl:end:ignore */
  top: 17.5rem;
  bottom: auto;
  max-height: min(42vh, 14rem);
}

.map-project-locations-panel__item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 0.28rem;
  padding: 0.38rem 0.42rem;
  border: 1px solid rgba(10, 51, 69, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.42);
  color: #0a3345;
  text-align: start;
  cursor: pointer;
}

.map-project-locations-panel__item.is-active {
  border-color: rgba(37, 99, 235, 0.45);
  background: rgba(37, 99, 235, 0.16);
}

.map-project-locations-panel__item-title {
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.25;
}

.map-project-locations-panel__item-meta,
.map-project-locations-panel__empty {
  font-size: 0.68rem;
  color: rgba(10, 51, 69, 0.72);
  line-height: 1.3;
}

.map-project-locations-panel__empty {
  margin: 0.4rem 0.2rem;
}

.map-location-action {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: rgba(8, 24, 36, 0.18);
}

.map-location-action__card {
  width: min(100%, 10.4rem);
  padding: 0.55rem 0.55rem 0.45rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 24px rgba(10, 51, 69, 0.16);
}

.map-location-action__title {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 700;
  color: #0a3345;
}

.map-location-action__hint {
  margin: 0.15rem 0 0.4rem;
  font-size: 0.7rem;
  color: rgba(10, 51, 69, 0.7);
}

.map-location-action__btn {
  display: block;
  width: 100%;
  margin-bottom: 0.28rem;
  padding: 0.32rem 0.4rem;
  border: 1px solid rgba(10, 51, 69, 0.14);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.62);
  color: #0a3345;
  font-size: 0.76rem;
  font-weight: 600;
  cursor: pointer;
}

.map-location-action__btn--polygon {
  background: rgba(37, 99, 235, 0.16);
  border-color: rgba(37, 99, 235, 0.28);
}

.map-location-action__btn--ghost {
  background: transparent;
  margin-bottom: 0;
  font-weight: 500;
  color: rgba(10, 51, 69, 0.7);
}

@media (max-width: 1199.98px) {
  .map-project-locations-panel,
  .map-draw-actions-panel {
    width: min(6rem, calc(34% - 1.1rem));
  }

  .map-project-locations-panel {
    top: 15.5rem;
  }

  .map-draw-actions-panel {
    top: 15.5rem;
    /*! rtl:begin:ignore */
    left: calc(0.5rem + min(6rem, calc(34% - 1.1rem)) + 0.4rem);
    right: auto;
    /*! rtl:end:ignore */
  }
}

@media (max-width: 767.98px) {
  .map-project-locations-panel,
  .map-draw-actions-panel {
    width: min(5.6rem, calc(40% - 0.9rem));
    /*! rtl:begin:ignore */
    left: 0.45rem;
    right: auto;
    /*! rtl:end:ignore */
  }

  .map-project-locations-panel {
    top: 12.5rem;
  }

  .map-draw-actions-panel {
    top: auto;
    bottom: 0.75rem;
  }

  /* The ArcGIS edit toolbar occupies the bottom 84px on phones. */
  .map-fullscreen-root--arcgis .map-fullscreen-survey-float:not(.is-fullscreen-visible),
  .map-fullscreen-root--arcgis .map-draw-actions-panel {
    bottom: calc(84px + env(safe-area-inset-bottom, 0px));
  }
}

.map-engine {
  background: #0b1f2a;
}

.map-engine--hidden {
  position: absolute !important;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden !important;
  pointer-events: none !important;
  z-index: 0 !important;
}

.map-engine--hidden:not(.map-engine--initializing) {
  visibility: hidden !important;
  opacity: 0 !important;
  clip-path: inset(0 0 100% 0);
}

.map-engine--hidden:not(.map-engine--initializing) canvas,
.map-engine--hidden:not(.map-engine--initializing) .gm-style,
.map-engine--hidden:not(.map-engine--initializing) .esri-view,
.map-engine--hidden:not(.map-engine--initializing) .esri-view-surface {
  visibility: hidden !important;
  pointer-events: none !important;
}

.map-engine--hidden.map-engine--initializing {
  visibility: visible;
  opacity: 1;
  clip-path: none;
  z-index: 1;
}

.map-engine--active {
  position: relative;
  z-index: 2;
  width: 100%;
  visibility: visible;
  opacity: 1;
  clip-path: none;
  background: #0b1f2a;
}

.map-engine-switch-loader {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background: rgba(8, 28, 40, 0.42);
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  text-align: center;
  pointer-events: all;
}

.map-fullscreen-root:fullscreen .map-engine-switch-loader,
.map-fullscreen-root:-webkit-full-screen .map-engine-switch-loader {
  border-radius: 0;
  z-index: 1000002;
}

.map-engine-switch-inline-spinner {
  margin-right: 0.35rem;
  vertical-align: middle;
}

.map-fullscreen-notice {
  display: none;
  position: absolute;
  top: auto;
  bottom: calc(8.55rem + env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000005;
  width: min(calc(100% - 1rem), 28rem);
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
  box-shadow: 0 8px 24px rgba(10, 51, 69, 0.22);
  pointer-events: none;
}

.map-fullscreen-root:fullscreen .map-fullscreen-notice,
.map-fullscreen-root:-webkit-full-screen .map-fullscreen-notice {
  display: block;
}

.map-fullscreen-notice--error {
  background: rgba(220, 53, 69, 0.94);
  color: #fff;
}

.map-fullscreen-notice--warning {
  background: rgba(245, 158, 11, 0.95);
  color: #1f2937;
}

.map-fullscreen-notice--success {
  background: rgba(16, 185, 129, 0.94);
  color: #fff;
}

.map-fullscreen-notice--info {
  background: rgba(37, 99, 235, 0.94);
  color: #fff;
}

.map-fullscreen-root:fullscreen .Vue-Toastification__container,
.map-fullscreen-root:-webkit-full-screen .Vue-Toastification__container {
  z-index: 2000006 !important;
  position: fixed !important;
  top: auto !important;
  bottom: calc(8.55rem + env(safe-area-inset-bottom, 0px)) !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%);
  width: min(calc(100% - 1rem), 28rem);
  pointer-events: none;
}

.map-fullscreen-root:fullscreen .Vue-Toastification__toast,
.map-fullscreen-root:-webkit-full-screen .Vue-Toastification__toast {
  max-width: 100%;
  pointer-events: auto;
}

@media (min-width: 768px) {
  .map-fullscreen-notice,
  .map-fullscreen-root:fullscreen .Vue-Toastification__container,
  .map-fullscreen-root:-webkit-full-screen .Vue-Toastification__container {
    top: calc(max(0.75rem, env(safe-area-inset-top, 0px)) + 4.15rem);
    bottom: auto !important;
  }
}

.map-fullscreen-root:fullscreen,
.map-fullscreen-root:-webkit-full-screen {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.map-fullscreen-root:fullscreen .map-engine--active,
.map-fullscreen-root:-webkit-full-screen .map-engine--active,
.map-fullscreen-root:fullscreen .map-engine--hidden,
.map-fullscreen-root:-webkit-full-screen .map-engine--hidden,
.map-fullscreen-root:fullscreen .coordinates-map-wrapper,
.map-fullscreen-root:-webkit-full-screen .coordinates-map-wrapper,
.map-fullscreen-root:fullscreen .map-container-wrapper,
.map-fullscreen-root:-webkit-full-screen .map-container-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.map-fullscreen-root:fullscreen .map-engine--hidden,
.map-fullscreen-root:-webkit-full-screen .map-engine--hidden {
  position: absolute !important;
  inset: 0;
  flex: none;
}

.map-fullscreen-root:fullscreen .map-engine--hidden:not(.map-engine--initializing),
.map-fullscreen-root:-webkit-full-screen .map-engine--hidden:not(.map-engine--initializing) {
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  z-index: 0 !important;
  clip-path: inset(0 0 100% 0);
}

.map-fullscreen-root:fullscreen .coordinates-google-map,
.map-fullscreen-root:-webkit-full-screen .coordinates-google-map,
.map-fullscreen-root:fullscreen .coordinates-arcgis-map,
.map-fullscreen-root:-webkit-full-screen .coordinates-arcgis-map {
  flex: 1 !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: none !important;
  aspect-ratio: auto;
  border-radius: 0;
}

:fullscreen > .modal-backdrop,
:-webkit-full-screen > .modal-backdrop {
  z-index: 100000 !important;
}

:fullscreen > .modal,
:-webkit-full-screen > .modal,
:fullscreen > #geodesia-sheet-import-modal,
:-webkit-full-screen > #geodesia-sheet-import-modal {
  z-index: 100001 !important;
}

.coordinates-survey-import-modal {
  .modal-dialog {
    max-width: min(92vw, 56rem);
    margin: 0.75rem auto;
  }
}
</style>
